import {
  InfiniteData,
  UseInfiniteQueryOptions,
  UseQueryOptions,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
export type Maybe<T> = T;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(
  client: GraphQLClient,
  query: string,
  variables?: TVariables,
  requestHeaders?: RequestInit['headers'],
) {
  return async (): Promise<TData> =>
    client.request({
      document: query,
      variables,
      requestHeaders,
    });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
  Long: { input: any; output: any };
  NewsItemContentDynamicZoneInput: { input: any; output: any };
  PostContentDynamicZoneInput: { input: any; output: any };
  PricingPageFaqDynamicZoneInput: { input: any; output: any };
};

export type Announcement = {
  __typename?: 'Announcement';
  action_link?: Maybe<Scalars['String']['output']>;
  action_title?: Maybe<Scalars['String']['output']>;
  applications: Array<Maybe<Application>>;
  applications_connection?: Maybe<ApplicationRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Enum_Announcement_Level>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementApplicationsArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnnouncementApplications_ConnectionArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnnouncementEntityResponseCollection = {
  __typename?: 'AnnouncementEntityResponseCollection';
  nodes: Array<Announcement>;
  pageInfo: Pagination;
};

export type AnnouncementFiltersInput = {
  action_link?: InputMaybe<StringFilterInput>;
  action_title?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<AnnouncementFiltersInput>>>;
  applications?: InputMaybe<ApplicationFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  expiration_date?: InputMaybe<DateTimeFilterInput>;
  level?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AnnouncementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AnnouncementFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AnnouncementInput = {
  action_link?: InputMaybe<Scalars['String']['input']>;
  action_title?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Enum_Announcement_Level>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Application = {
  __typename?: 'Application';
  announcement?: Maybe<Announcement>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentVersion: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  logo?: Maybe<UploadFile>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updateRequired: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicationEntityResponseCollection = {
  __typename?: 'ApplicationEntityResponseCollection';
  nodes: Array<Application>;
  pageInfo: Pagination;
};

export type ApplicationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ApplicationFiltersInput>>>;
  announcement?: InputMaybe<AnnouncementFiltersInput>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  currentVersion?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ApplicationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ApplicationFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updateRequired?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ApplicationInput = {
  announcement?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updateRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationRelationResponseCollection = {
  __typename?: 'ApplicationRelationResponseCollection';
  nodes: Array<Application>;
};

export type Boat = {
  __typename?: 'Boat';
  activities: Array<Maybe<BoatsActivity>>;
  activities_connection?: Maybe<BoatsActivityRelationResponseCollection>;
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  ballast_displacement?: Maybe<Scalars['Float']['output']>;
  ballast_type?: Maybe<Scalars['String']['output']>;
  ballast_weight?: Maybe<Scalars['Float']['output']>;
  bcl?: Maybe<Scalars['Float']['output']>;
  bdcl?: Maybe<Scalars['Float']['output']>;
  berths?: Maybe<Scalars['Int']['output']>;
  bh?: Maybe<Scalars['Float']['output']>;
  boa?: Maybe<Scalars['Float']['output']>;
  boatDocuments: Array<Maybe<UploadFile>>;
  boatDocuments_connection?: Maybe<UploadFileRelationResponseCollection>;
  boat_designers: Array<Maybe<BoatDesigner>>;
  boat_designers_connection?: Maybe<BoatDesignerRelationResponseCollection>;
  boat_exterior_designers: Array<Maybe<BoatDesigner>>;
  boat_exterior_designers_connection?: Maybe<BoatDesignerRelationResponseCollection>;
  boat_interior_designers: Array<Maybe<BoatDesigner>>;
  boat_interior_designers_connection?: Maybe<BoatDesignerRelationResponseCollection>;
  cabins?: Maybe<Scalars['Int']['output']>;
  categories: Array<Maybe<BoatsCategory>>;
  categories_connection?: Maybe<BoatsCategoryRelationResponseCollection>;
  ce_classification?: Maybe<ComponentBoatsCeClassification>;
  cockpit_location?: Maybe<Scalars['String']['output']>;
  cockpit_type?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cruising_speed?: Maybe<Scalars['Float']['output']>;
  csf?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displacement?: Maybe<Scalars['Float']['output']>;
  displacement_hull_speed?: Maybe<Scalars['Float']['output']>;
  displacement_length?: Maybe<Scalars['Float']['output']>;
  documentId: Scalars['ID']['output'];
  documents?: Maybe<Array<Maybe<ComponentBoatsDocuments>>>;
  downwind_sail_area?: Maybe<Scalars['Float']['output']>;
  downwind_sail_area_displacement?: Maybe<Scalars['Float']['output']>;
  draft_max?: Maybe<Scalars['Float']['output']>;
  draft_min?: Maybe<Scalars['Float']['output']>;
  enable_description: Scalars['Boolean']['output'];
  engine?: Maybe<Array<Maybe<ComponentBoatsEngine>>>;
  favorites_count?: Maybe<Scalars['Int']['output']>;
  files: Array<Maybe<UploadFile>>;
  files_connection?: Maybe<UploadFileRelationResponseCollection>;
  fuel_tank?: Maybe<Array<Maybe<ComponentBoatsTank>>>;
  headroom?: Maybe<Scalars['Float']['output']>;
  heads?: Maybe<Scalars['Int']['output']>;
  headsail?: Maybe<Array<Maybe<ComponentBoatsNameValue>>>;
  helm?: Maybe<Scalars['String']['output']>;
  holding_tank?: Maybe<Array<Maybe<ComponentBoatsTank>>>;
  hull_appendages?: Maybe<Array<Maybe<ComponentBoatsNameValue>>>;
  hull_material?: Maybe<BoatsHullMaterial>;
  hull_type?: Maybe<BoatsHullType>;
  image?: Maybe<UploadFile>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  keel_type?: Maybe<Enum_Boat_Keel_Type>;
  ksi?: Maybe<Scalars['Float']['output']>;
  loa?: Maybe<Scalars['Float']['output']>;
  lumen_ref_id?: Maybe<Scalars['Long']['output']>;
  lumen_ref_user_id?: Maybe<Scalars['Long']['output']>;
  lwl?: Maybe<Scalars['Float']['output']>;
  mainsail?: Maybe<Array<Maybe<ComponentBoatsNameValue>>>;
  manufacturer?: Maybe<Manufacturer>;
  mast?: Maybe<Scalars['Float']['output']>;
  mast_configuration?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nom?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reference_price?: Maybe<ComponentBoatsPrice>;
  rigging?: Maybe<Enum_Boat_Rigging>;
  rotating_spars?: Maybe<Scalars['Boolean']['output']>;
  rudder?: Maybe<Scalars['String']['output']>;
  sail_area_displacement?: Maybe<Scalars['Float']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug?: Maybe<Scalars['String']['output']>;
  spars?: Maybe<Scalars['String']['output']>;
  spinnaker?: Maybe<Array<Maybe<ComponentBoatsNameValue>>>;
  spreaders_angle?: Maybe<Scalars['String']['output']>;
  spreaders_level?: Maybe<Scalars['Int']['output']>;
  sspd?: Maybe<Scalars['Float']['output']>;
  standing_rigging?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  tonnage_gross?: Maybe<Scalars['Float']['output']>;
  tonnage_net?: Maybe<Scalars['Float']['output']>;
  top_speed?: Maybe<Scalars['Float']['output']>;
  trailerable?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<BoatsType>;
  unique_views_count?: Maybe<Scalars['Int']['output']>;
  unit: Enum_Boat_Unit;
  unsinkable?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upwind_sail_area?: Maybe<Scalars['Float']['output']>;
  upwind_sail_area_displacement?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  views_count?: Maybe<Scalars['Int']['output']>;
  water_heater?: Maybe<Array<Maybe<ComponentBoatsTank>>>;
  water_tank?: Maybe<Array<Maybe<ComponentBoatsTank>>>;
  year_first?: Maybe<Scalars['Int']['output']>;
  year_last?: Maybe<Scalars['Int']['output']>;
};

export type BoatActivitiesArgs = {
  filters?: InputMaybe<BoatsActivityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatActivities_ConnectionArgs = {
  filters?: InputMaybe<BoatsActivityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoatDocumentsArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoatDocuments_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoat_DesignersArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoat_Designers_ConnectionArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoat_Exterior_DesignersArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoat_Exterior_Designers_ConnectionArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoat_Interior_DesignersArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatBoat_Interior_Designers_ConnectionArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatCategoriesArgs = {
  filters?: InputMaybe<BoatsCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatCategories_ConnectionArgs = {
  filters?: InputMaybe<BoatsCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatDocumentsArgs = {
  filters?: InputMaybe<ComponentBoatsDocumentsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatEngineArgs = {
  filters?: InputMaybe<ComponentBoatsEngineFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatFuel_TankArgs = {
  filters?: InputMaybe<ComponentBoatsTankFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatHeadsailArgs = {
  filters?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatHolding_TankArgs = {
  filters?: InputMaybe<ComponentBoatsTankFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatHull_AppendagesArgs = {
  filters?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatMainsailArgs = {
  filters?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatSpinnakerArgs = {
  filters?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatWater_HeaterArgs = {
  filters?: InputMaybe<ComponentBoatsTankFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatWater_TankArgs = {
  filters?: InputMaybe<ComponentBoatsTankFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BoatDesigner = {
  __typename?: 'BoatDesigner';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BoatDesignerEntityResponseCollection = {
  __typename?: 'BoatDesignerEntityResponseCollection';
  nodes: Array<BoatDesigner>;
  pageInfo: Pagination;
};

export type BoatDesignerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BoatDesignerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BoatDesignerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BoatDesignerFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type BoatDesignerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BoatDesignerRelationResponseCollection = {
  __typename?: 'BoatDesignerRelationResponseCollection';
  nodes: Array<BoatDesigner>;
};

export type BoatEntityResponseCollection = {
  __typename?: 'BoatEntityResponseCollection';
  nodes: Array<Boat>;
  pageInfo: Pagination;
};

export type BoatFiltersInput = {
  activities?: InputMaybe<BoatsActivityFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BoatFiltersInput>>>;
  approved_at?: InputMaybe<DateTimeFilterInput>;
  ballast_displacement?: InputMaybe<FloatFilterInput>;
  ballast_type?: InputMaybe<StringFilterInput>;
  ballast_weight?: InputMaybe<FloatFilterInput>;
  bcl?: InputMaybe<FloatFilterInput>;
  bdcl?: InputMaybe<FloatFilterInput>;
  berths?: InputMaybe<IntFilterInput>;
  bh?: InputMaybe<FloatFilterInput>;
  boa?: InputMaybe<FloatFilterInput>;
  boat_designers?: InputMaybe<BoatDesignerFiltersInput>;
  boat_exterior_designers?: InputMaybe<BoatDesignerFiltersInput>;
  boat_interior_designers?: InputMaybe<BoatDesignerFiltersInput>;
  cabins?: InputMaybe<IntFilterInput>;
  categories?: InputMaybe<BoatsCategoryFiltersInput>;
  ce_classification?: InputMaybe<ComponentBoatsCeClassificationFiltersInput>;
  cockpit_location?: InputMaybe<StringFilterInput>;
  cockpit_type?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cruising_speed?: InputMaybe<FloatFilterInput>;
  csf?: InputMaybe<FloatFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  displacement?: InputMaybe<FloatFilterInput>;
  displacement_hull_speed?: InputMaybe<FloatFilterInput>;
  displacement_length?: InputMaybe<FloatFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  documents?: InputMaybe<ComponentBoatsDocumentsFiltersInput>;
  downwind_sail_area?: InputMaybe<FloatFilterInput>;
  downwind_sail_area_displacement?: InputMaybe<FloatFilterInput>;
  draft_max?: InputMaybe<FloatFilterInput>;
  draft_min?: InputMaybe<FloatFilterInput>;
  enable_description?: InputMaybe<BooleanFilterInput>;
  engine?: InputMaybe<ComponentBoatsEngineFiltersInput>;
  favorites_count?: InputMaybe<IntFilterInput>;
  fuel_tank?: InputMaybe<ComponentBoatsTankFiltersInput>;
  headroom?: InputMaybe<FloatFilterInput>;
  heads?: InputMaybe<IntFilterInput>;
  headsail?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  helm?: InputMaybe<StringFilterInput>;
  holding_tank?: InputMaybe<ComponentBoatsTankFiltersInput>;
  hull_appendages?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  hull_material?: InputMaybe<BoatsHullMaterialFiltersInput>;
  hull_type?: InputMaybe<BoatsHullTypeFiltersInput>;
  is_featured?: InputMaybe<BooleanFilterInput>;
  keel_type?: InputMaybe<StringFilterInput>;
  ksi?: InputMaybe<FloatFilterInput>;
  loa?: InputMaybe<FloatFilterInput>;
  lumen_ref_id?: InputMaybe<LongFilterInput>;
  lumen_ref_user_id?: InputMaybe<LongFilterInput>;
  lwl?: InputMaybe<FloatFilterInput>;
  mainsail?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  manufacturer?: InputMaybe<ManufacturerFiltersInput>;
  mast?: InputMaybe<FloatFilterInput>;
  mast_configuration?: InputMaybe<StringFilterInput>;
  model?: InputMaybe<StringFilterInput>;
  nom?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<BoatFiltersInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<BoatFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reference_price?: InputMaybe<ComponentBoatsPriceFiltersInput>;
  rigging?: InputMaybe<StringFilterInput>;
  rotating_spars?: InputMaybe<BooleanFilterInput>;
  rudder?: InputMaybe<StringFilterInput>;
  sail_area_displacement?: InputMaybe<FloatFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  spars?: InputMaybe<StringFilterInput>;
  spinnaker?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  spreaders_angle?: InputMaybe<StringFilterInput>;
  spreaders_level?: InputMaybe<IntFilterInput>;
  sspd?: InputMaybe<FloatFilterInput>;
  standing_rigging?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<BooleanFilterInput>;
  tonnage_gross?: InputMaybe<FloatFilterInput>;
  tonnage_net?: InputMaybe<FloatFilterInput>;
  top_speed?: InputMaybe<FloatFilterInput>;
  trailerable?: InputMaybe<BooleanFilterInput>;
  type?: InputMaybe<BoatsTypeFiltersInput>;
  unique_views_count?: InputMaybe<IntFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
  unsinkable?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  upwind_sail_area?: InputMaybe<FloatFilterInput>;
  upwind_sail_area_displacement?: InputMaybe<FloatFilterInput>;
  version?: InputMaybe<StringFilterInput>;
  views_count?: InputMaybe<IntFilterInput>;
  water_heater?: InputMaybe<ComponentBoatsTankFiltersInput>;
  water_tank?: InputMaybe<ComponentBoatsTankFiltersInput>;
  year_first?: InputMaybe<IntFilterInput>;
  year_last?: InputMaybe<IntFilterInput>;
};

export type BoatInput = {
  activities?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  approved_at?: InputMaybe<Scalars['DateTime']['input']>;
  ballast_displacement?: InputMaybe<Scalars['Float']['input']>;
  ballast_type?: InputMaybe<Scalars['String']['input']>;
  ballast_weight?: InputMaybe<Scalars['Float']['input']>;
  bcl?: InputMaybe<Scalars['Float']['input']>;
  bdcl?: InputMaybe<Scalars['Float']['input']>;
  berths?: InputMaybe<Scalars['Int']['input']>;
  bh?: InputMaybe<Scalars['Float']['input']>;
  boa?: InputMaybe<Scalars['Float']['input']>;
  boatDocuments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  boat_designers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  boat_exterior_designers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  boat_interior_designers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cabins?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ce_classification?: InputMaybe<ComponentBoatsCeClassificationInput>;
  cockpit_location?: InputMaybe<Scalars['String']['input']>;
  cockpit_type?: InputMaybe<Scalars['String']['input']>;
  cruising_speed?: InputMaybe<Scalars['Float']['input']>;
  csf?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  displacement_hull_speed?: InputMaybe<Scalars['Float']['input']>;
  displacement_length?: InputMaybe<Scalars['Float']['input']>;
  documents?: InputMaybe<Array<InputMaybe<ComponentBoatsDocumentsInput>>>;
  downwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  downwind_sail_area_displacement?: InputMaybe<Scalars['Float']['input']>;
  draft_max?: InputMaybe<Scalars['Float']['input']>;
  draft_min?: InputMaybe<Scalars['Float']['input']>;
  enable_description?: InputMaybe<Scalars['Boolean']['input']>;
  engine?: InputMaybe<Array<InputMaybe<ComponentBoatsEngineInput>>>;
  favorites_count?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fuel_tank?: InputMaybe<Array<InputMaybe<ComponentBoatsTankInput>>>;
  headroom?: InputMaybe<Scalars['Float']['input']>;
  heads?: InputMaybe<Scalars['Int']['input']>;
  headsail?: InputMaybe<Array<InputMaybe<ComponentBoatsNameValueInput>>>;
  helm?: InputMaybe<Scalars['String']['input']>;
  holding_tank?: InputMaybe<Array<InputMaybe<ComponentBoatsTankInput>>>;
  hull_appendages?: InputMaybe<Array<InputMaybe<ComponentBoatsNameValueInput>>>;
  hull_material?: InputMaybe<Scalars['ID']['input']>;
  hull_type?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  is_featured?: InputMaybe<Scalars['Boolean']['input']>;
  keel_type?: InputMaybe<Enum_Boat_Keel_Type>;
  ksi?: InputMaybe<Scalars['Float']['input']>;
  loa?: InputMaybe<Scalars['Float']['input']>;
  lumen_ref_id?: InputMaybe<Scalars['Long']['input']>;
  lumen_ref_user_id?: InputMaybe<Scalars['Long']['input']>;
  lwl?: InputMaybe<Scalars['Float']['input']>;
  mainsail?: InputMaybe<Array<InputMaybe<ComponentBoatsNameValueInput>>>;
  manufacturer?: InputMaybe<Scalars['ID']['input']>;
  mast?: InputMaybe<Scalars['Float']['input']>;
  mast_configuration?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  nom?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reference_price?: InputMaybe<ComponentBoatsPriceInput>;
  rigging?: InputMaybe<Enum_Boat_Rigging>;
  rotating_spars?: InputMaybe<Scalars['Boolean']['input']>;
  rudder?: InputMaybe<Scalars['String']['input']>;
  sail_area_displacement?: InputMaybe<Scalars['Float']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spars?: InputMaybe<Scalars['String']['input']>;
  spinnaker?: InputMaybe<Array<InputMaybe<ComponentBoatsNameValueInput>>>;
  spreaders_angle?: InputMaybe<Scalars['String']['input']>;
  spreaders_level?: InputMaybe<Scalars['Int']['input']>;
  sspd?: InputMaybe<Scalars['Float']['input']>;
  standing_rigging?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tonnage_gross?: InputMaybe<Scalars['Float']['input']>;
  tonnage_net?: InputMaybe<Scalars['Float']['input']>;
  top_speed?: InputMaybe<Scalars['Float']['input']>;
  trailerable?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
  unique_views_count?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Enum_Boat_Unit>;
  unsinkable?: InputMaybe<Scalars['Boolean']['input']>;
  upwind_sail_area?: InputMaybe<Scalars['Float']['input']>;
  upwind_sail_area_displacement?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  views_count?: InputMaybe<Scalars['Int']['input']>;
  water_heater?: InputMaybe<Array<InputMaybe<ComponentBoatsTankInput>>>;
  water_tank?: InputMaybe<Array<InputMaybe<ComponentBoatsTankInput>>>;
  year_first?: InputMaybe<Scalars['Int']['input']>;
  year_last?: InputMaybe<Scalars['Int']['input']>;
};

export type BoatRelationResponseCollection = {
  __typename?: 'BoatRelationResponseCollection';
  nodes: Array<Boat>;
};

export type BoatsActivity = {
  __typename?: 'BoatsActivity';
  coverImage?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  lumen_ref_id?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  publicBoatsCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoatsActivityEntityResponseCollection = {
  __typename?: 'BoatsActivityEntityResponseCollection';
  nodes: Array<BoatsActivity>;
  pageInfo: Pagination;
};

export type BoatsActivityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BoatsActivityFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lumen_ref_id?: InputMaybe<LongFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BoatsActivityFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BoatsActivityFiltersInput>>>;
  publicBoatsCount?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BoatsActivityInput = {
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lumen_ref_id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicBoatsCount?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BoatsActivityRelationResponseCollection = {
  __typename?: 'BoatsActivityRelationResponseCollection';
  nodes: Array<BoatsActivity>;
};

export type BoatsCategory = {
  __typename?: 'BoatsCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  lumen_ref_id?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  publicBoatsCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoatsCategoryEntityResponseCollection = {
  __typename?: 'BoatsCategoryEntityResponseCollection';
  nodes: Array<BoatsCategory>;
  pageInfo: Pagination;
};

export type BoatsCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BoatsCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lumen_ref_id?: InputMaybe<LongFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BoatsCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BoatsCategoryFiltersInput>>>;
  publicBoatsCount?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BoatsCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  lumen_ref_id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicBoatsCount?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BoatsCategoryRelationResponseCollection = {
  __typename?: 'BoatsCategoryRelationResponseCollection';
  nodes: Array<BoatsCategory>;
};

export type BoatsHullMaterial = {
  __typename?: 'BoatsHullMaterial';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publicBoatsCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoatsHullMaterialEntityResponseCollection = {
  __typename?: 'BoatsHullMaterialEntityResponseCollection';
  nodes: Array<BoatsHullMaterial>;
  pageInfo: Pagination;
};

export type BoatsHullMaterialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BoatsHullMaterialFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BoatsHullMaterialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BoatsHullMaterialFiltersInput>>>;
  publicBoatsCount?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BoatsHullMaterialInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publicBoatsCount?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BoatsHullType = {
  __typename?: 'BoatsHullType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publicBoatsCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoatsHullTypeEntityResponseCollection = {
  __typename?: 'BoatsHullTypeEntityResponseCollection';
  nodes: Array<BoatsHullType>;
  pageInfo: Pagination;
};

export type BoatsHullTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BoatsHullTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BoatsHullTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BoatsHullTypeFiltersInput>>>;
  publicBoatsCount?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BoatsHullTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicBoatsCount?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BoatsType = {
  __typename?: 'BoatsType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publicBoatsCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BoatsTypeEntityResponseCollection = {
  __typename?: 'BoatsTypeEntityResponseCollection';
  nodes: Array<BoatsType>;
  pageInfo: Pagination;
};

export type BoatsTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BoatsTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BoatsTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BoatsTypeFiltersInput>>>;
  publicBoatsCount?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BoatsTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicBoatsCount?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Changelog = {
  __typename?: 'Changelog';
  application?: Maybe<Application>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Array<Maybe<ComponentBlocksDescription>>>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['String']['output'];
};

export type ChangelogDescriptionArgs = {
  filters?: InputMaybe<ComponentBlocksDescriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChangelogEntityResponseCollection = {
  __typename?: 'ChangelogEntityResponseCollection';
  nodes: Array<Changelog>;
  pageInfo: Pagination;
};

export type ChangelogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ChangelogFiltersInput>>>;
  application?: InputMaybe<ApplicationFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  description?: InputMaybe<ComponentBlocksDescriptionFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ChangelogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ChangelogFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  version?: InputMaybe<StringFilterInput>;
};

export type ChangelogInput = {
  application?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Array<InputMaybe<ComponentBlocksDescriptionInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBlocksAvailableOn = {
  __typename?: 'ComponentBlocksAvailableOn';
  availabilitySubtitle?: Maybe<Scalars['String']['output']>;
  availabilityTitle?: Maybe<Scalars['String']['output']>;
  cardTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan?: Maybe<Plan>;
};

export type ComponentBlocksAvailableOnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksAvailableOnFiltersInput>>>;
  availabilitySubtitle?: InputMaybe<StringFilterInput>;
  availabilityTitle?: InputMaybe<StringFilterInput>;
  cardTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBlocksAvailableOnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksAvailableOnFiltersInput>>>;
  plan?: InputMaybe<PlanFiltersInput>;
};

export type ComponentBlocksAvailableOnInput = {
  availabilitySubtitle?: InputMaybe<Scalars['String']['input']>;
  availabilityTitle?: InputMaybe<Scalars['String']['input']>;
  cardTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  plan?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBlocksAvailableonOptions = {
  __typename?: 'ComponentBlocksAvailableonOptions';
  availableonImage?: Maybe<UploadFile>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentBlocksAvailableonOptionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksAvailableonOptionsFiltersInput>>>;
  not?: InputMaybe<ComponentBlocksAvailableonOptionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksAvailableonOptionsFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentBlocksAvailableonOptionsInput = {
  availableonImage?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBlocksCommonAskedQuestions = {
  __typename?: 'ComponentBlocksCommonAskedQuestions';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentBlocksDescription = {
  __typename?: 'ComponentBlocksDescription';
  details: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: Enum_Componentblocksdescription_Type;
};

export type ComponentBlocksDescriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksDescriptionFiltersInput>>>;
  details?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBlocksDescriptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksDescriptionFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentBlocksDescriptionInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Componentblocksdescription_Type>;
};

export type ComponentBlocksFeatureCard = {
  __typename?: 'ComponentBlocksFeatureCard';
  applications: Array<Maybe<Application>>;
  applications_connection?: Maybe<ApplicationRelationResponseCollection>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Enum_Componentblocksfeaturecard_Icon>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentBlocksFeatureCardApplicationsArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksFeatureCardApplications_ConnectionArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentBlocksImage = {
  __typename?: 'ComponentBlocksImage';
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
};

export type ComponentBlocksPlatformCard = {
  __typename?: 'ComponentBlocksPlatformCard';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  url: Scalars['String']['output'];
};

export type ComponentBlocksPlatformCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksPlatformCardFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBlocksPlatformCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksPlatformCardFiltersInput>>>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentBlocksPlatformCardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBlocksRichSectionTitle = {
  __typename?: 'ComponentBlocksRichSectionTitle';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentBlocksRichSectionTitleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBlocksRichText = {
  __typename?: 'ComponentBlocksRichText';
  id: Scalars['ID']['output'];
  richtext?: Maybe<Scalars['String']['output']>;
};

export type ComponentBlocksSectionTitle = {
  __typename?: 'ComponentBlocksSectionTitle';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentBlocksSectionTitleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBlocksSectionTitleFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBlocksSectionTitleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBlocksSectionTitleFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentBlocksSectionTitleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBlocksTwoColumnCover = {
  __typename?: 'ComponentBlocksTwoColumnCover';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  title: Scalars['String']['output'];
};

export type ComponentBoatsCeClassification = {
  __typename?: 'ComponentBoatsCeClassification';
  a?: Maybe<Scalars['Int']['output']>;
  b?: Maybe<Scalars['Int']['output']>;
  c?: Maybe<Scalars['Int']['output']>;
  d?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBoatsCeClassificationFiltersInput = {
  a?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBoatsCeClassificationFiltersInput>>>;
  b?: InputMaybe<IntFilterInput>;
  c?: InputMaybe<IntFilterInput>;
  d?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentBoatsCeClassificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBoatsCeClassificationFiltersInput>>>;
};

export type ComponentBoatsCeClassificationInput = {
  a?: InputMaybe<Scalars['Int']['input']>;
  b?: InputMaybe<Scalars['Int']['input']>;
  c?: InputMaybe<Scalars['Int']['input']>;
  d?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBoatsDocuments = {
  __typename?: 'ComponentBoatsDocuments';
  file: UploadFile;
  id: Scalars['ID']['output'];
  tags: Scalars['JSON']['output'];
};

export type ComponentBoatsDocumentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBoatsDocumentsFiltersInput>>>;
  not?: InputMaybe<ComponentBoatsDocumentsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBoatsDocumentsFiltersInput>>>;
  tags?: InputMaybe<JsonFilterInput>;
};

export type ComponentBoatsDocumentsInput = {
  file?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentBoatsEngine = {
  __typename?: 'ComponentBoatsEngine';
  drive?: Maybe<Enum_Componentboatsengine_Drive>;
  fuel?: Maybe<Enum_Componentboatsengine_Fuel>;
  id: Scalars['ID']['output'];
  maker?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  power_type?: Maybe<Enum_Componentboatsengine_Power_Type>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ComponentBoatsEngineFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBoatsEngineFiltersInput>>>;
  drive?: InputMaybe<StringFilterInput>;
  fuel?: InputMaybe<StringFilterInput>;
  maker?: InputMaybe<StringFilterInput>;
  model?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBoatsEngineFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBoatsEngineFiltersInput>>>;
  power?: InputMaybe<StringFilterInput>;
  power_type?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type ComponentBoatsEngineInput = {
  drive?: InputMaybe<Enum_Componentboatsengine_Drive>;
  fuel?: InputMaybe<Enum_Componentboatsengine_Fuel>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maker?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  power?: InputMaybe<Scalars['String']['input']>;
  power_type?: InputMaybe<Enum_Componentboatsengine_Power_Type>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBoatsNameValue = {
  __typename?: 'ComponentBoatsNameValue';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ComponentBoatsNameValueFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBoatsNameValueFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBoatsNameValueFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBoatsNameValueFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentBoatsNameValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentBoatsPrice = {
  __typename?: 'ComponentBoatsPrice';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID']['output'];
};

export type ComponentBoatsPriceFiltersInput = {
  amount?: InputMaybe<FloatFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentBoatsPriceFiltersInput>>>;
  currency?: InputMaybe<CurrencyFiltersInput>;
  not?: InputMaybe<ComponentBoatsPriceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBoatsPriceFiltersInput>>>;
};

export type ComponentBoatsPriceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentBoatsTank = {
  __typename?: 'ComponentBoatsTank';
  capacity?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentBoatsTankFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentBoatsTankFiltersInput>>>;
  capacity?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentBoatsTankFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentBoatsTankFiltersInput>>>;
};

export type ComponentBoatsTankInput = {
  capacity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentMdcLandingSectionsMission = {
  __typename?: 'ComponentMdcLandingSectionsMission';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentMdcLandingSectionsMissionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMdcLandingSectionsSlogan = {
  __typename?: 'ComponentMdcLandingSectionsSlogan';
  appLinks?: Maybe<Array<Maybe<ComponentBlocksPlatformCard>>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  title: Scalars['String']['output'];
};

export type ComponentMdcLandingSectionsSloganAppLinksArgs = {
  filters?: InputMaybe<ComponentBlocksPlatformCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMdcLandingSectionsSloganInput = {
  appLinks?: InputMaybe<Array<InputMaybe<ComponentBlocksPlatformCardInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMdcLandingSectionsStory = {
  __typename?: 'ComponentMdcLandingSectionsStory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  title: Scalars['String']['output'];
};

export type ComponentMdcLandingSectionsStoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMdcLandingSectionsValues = {
  __typename?: 'ComponentMdcLandingSectionsValues';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentMdcLandingSectionsValuesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMdcLandingSectionsVision = {
  __typename?: 'ComponentMdcLandingSectionsVision';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  label: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentMdcLandingSectionsVisionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMdcLandingSectionsWorkWithUs = {
  __typename?: 'ComponentMdcLandingSectionsWorkWithUs';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  title: Scalars['String']['output'];
};

export type ComponentMdcLandingSectionsWorkWithUsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPricingPagePlanCards = {
  __typename?: 'ComponentPricingPagePlanCards';
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  planName: Scalars['String']['output'];
  price?: Maybe<Scalars['String']['output']>;
  recurrance?: Maybe<Scalars['String']['output']>;
};

export type ComponentPricingPagePlanCardsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentPricingPagePlanCardsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  features?: InputMaybe<StringFilterInput>;
  iconName?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentPricingPagePlanCardsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentPricingPagePlanCardsFiltersInput>>>;
  planName?: InputMaybe<StringFilterInput>;
  price?: InputMaybe<StringFilterInput>;
  recurrance?: InputMaybe<StringFilterInput>;
};

export type ComponentPricingPagePlanCardsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  recurrance?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPricingPagePlans = {
  __typename?: 'ComponentPricingPagePlans';
  features?: Maybe<Scalars['JSON']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  planName: Scalars['String']['output'];
  price?: Maybe<Scalars['String']['output']>;
  recurrance?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedIcon = {
  __typename?: 'ComponentSharedIcon';
  id: Scalars['ID']['output'];
  name?: Maybe<Enum_Componentsharedicon_Name>;
};

export type ComponentSharedIconFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedIconFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedIconFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedIconFiltersInput>>>;
};

export type ComponentSharedIconInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Enum_Componentsharedicon_Name>;
};

export type ComponentSharedMetaSocial = {
  __typename?: 'ComponentSharedMetaSocial';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork;
  title: Scalars['String']['output'];
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  canonicalURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaImage?: Maybe<UploadFile>;
  metaRobots?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  metaViewport?: Maybe<Scalars['String']['output']>;
  structuredData?: Maybe<Scalars['JSON']['output']>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  canonicalURL?: InputMaybe<StringFilterInput>;
  keywords?: InputMaybe<StringFilterInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaRobots?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  metaViewport?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  structuredData?: InputMaybe<JsonFilterInput>;
};

export type ComponentSharedSeoInput = {
  canonicalURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaImage?: InputMaybe<Scalars['ID']['input']>;
  metaRobots?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaViewport?: InputMaybe<Scalars['String']['input']>;
  structuredData?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentTbaLandingSectionsAvailableOn = {
  __typename?: 'ComponentTbaLandingSectionsAvailableOn';
  availableonOptions?: Maybe<Array<Maybe<ComponentBlocksAvailableonOptions>>>;
  coverImage?: Maybe<UploadFile>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentTbaLandingSectionsAvailableOnAvailableonOptionsArgs = {
  filters?: InputMaybe<ComponentBlocksAvailableonOptionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTbaLandingSectionsAvailableOnInput = {
  availableonOptions?: InputMaybe<Array<InputMaybe<ComponentBlocksAvailableonOptionsInput>>>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTbaLandingSectionsImagesGridWithVideo = {
  __typename?: 'ComponentTbaLandingSectionsImagesGridWithVideo';
  description: Scalars['String']['output'];
  gridImages: Array<Maybe<UploadFile>>;
  gridImages_connection: UploadFileRelationResponseCollection;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ComponentTbaLandingSectionsImagesGridWithVideoGridImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTbaLandingSectionsImagesGridWithVideoGridImages_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTbaLandingSectionsImagesGridWithVideoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gridImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTbaLandingSectionsJoinUs = {
  __typename?: 'ComponentTbaLandingSectionsJoinUs';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  joinUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentTbaLandingSectionsJoinUsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  joinUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTbaLandingSectionsPageCover = {
  __typename?: 'ComponentTbaLandingSectionsPageCover';
  description: Scalars['String']['output'];
  getStartedLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  title: Scalars['String']['output'];
};

export type ComponentTbaLandingSectionsPageCoverInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  getStartedLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTbaLandingSectionsShowcase = {
  __typename?: 'ComponentTbaLandingSectionsShowcase';
  description: Scalars['String']['output'];
  getStartedLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFile;
  title: Scalars['String']['output'];
};

export type ComponentTbaLandingSectionsShowcaseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  getStartedLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Currency = {
  __typename?: 'Currency';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  exchange_rate?: Maybe<Scalars['Float']['output']>;
  is_default: Scalars['Boolean']['output'];
  iso_code: Scalars['String']['output'];
  iso_code_num: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sort?: Maybe<Scalars['Int']['output']>;
  symbol: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CurrencyEntityResponseCollection = {
  __typename?: 'CurrencyEntityResponseCollection';
  nodes: Array<Currency>;
  pageInfo: Pagination;
};

export type CurrencyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CurrencyFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  exchange_rate?: InputMaybe<FloatFilterInput>;
  is_default?: InputMaybe<BooleanFilterInput>;
  iso_code?: InputMaybe<StringFilterInput>;
  iso_code_num?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CurrencyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CurrencyFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sort?: InputMaybe<IntFilterInput>;
  symbol?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CurrencyInput = {
  exchange_rate?: InputMaybe<Scalars['Float']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  iso_code?: InputMaybe<Scalars['String']['input']>;
  iso_code_num?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export enum Enum_Announcement_Level {
  Announcement = 'announcement',
  Info = 'info',
  Maintenance = 'maintenance',
  Warning = 'warning',
}

export enum Enum_Boat_Keel_Type {
  Bilge = 'bilge',
  Bulb = 'bulb',
  Centerboard = 'centerboard',
  Daggerboard = 'daggerboard',
  Fin = 'fin',
  Other = 'other',
  Wing = 'wing',
}

export enum Enum_Boat_Rigging {
  Brig = 'Brig',
  Cutter = 'Cutter',
  ForeAndAft = 'Fore_and_aft',
  FractionalSloop = 'Fractional_Sloop',
  Gaff = 'Gaff',
  Ketch = 'Ketch',
  MastheadSloop = 'Masthead_sloop',
  Running = 'Running',
  Schooner = 'Schooner',
  Sloop = 'Sloop',
  Square = 'Square',
  SquareRigged = 'Square_rigged',
  Standing = 'Standing',
  Unstayed = 'Unstayed',
  FractionalRigSloop = 'fractional_rig_sloop',
}

export enum Enum_Boat_Unit {
  Imperial = 'imperial',
  Metric = 'metric',
}

export enum Enum_Componentblocksdescription_Type {
  Added = 'Added',
  Fixed = 'Fixed',
  Updated = 'Updated',
}

export enum Enum_Componentblocksfeaturecard_Icon {
  AlarmIcon = 'AlarmIcon',
  CloudOutlined = 'CloudOutlined',
  DashboardOutlined = 'DashboardOutlined',
  FileAddOutlined = 'FileAddOutlined',
  GoldIcon = 'GoldIcon',
  HeartOutlined = 'HeartOutlined',
  LifeBuoyIcon = 'LifeBuoyIcon',
  LikeOutlined = 'LikeOutlined',
  MarkerIcon = 'MarkerIcon',
  OfflineIcon = 'OfflineIcon',
  SaveOutlined = 'SaveOutlined',
  ScaleIcon = 'ScaleIcon',
  SearchOutlined = 'SearchOutlined',
  ShareAltOutlined = 'ShareAltOutlined',
  ShareFileIcon = 'ShareFileIcon',
  SoundOutlined = 'SoundOutlined',
  StopOutlined = 'StopOutlined',
  TaskCheckListIcon = 'TaskCheckListIcon',
  UserOutlined = 'UserOutlined',
  UsersIcon = 'UsersIcon',
  WindIcon = 'WindIcon',
}

export enum Enum_Componentboatsengine_Drive {
  DDrive = 'D_drive',
  JetDrive = 'Jet_drive',
  Other = 'Other',
  PodDrive = 'Pod_drive',
  SurfaceDrive = 'Surface_drive',
  VDrive = 'V_drive',
}

export enum Enum_Componentboatsengine_Fuel {
  Diesel = 'Diesel',
  Electric = 'Electric',
  Gas = 'Gas',
  Gasoline = 'Gasoline',
  Lpg = 'LPG',
  Other = 'Other',
}

export enum Enum_Componentboatsengine_Power_Type {
  Hp = 'hp',
  Kw = 'kw',
}

export enum Enum_Componentsharedicon_Name {
  AlarmIcon = 'alarmIcon',
  BoatIcon = 'boatIcon',
  BoatTwoIcon = 'boatTwoIcon',
  BookOutlined = 'bookOutlined',
  BulbOutlined = 'bulbOutlined',
  CloudOutlined = 'cloudOutlined',
  CommunityIcon = 'communityIcon',
  CompareIcon = 'compareIcon',
  CustomerServiceOutlined = 'customerServiceOutlined',
  DashboardOutlined = 'dashboardOutlined',
  DatabaseOutlined = 'databaseOutlined',
  DoubleCheckIcon = 'doubleCheckIcon',
  ExplorerIcon = 'explorerIcon',
  ExternalLinkIcon = 'externalLinkIcon',
  FileAddOutlined = 'fileAddOutlined',
  FileOutlined = 'fileOutlined',
  FileProtectOutlined = 'fileProtectOutlined',
  FileTextOutlined = 'fileTextOutlined',
  FundOutlined = 'fundOutlined',
  GoldIcon = 'goldIcon',
  HeartOutlined = 'heartOutlined',
  LifeBuoyIcon = 'lifeBuoyIcon',
  LikeOutlined = 'likeOutlined',
  MarkerIcon = 'markerIcon',
  MessageOutlined = 'messageOutlined',
  OfflineIcon = 'offlineIcon',
  PieChartOutlined = 'pieChartOutlined',
  PlatinumIcon = 'platinumIcon',
  ProfileOutlined = 'profileOutlined',
  SailBoat = 'sailBoat',
  SaveOutlined = 'saveOutlined',
  ScaleIcon = 'scaleIcon',
  SearchOutlined = 'searchOutlined',
  ShareAltOutlined = 'shareAltOutlined',
  ShareFileIcon = 'shareFileIcon',
  SilverIcon = 'silverIcon',
  SolutionOutlined = 'solutionOutlined',
  SoundOutlined = 'soundOutlined',
  StopOutlined = 'stopOutlined',
  SuitcaseIcon = 'suitcaseIcon',
  TaskCheckListIcon = 'taskCheckListIcon',
  UnorderedListOutlined = 'unorderedListOutlined',
  UserHeartIcon = 'userHeartIcon',
  UserOutlined = 'userOutlined',
  UsersIcon = 'usersIcon',
  WindIcon = 'windIcon',
}

export enum Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
}

export enum Enum_Feature_Group {
  General = 'General',
  TheBoatApp = 'TheBoatApp',
  TheBoatDb = 'TheBoatDB',
}

export enum Enum_Feature_Subgroup {
  Alerts = 'Alerts',
  Boats = 'Boats',
  Checklists = 'Checklists',
  Costs = 'Costs',
  Dashboard = 'Dashboard',
  Inventory = 'Inventory',
  Logbook = 'Logbook',
  Storage = 'Storage',
  Tasks = 'Tasks',
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Feature = {
  __typename?: 'Feature';
  availableOn?: Maybe<Array<Maybe<ComponentBlocksAvailableOn>>>;
  badge?: Maybe<Scalars['String']['output']>;
  carouselDescription?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  group?: Maybe<Enum_Feature_Group>;
  icon?: Maybe<ComponentSharedIcon>;
  link?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showOnCard: Scalars['Boolean']['output'];
  showOnCarousel: Scalars['Boolean']['output'];
  subGroup?: Maybe<Enum_Feature_Subgroup>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureAvailableOnArgs = {
  filters?: InputMaybe<ComponentBlocksAvailableOnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeatureEntityResponseCollection = {
  __typename?: 'FeatureEntityResponseCollection';
  nodes: Array<Feature>;
  pageInfo: Pagination;
};

export type FeatureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeatureFiltersInput>>>;
  availableOn?: InputMaybe<ComponentBlocksAvailableOnFiltersInput>;
  badge?: InputMaybe<StringFilterInput>;
  carouselDescription?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  group?: InputMaybe<StringFilterInput>;
  icon?: InputMaybe<ComponentSharedIconFiltersInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<FeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeatureFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  showOnCard?: InputMaybe<BooleanFilterInput>;
  showOnCarousel?: InputMaybe<BooleanFilterInput>;
  subGroup?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FeatureInput = {
  availableOn?: InputMaybe<Array<InputMaybe<ComponentBlocksAvailableOnInput>>>;
  badge?: InputMaybe<Scalars['String']['input']>;
  carouselDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Enum_Feature_Group>;
  icon?: InputMaybe<ComponentSharedIconInput>;
  link?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showOnCard?: InputMaybe<Scalars['Boolean']['input']>;
  showOnCarousel?: InputMaybe<Scalars['Boolean']['input']>;
  subGroup?: InputMaybe<Enum_Feature_Subgroup>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureRelationResponseCollection = {
  __typename?: 'FeatureRelationResponseCollection';
  nodes: Array<Feature>;
};

export type FeaturesPage = {
  __typename?: 'FeaturesPage';
  applications: Array<Maybe<Application>>;
  applications_connection?: Maybe<ApplicationRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  icon?: Maybe<ComponentSharedIcon>;
  image?: Maybe<UploadFile>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  youtube_video_url?: Maybe<Scalars['String']['output']>;
};

export type FeaturesPageApplicationsArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeaturesPageApplications_ConnectionArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeaturesPageEntityResponseCollection = {
  __typename?: 'FeaturesPageEntityResponseCollection';
  nodes: Array<FeaturesPage>;
  pageInfo: Pagination;
};

export type FeaturesPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeaturesPageFiltersInput>>>;
  applications?: InputMaybe<ApplicationFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  icon?: InputMaybe<ComponentSharedIconFiltersInput>;
  not?: InputMaybe<FeaturesPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeaturesPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  youtube_video_url?: InputMaybe<StringFilterInput>;
};

export type FeaturesPageInput = {
  applications?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<ComponentSharedIconInput>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youtube_video_url?: InputMaybe<Scalars['String']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph =
  | Announcement
  | Application
  | Boat
  | BoatDesigner
  | BoatsActivity
  | BoatsCategory
  | BoatsHullMaterial
  | BoatsHullType
  | BoatsType
  | Changelog
  | ComponentBlocksAvailableOn
  | ComponentBlocksAvailableonOptions
  | ComponentBlocksCommonAskedQuestions
  | ComponentBlocksDescription
  | ComponentBlocksFeatureCard
  | ComponentBlocksImage
  | ComponentBlocksPlatformCard
  | ComponentBlocksRichSectionTitle
  | ComponentBlocksRichText
  | ComponentBlocksSectionTitle
  | ComponentBlocksTwoColumnCover
  | ComponentBoatsCeClassification
  | ComponentBoatsDocuments
  | ComponentBoatsEngine
  | ComponentBoatsNameValue
  | ComponentBoatsPrice
  | ComponentBoatsTank
  | ComponentMdcLandingSectionsMission
  | ComponentMdcLandingSectionsSlogan
  | ComponentMdcLandingSectionsStory
  | ComponentMdcLandingSectionsValues
  | ComponentMdcLandingSectionsVision
  | ComponentMdcLandingSectionsWorkWithUs
  | ComponentPricingPagePlanCards
  | ComponentPricingPagePlans
  | ComponentSharedIcon
  | ComponentSharedMetaSocial
  | ComponentSharedSeo
  | ComponentTbaLandingSectionsAvailableOn
  | ComponentTbaLandingSectionsImagesGridWithVideo
  | ComponentTbaLandingSectionsJoinUs
  | ComponentTbaLandingSectionsPageCover
  | ComponentTbaLandingSectionsShowcase
  | Currency
  | Feature
  | FeaturesPage
  | I18NLocale
  | LegalPage
  | Manufacturer
  | MarinedatacloudHomepage
  | NewsItem
  | Plan
  | Post
  | PostCategory
  | PostTag
  | PricingPage
  | PublisherAction
  | ReviewWorkflowsWorkflow
  | ReviewWorkflowsWorkflowStage
  | TheboatappHomepage
  | UploadFile
  | UserFavoriteBoat
  | UsersPermissionsPermission
  | UsersPermissionsRole
  | UsersPermissionsUser;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LegalPage = {
  __typename?: 'LegalPage';
  content?: Maybe<Array<Maybe<ComponentBlocksSectionTitle>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LegalPageContentArgs = {
  filters?: InputMaybe<ComponentBlocksSectionTitleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegalPageEntityResponseCollection = {
  __typename?: 'LegalPageEntityResponseCollection';
  nodes: Array<LegalPage>;
  pageInfo: Pagination;
};

export type LegalPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LegalPageFiltersInput>>>;
  content?: InputMaybe<ComponentBlocksSectionTitleFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LegalPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LegalPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LegalPageInput = {
  content?: InputMaybe<Array<InputMaybe<ComponentBlocksSectionTitleInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  logo?: Maybe<UploadFile>;
  lumen_ref_id?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  publicBoatsCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerEntityResponseCollection = {
  __typename?: 'ManufacturerEntityResponseCollection';
  nodes: Array<Manufacturer>;
  pageInfo: Pagination;
};

export type ManufacturerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ManufacturerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lumen_ref_id?: InputMaybe<LongFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ManufacturerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ManufacturerFiltersInput>>>;
  publicBoatsCount?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type ManufacturerInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  lumen_ref_id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicBoatsCount?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type MarinedatacloudHomepage = {
  __typename?: 'MarinedatacloudHomepage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  mission: ComponentMdcLandingSectionsMission;
  ourStory: ComponentMdcLandingSectionsStory;
  pageCover: ComponentMdcLandingSectionsSlogan;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  values: ComponentMdcLandingSectionsValues;
  vision: ComponentMdcLandingSectionsVision;
  workWithUs: ComponentMdcLandingSectionsWorkWithUs;
};

export type MarinedatacloudHomepageInput = {
  mission?: InputMaybe<ComponentMdcLandingSectionsMissionInput>;
  ourStory?: InputMaybe<ComponentMdcLandingSectionsStoryInput>;
  pageCover?: InputMaybe<ComponentMdcLandingSectionsSloganInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  values?: InputMaybe<ComponentMdcLandingSectionsValuesInput>;
  vision?: InputMaybe<ComponentMdcLandingSectionsVisionInput>;
  workWithUs?: InputMaybe<ComponentMdcLandingSectionsWorkWithUsInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAnnouncement?: Maybe<Announcement>;
  createApplication?: Maybe<Application>;
  createBoat?: Maybe<Boat>;
  createBoatDesigner?: Maybe<BoatDesigner>;
  createBoatsActivity?: Maybe<BoatsActivity>;
  createBoatsCategory?: Maybe<BoatsCategory>;
  createBoatsHullMaterial?: Maybe<BoatsHullMaterial>;
  createBoatsHullType?: Maybe<BoatsHullType>;
  createBoatsType?: Maybe<BoatsType>;
  createChangelog?: Maybe<Changelog>;
  createCurrency?: Maybe<Currency>;
  createFeature?: Maybe<Feature>;
  createFeaturesPage?: Maybe<FeaturesPage>;
  createLegalPage?: Maybe<LegalPage>;
  createManufacturer?: Maybe<Manufacturer>;
  createNewsItem?: Maybe<NewsItem>;
  createPlan?: Maybe<Plan>;
  createPost?: Maybe<Post>;
  createPostCategory?: Maybe<PostCategory>;
  createPostTag?: Maybe<PostTag>;
  createPublisherAction?: Maybe<PublisherAction>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createUserFavoriteBoat?: Maybe<UserFavoriteBoat>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAnnouncement?: Maybe<DeleteMutationResponse>;
  deleteApplication?: Maybe<DeleteMutationResponse>;
  deleteBoat?: Maybe<DeleteMutationResponse>;
  deleteBoatDesigner?: Maybe<DeleteMutationResponse>;
  deleteBoatsActivity?: Maybe<DeleteMutationResponse>;
  deleteBoatsCategory?: Maybe<DeleteMutationResponse>;
  deleteBoatsHullMaterial?: Maybe<DeleteMutationResponse>;
  deleteBoatsHullType?: Maybe<DeleteMutationResponse>;
  deleteBoatsType?: Maybe<DeleteMutationResponse>;
  deleteChangelog?: Maybe<DeleteMutationResponse>;
  deleteCurrency?: Maybe<DeleteMutationResponse>;
  deleteFeature?: Maybe<DeleteMutationResponse>;
  deleteFeaturesPage?: Maybe<DeleteMutationResponse>;
  deleteLegalPage?: Maybe<DeleteMutationResponse>;
  deleteManufacturer?: Maybe<DeleteMutationResponse>;
  deleteMarinedatacloudHomepage?: Maybe<DeleteMutationResponse>;
  deleteNewsItem?: Maybe<DeleteMutationResponse>;
  deletePlan?: Maybe<DeleteMutationResponse>;
  deletePost?: Maybe<DeleteMutationResponse>;
  deletePostCategory?: Maybe<DeleteMutationResponse>;
  deletePostTag?: Maybe<DeleteMutationResponse>;
  deletePricingPage?: Maybe<DeleteMutationResponse>;
  deletePublisherAction?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteTheboatappHomepage?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  deleteUserFavoriteBoat?: Maybe<DeleteMutationResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAnnouncement?: Maybe<Announcement>;
  updateApplication?: Maybe<Application>;
  updateBoat?: Maybe<Boat>;
  updateBoatDesigner?: Maybe<BoatDesigner>;
  updateBoatsActivity?: Maybe<BoatsActivity>;
  updateBoatsCategory?: Maybe<BoatsCategory>;
  updateBoatsHullMaterial?: Maybe<BoatsHullMaterial>;
  updateBoatsHullType?: Maybe<BoatsHullType>;
  updateBoatsType?: Maybe<BoatsType>;
  updateChangelog?: Maybe<Changelog>;
  updateCurrency?: Maybe<Currency>;
  updateFeature?: Maybe<Feature>;
  updateFeaturesPage?: Maybe<FeaturesPage>;
  updateLegalPage?: Maybe<LegalPage>;
  updateManufacturer?: Maybe<Manufacturer>;
  updateMarinedatacloudHomepage?: Maybe<MarinedatacloudHomepage>;
  updateNewsItem?: Maybe<NewsItem>;
  updatePlan?: Maybe<Plan>;
  updatePost?: Maybe<Post>;
  updatePostCategory?: Maybe<PostCategory>;
  updatePostTag?: Maybe<PostTag>;
  updatePricingPage?: Maybe<PricingPage>;
  updatePublisherAction?: Maybe<PublisherAction>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateTheboatappHomepage?: Maybe<TheboatappHomepage>;
  updateUploadFile: UploadFile;
  updateUserFavoriteBoat?: Maybe<UserFavoriteBoat>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type MutationCreateAnnouncementArgs = {
  data: AnnouncementInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateApplicationArgs = {
  data: ApplicationInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatArgs = {
  data: BoatInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatDesignerArgs = {
  data: BoatDesignerInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatsActivityArgs = {
  data: BoatsActivityInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatsCategoryArgs = {
  data: BoatsCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatsHullMaterialArgs = {
  data: BoatsHullMaterialInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatsHullTypeArgs = {
  data: BoatsHullTypeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateBoatsTypeArgs = {
  data: BoatsTypeInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateChangelogArgs = {
  data: ChangelogInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateCurrencyArgs = {
  data: CurrencyInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateFeatureArgs = {
  data: FeatureInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateFeaturesPageArgs = {
  data: FeaturesPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateLegalPageArgs = {
  data: LegalPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateManufacturerArgs = {
  data: ManufacturerInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateNewsItemArgs = {
  data: NewsItemInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePlanArgs = {
  data: PlanInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePostArgs = {
  data: PostInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePostCategoryArgs = {
  data: PostCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePostTagArgs = {
  data: PostTagInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreatePublisherActionArgs = {
  data: PublisherActionInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateUserFavoriteBoatArgs = {
  data: UserFavoriteBoatInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};

export type MutationDeleteAnnouncementArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteApplicationArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatDesignerArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatsActivityArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatsCategoryArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatsHullMaterialArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatsHullTypeArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteBoatsTypeArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteChangelogArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteCurrencyArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteFeatureArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteFeaturesPageArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteLegalPageArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteManufacturerArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteNewsItemArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePlanArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePostArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePostCategoryArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePostTagArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeletePublisherActionArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUserFavoriteBoatArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};

export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type MutationUpdateAnnouncementArgs = {
  data: AnnouncementInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateApplicationArgs = {
  data: ApplicationInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatArgs = {
  data: BoatInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatDesignerArgs = {
  data: BoatDesignerInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatsActivityArgs = {
  data: BoatsActivityInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatsCategoryArgs = {
  data: BoatsCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatsHullMaterialArgs = {
  data: BoatsHullMaterialInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatsHullTypeArgs = {
  data: BoatsHullTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateBoatsTypeArgs = {
  data: BoatsTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateChangelogArgs = {
  data: ChangelogInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateCurrencyArgs = {
  data: CurrencyInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateFeatureArgs = {
  data: FeatureInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateFeaturesPageArgs = {
  data: FeaturesPageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateLegalPageArgs = {
  data: LegalPageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateManufacturerArgs = {
  data: ManufacturerInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateMarinedatacloudHomepageArgs = {
  data: MarinedatacloudHomepageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateNewsItemArgs = {
  data: NewsItemInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePlanArgs = {
  data: PlanInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePostArgs = {
  data: PostInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePostCategoryArgs = {
  data: PostCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePostTagArgs = {
  data: PostTagInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePricingPageArgs = {
  data: PricingPageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdatePublisherActionArgs = {
  data: PublisherActionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateTheboatappHomepageArgs = {
  data: TheboatappHomepageInput;
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};

export type MutationUpdateUserFavoriteBoatArgs = {
  data: UserFavoriteBoatInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type NewsItem = {
  __typename?: 'NewsItem';
  application: Application;
  content?: Maybe<Array<Maybe<NewsItemContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  excerpt: Scalars['String']['output'];
  featuredImage: UploadFile;
  publishDate?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  showPublishDate?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NewsItemContentDynamicZone = ComponentBlocksRichText | Error;

export type NewsItemEntityResponseCollection = {
  __typename?: 'NewsItemEntityResponseCollection';
  nodes: Array<NewsItem>;
  pageInfo: Pagination;
};

export type NewsItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NewsItemFiltersInput>>>;
  application?: InputMaybe<ApplicationFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  excerpt?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NewsItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NewsItemFiltersInput>>>;
  publishDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  showPublishDate?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NewsItemInput = {
  application?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Array<Scalars['NewsItemContentDynamicZoneInput']['input']>>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['ID']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  showPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  icon?: Maybe<ComponentSharedIcon>;
  order: Scalars['Int']['output'];
  price?: Maybe<ComponentBoatsPrice>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  recurrence?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlanEntityResponseCollection = {
  __typename?: 'PlanEntityResponseCollection';
  nodes: Array<Plan>;
  pageInfo: Pagination;
};

export type PlanFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PlanFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  icon?: InputMaybe<ComponentSharedIconFiltersInput>;
  not?: InputMaybe<PlanFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PlanFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  price?: InputMaybe<ComponentBoatsPriceFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  recurrence?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<ComponentSharedIconInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<ComponentBoatsPriceInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recurrence?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Post = {
  __typename?: 'Post';
  application?: Maybe<Application>;
  content: Array<Maybe<PostContentDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featuredImage: UploadFile;
  post_categories: Array<Maybe<PostCategory>>;
  post_categories_connection?: Maybe<PostCategoryRelationResponseCollection>;
  post_tags: Array<Maybe<PostTag>>;
  post_tags_connection?: Maybe<PostTagRelationResponseCollection>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reading_time?: Maybe<Scalars['Int']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  showPublishDate: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostPost_CategoriesArgs = {
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostPost_Categories_ConnectionArgs = {
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostPost_TagsArgs = {
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostPost_Tags_ConnectionArgs = {
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostCategory = {
  __typename?: 'PostCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent_category?: Maybe<PostCategory>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  tbaPostsCount: Scalars['Int']['output'];
  tbdPostsCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostCategoryEntityResponseCollection = {
  __typename?: 'PostCategoryEntityResponseCollection';
  nodes: Array<PostCategory>;
  pageInfo: Pagination;
};

export type PostCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PostCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostCategoryFiltersInput>>>;
  parent_category?: InputMaybe<PostCategoryFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  tbaPostsCount?: InputMaybe<IntFilterInput>;
  tbdPostsCount?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_category?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tbaPostsCount?: InputMaybe<Scalars['Int']['input']>;
  tbdPostsCount?: InputMaybe<Scalars['Int']['input']>;
};

export type PostCategoryRelationResponseCollection = {
  __typename?: 'PostCategoryRelationResponseCollection';
  nodes: Array<PostCategory>;
};

export type PostContentDynamicZone = ComponentBlocksImage | ComponentBlocksRichText | Error;

export type PostEntityResponseCollection = {
  __typename?: 'PostEntityResponseCollection';
  nodes: Array<Post>;
  pageInfo: Pagination;
};

export type PostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  application?: InputMaybe<ApplicationFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  excerpt?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  post_categories?: InputMaybe<PostCategoryFiltersInput>;
  post_tags?: InputMaybe<PostTagFiltersInput>;
  publishDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reading_time?: InputMaybe<IntFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  showPublishDate?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostInput = {
  application?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Array<Scalars['PostContentDynamicZoneInput']['input']>>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['ID']['input']>;
  post_categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  post_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reading_time?: InputMaybe<Scalars['Int']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  showPublishDate?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostTag = {
  __typename?: 'PostTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String']['output'];
  tbaPostsCount: Scalars['Int']['output'];
  tbdPostsCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostTagEntityResponseCollection = {
  __typename?: 'PostTagEntityResponseCollection';
  nodes: Array<PostTag>;
  pageInfo: Pagination;
};

export type PostTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostTagFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PostTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostTagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  tbaPostsCount?: InputMaybe<IntFilterInput>;
  tbdPostsCount?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tbaPostsCount?: InputMaybe<Scalars['Int']['input']>;
  tbdPostsCount?: InputMaybe<Scalars['Int']['input']>;
};

export type PostTagRelationResponseCollection = {
  __typename?: 'PostTagRelationResponseCollection';
  nodes: Array<PostTag>;
};

export type PricingPage = {
  __typename?: 'PricingPage';
  FAQ?: Maybe<Array<Maybe<PricingPageFaqDynamicZone>>>;
  comparePlansTitle?: Maybe<ComponentBlocksSectionTitle>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  faq_title?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<UploadFile>;
  features: Array<Maybe<Feature>>;
  featuresTitle?: Maybe<ComponentBlocksSectionTitle>;
  features_connection?: Maybe<FeatureRelationResponseCollection>;
  planCards?: Maybe<Array<Maybe<ComponentPricingPagePlanCards>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reachSectionTitle?: Maybe<ComponentBlocksRichSectionTitle>;
  seo?: Maybe<ComponentSharedSeo>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PricingPageFeaturesArgs = {
  filters?: InputMaybe<FeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PricingPageFeatures_ConnectionArgs = {
  filters?: InputMaybe<FeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PricingPagePlanCardsArgs = {
  filters?: InputMaybe<ComponentPricingPagePlanCardsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PricingPageFaqDynamicZone = ComponentBlocksCommonAskedQuestions | Error;

export type PricingPageInput = {
  FAQ?: InputMaybe<Array<Scalars['PricingPageFaqDynamicZoneInput']['input']>>;
  comparePlansTitle?: InputMaybe<ComponentBlocksSectionTitleInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  faq_title?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['ID']['input']>;
  features?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  featuresTitle?: InputMaybe<ComponentBlocksSectionTitleInput>;
  planCards?: InputMaybe<Array<InputMaybe<ComponentPricingPagePlanCardsInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reachSectionTitle?: InputMaybe<ComponentBlocksRichSectionTitleInput>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type PublisherAction = {
  __typename?: 'PublisherAction';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entitySlug?: Maybe<Scalars['String']['output']>;
  executeAt?: Maybe<Scalars['DateTime']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PublisherActionEntityResponseCollection = {
  __typename?: 'PublisherActionEntityResponseCollection';
  nodes: Array<PublisherAction>;
  pageInfo: Pagination;
};

export type PublisherActionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PublisherActionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  entityId?: InputMaybe<StringFilterInput>;
  entitySlug?: InputMaybe<StringFilterInput>;
  executeAt?: InputMaybe<DateTimeFilterInput>;
  mode?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PublisherActionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PublisherActionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PublisherActionInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entitySlug?: InputMaybe<Scalars['String']['input']>;
  executeAt?: InputMaybe<Scalars['DateTime']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Query = {
  __typename?: 'Query';
  announcement?: Maybe<Announcement>;
  announcements: Array<Maybe<Announcement>>;
  announcements_connection?: Maybe<AnnouncementEntityResponseCollection>;
  application?: Maybe<Application>;
  applications: Array<Maybe<Application>>;
  applications_connection?: Maybe<ApplicationEntityResponseCollection>;
  boat?: Maybe<Boat>;
  boatDesigner?: Maybe<BoatDesigner>;
  boatDesigners: Array<Maybe<BoatDesigner>>;
  boatDesigners_connection?: Maybe<BoatDesignerEntityResponseCollection>;
  boats: Array<Maybe<Boat>>;
  boatsActivities: Array<Maybe<BoatsActivity>>;
  boatsActivities_connection?: Maybe<BoatsActivityEntityResponseCollection>;
  boatsActivity?: Maybe<BoatsActivity>;
  boatsCategories: Array<Maybe<BoatsCategory>>;
  boatsCategories_connection?: Maybe<BoatsCategoryEntityResponseCollection>;
  boatsCategory?: Maybe<BoatsCategory>;
  boatsHullMaterial?: Maybe<BoatsHullMaterial>;
  boatsHullMaterials: Array<Maybe<BoatsHullMaterial>>;
  boatsHullMaterials_connection?: Maybe<BoatsHullMaterialEntityResponseCollection>;
  boatsHullType?: Maybe<BoatsHullType>;
  boatsHullTypes: Array<Maybe<BoatsHullType>>;
  boatsHullTypes_connection?: Maybe<BoatsHullTypeEntityResponseCollection>;
  boatsType?: Maybe<BoatsType>;
  boatsTypes: Array<Maybe<BoatsType>>;
  boatsTypes_connection?: Maybe<BoatsTypeEntityResponseCollection>;
  boats_connection?: Maybe<BoatEntityResponseCollection>;
  changelog?: Maybe<Changelog>;
  changelogs: Array<Maybe<Changelog>>;
  changelogs_connection?: Maybe<ChangelogEntityResponseCollection>;
  currencies: Array<Maybe<Currency>>;
  currencies_connection?: Maybe<CurrencyEntityResponseCollection>;
  currency?: Maybe<Currency>;
  feature?: Maybe<Feature>;
  features: Array<Maybe<Feature>>;
  featuresPage?: Maybe<FeaturesPage>;
  featuresPages: Array<Maybe<FeaturesPage>>;
  featuresPages_connection?: Maybe<FeaturesPageEntityResponseCollection>;
  features_connection?: Maybe<FeatureEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  legalPage?: Maybe<LegalPage>;
  legalPages: Array<Maybe<LegalPage>>;
  legalPages_connection?: Maybe<LegalPageEntityResponseCollection>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturers: Array<Maybe<Manufacturer>>;
  manufacturers_connection?: Maybe<ManufacturerEntityResponseCollection>;
  marinedatacloudHomepage?: Maybe<MarinedatacloudHomepage>;
  me?: Maybe<UsersPermissionsMe>;
  newsItem?: Maybe<NewsItem>;
  newsItems: Array<Maybe<NewsItem>>;
  newsItems_connection?: Maybe<NewsItemEntityResponseCollection>;
  plan?: Maybe<Plan>;
  plans: Array<Maybe<Plan>>;
  plans_connection?: Maybe<PlanEntityResponseCollection>;
  post?: Maybe<Post>;
  postCategories: Array<Maybe<PostCategory>>;
  postCategories_connection?: Maybe<PostCategoryEntityResponseCollection>;
  postCategory?: Maybe<PostCategory>;
  postTag?: Maybe<PostTag>;
  postTags: Array<Maybe<PostTag>>;
  postTags_connection?: Maybe<PostTagEntityResponseCollection>;
  posts: Array<Maybe<Post>>;
  posts_connection?: Maybe<PostEntityResponseCollection>;
  pricingPage?: Maybe<PricingPage>;
  publisherAction?: Maybe<PublisherAction>;
  publisherActions: Array<Maybe<PublisherAction>>;
  publisherActions_connection?: Maybe<PublisherActionEntityResponseCollection>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  theboatappHomepage?: Maybe<TheboatappHomepage>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  userFavoriteBoat?: Maybe<UserFavoriteBoat>;
  userFavoriteBoats: Array<Maybe<UserFavoriteBoat>>;
  userFavoriteBoats_connection?: Maybe<UserFavoriteBoatEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};

export type QueryAnnouncementArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAnnouncementsArgs = {
  filters?: InputMaybe<AnnouncementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryAnnouncements_ConnectionArgs = {
  filters?: InputMaybe<AnnouncementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryApplicationArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryApplicationsArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryApplications_ConnectionArgs = {
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatDesignerArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatDesignersArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatDesigners_ConnectionArgs = {
  filters?: InputMaybe<BoatDesignerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsArgs = {
  filters?: InputMaybe<BoatFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsActivitiesArgs = {
  filters?: InputMaybe<BoatsActivityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsActivities_ConnectionArgs = {
  filters?: InputMaybe<BoatsActivityFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsActivityArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsCategoriesArgs = {
  filters?: InputMaybe<BoatsCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsCategories_ConnectionArgs = {
  filters?: InputMaybe<BoatsCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsCategoryArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsHullMaterialArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsHullMaterialsArgs = {
  filters?: InputMaybe<BoatsHullMaterialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsHullMaterials_ConnectionArgs = {
  filters?: InputMaybe<BoatsHullMaterialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsHullTypeArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsHullTypesArgs = {
  filters?: InputMaybe<BoatsHullTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsHullTypes_ConnectionArgs = {
  filters?: InputMaybe<BoatsHullTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsTypeArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsTypesArgs = {
  filters?: InputMaybe<BoatsTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoatsTypes_ConnectionArgs = {
  filters?: InputMaybe<BoatsTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryBoats_ConnectionArgs = {
  filters?: InputMaybe<BoatFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryChangelogArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryChangelogsArgs = {
  filters?: InputMaybe<ChangelogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryChangelogs_ConnectionArgs = {
  filters?: InputMaybe<ChangelogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCurrenciesArgs = {
  filters?: InputMaybe<CurrencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCurrencies_ConnectionArgs = {
  filters?: InputMaybe<CurrencyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryCurrencyArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFeatureArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFeaturesArgs = {
  filters?: InputMaybe<FeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFeaturesPageArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFeaturesPagesArgs = {
  filters?: InputMaybe<FeaturesPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFeaturesPages_ConnectionArgs = {
  filters?: InputMaybe<FeaturesPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryFeatures_ConnectionArgs = {
  filters?: InputMaybe<FeatureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLegalPageArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLegalPagesArgs = {
  filters?: InputMaybe<LegalPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryLegalPages_ConnectionArgs = {
  filters?: InputMaybe<LegalPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryManufacturerArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryManufacturersArgs = {
  filters?: InputMaybe<ManufacturerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryManufacturers_ConnectionArgs = {
  filters?: InputMaybe<ManufacturerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryMarinedatacloudHomepageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsItemArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsItemsArgs = {
  filters?: InputMaybe<NewsItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryNewsItems_ConnectionArgs = {
  filters?: InputMaybe<NewsItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPlanArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPlansArgs = {
  filters?: InputMaybe<PlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPlans_ConnectionArgs = {
  filters?: InputMaybe<PlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostCategoriesArgs = {
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostCategories_ConnectionArgs = {
  filters?: InputMaybe<PostCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostCategoryArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostTagArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostTagsArgs = {
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostTags_ConnectionArgs = {
  filters?: InputMaybe<PostTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPostsArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPosts_ConnectionArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPricingPageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPublisherActionArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPublisherActionsArgs = {
  filters?: InputMaybe<PublisherActionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryPublisherActions_ConnectionArgs = {
  filters?: InputMaybe<PublisherActionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryTheboatappHomepageArgs = {
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUserFavoriteBoatArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUserFavoriteBoatsArgs = {
  filters?: InputMaybe<UserFavoriteBoatFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUserFavoriteBoats_ConnectionArgs = {
  filters?: InputMaybe<UserFavoriteBoatFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TheboatappHomepage = {
  __typename?: 'TheboatappHomepage';
  availableOn: ComponentTbaLandingSectionsAvailableOn;
  checklistCarousel: ComponentBlocksSectionTitle;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  featuresCarousel: ComponentBlocksSectionTitle;
  imagesGridWithVideo: ComponentTbaLandingSectionsImagesGridWithVideo;
  joinUs: ComponentTbaLandingSectionsJoinUs;
  pageCover: ComponentTbaLandingSectionsPageCover;
  pricingCards: ComponentBlocksSectionTitle;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showcase: ComponentTbaLandingSectionsShowcase;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TheboatappHomepageInput = {
  availableOn?: InputMaybe<ComponentTbaLandingSectionsAvailableOnInput>;
  checklistCarousel?: InputMaybe<ComponentBlocksSectionTitleInput>;
  featuresCarousel?: InputMaybe<ComponentBlocksSectionTitleInput>;
  imagesGridWithVideo?: InputMaybe<ComponentTbaLandingSectionsImagesGridWithVideoInput>;
  joinUs?: InputMaybe<ComponentTbaLandingSectionsJoinUsInput>;
  pageCover?: InputMaybe<ComponentTbaLandingSectionsPageCoverInput>;
  pricingCards?: InputMaybe<ComponentBlocksSectionTitleInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showcase?: InputMaybe<ComponentTbaLandingSectionsShowcaseInput>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<UploadFile>;
};

export type UserFavoriteBoat = {
  __typename?: 'UserFavoriteBoat';
  boats: Array<Maybe<Boat>>;
  boats_connection?: Maybe<BoatRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type UserFavoriteBoatBoatsArgs = {
  filters?: InputMaybe<BoatFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserFavoriteBoatBoats_ConnectionArgs = {
  filters?: InputMaybe<BoatFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserFavoriteBoatEntityResponseCollection = {
  __typename?: 'UserFavoriteBoatEntityResponseCollection';
  nodes: Array<UserFavoriteBoat>;
  pageInfo: Pagination;
};

export type UserFavoriteBoatFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UserFavoriteBoatFiltersInput>>>;
  boats?: InputMaybe<BoatFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UserFavoriteBoatFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserFavoriteBoatFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
};

export type UserFavoriteBoatInput = {
  boats?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type GetAnnouncementsVariables = Exact<{
  appCode?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type GetAnnouncements = {
  __typename?: 'Query';
  announcements: Array<{
    __typename?: 'Announcement';
    documentId: string;
    title?: string;
    description?: string;
    level?: Enum_Announcement_Level;
    action_title?: string;
    action_link?: string;
    expiration_date?: any;
    applications: Array<{ __typename?: 'Application'; documentId: string; code: string }>;
  }>;
};

export type GetApplicationsInfoVariables = Exact<{
  filters?: InputMaybe<ApplicationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  publicationStatus?: InputMaybe<PublicationStatus>;
}>;

export type GetApplicationsInfo = {
  __typename?: 'Query';
  applications: Array<{
    __typename?: 'Application';
    documentId: string;
    name: string;
    code: string;
    currentVersion: string;
    updateRequired: boolean;
  }>;
};

export type GetBoatsActivitiesVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BoatsActivityFiltersInput>;
}>;

export type GetBoatsActivities = {
  __typename?: 'Query';
  boatsActivities: Array<{
    __typename?: 'BoatsActivity';
    documentId: string;
    name: string;
    slug?: string;
    lumen_ref_id?: any;
    description?: string;
    coverImage?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
  }>;
};

export type GetAllBoatsActivitiesIdVariables = Exact<{ [key: string]: never }>;

export type GetAllBoatsActivitiesId = {
  __typename?: 'Query';
  boatsActivities: Array<{ __typename?: 'BoatsActivity'; documentId: string; name: string; slug?: string }>;
};

export type GetBoatsActivityBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetBoatsActivityBySlug = {
  __typename?: 'Query';
  boatsActivities: Array<{
    __typename?: 'BoatsActivity';
    documentId: string;
    name: string;
    slug?: string;
    lumen_ref_id?: any;
    description?: string;
    coverImage?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
  }>;
};

export type GetBoatsCategoriesVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetBoatsCategories = {
  __typename?: 'Query';
  boatsCategories: Array<{
    __typename?: 'BoatsCategory';
    documentId: string;
    name: string;
    slug: string;
    lumen_ref_id?: any;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type GetAllBoatsCategoriesIdVariables = Exact<{ [key: string]: never }>;

export type GetAllBoatsCategoriesId = {
  __typename?: 'Query';
  boatsCategories: Array<{ __typename?: 'BoatsCategory'; documentId: string; name: string; slug: string }>;
};

export type GetBoatsCategoriesBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetBoatsCategoriesBySlug = {
  __typename?: 'Query';
  boatsCategories: Array<{
    __typename?: 'BoatsCategory';
    documentId: string;
    name: string;
    slug: string;
    lumen_ref_id?: any;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type AllBoatsCategoriesWithLumenIdQueryVariables = Exact<{ [key: string]: never }>;

export type AllBoatsCategoriesWithLumenIdQuery = {
  __typename?: 'Query';
  boatsCategories: Array<{
    __typename?: 'BoatsCategory';
    documentId: string;
    name: string;
    slug: string;
    lumen_ref_id?: any;
  }>;
};

export type AllBoatsActivitiesWithLumenIdQueryVariables = Exact<{ [key: string]: never }>;

export type AllBoatsActivitiesWithLumenIdQuery = {
  __typename?: 'Query';
  boatsActivities: Array<{
    __typename?: 'BoatsActivity';
    documentId: string;
    name: string;
    slug?: string;
    lumen_ref_id?: any;
  }>;
};

export type GetBoatsTypesVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetBoatsTypes = {
  __typename?: 'Query';
  boatsTypes: Array<{
    __typename?: 'BoatsType';
    documentId: string;
    name: string;
    slug: string;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type GetAllBoatsTypesIdVariables = Exact<{ [key: string]: never }>;

export type GetAllBoatsTypesId = {
  __typename?: 'Query';
  boatsTypes: Array<{ __typename?: 'BoatsType'; documentId: string; name: string; slug: string }>;
};

export type GetBoatsTypesBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetBoatsTypesBySlug = {
  __typename?: 'Query';
  boatsTypes: Array<{
    __typename?: 'BoatsType';
    documentId: string;
    name: string;
    slug: string;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type GetChangelogsVariables = Exact<{
  code: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type GetChangelogs = {
  __typename?: 'Query';
  changelogs_connection?: {
    __typename?: 'ChangelogEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Changelog';
      documentId: string;
      title: string;
      subtitle?: string;
      date?: any;
      version: string;
      description?: Array<{
        __typename?: 'ComponentBlocksDescription';
        id: string;
        type: Enum_Componentblocksdescription_Type;
        details: string;
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetUserFavoriteBoatsVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUserFavoriteBoats = {
  __typename?: 'Query';
  userFavoriteBoats: Array<{
    __typename?: 'UserFavoriteBoat';
    documentId: string;
    boats: Array<{ __typename?: 'Boat'; documentId: string }>;
  }>;
};

export type GetFeaturesPageSlugsVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  appCode: Scalars['String']['input'];
}>;

export type GetFeaturesPageSlugs = {
  __typename?: 'Query';
  featuresPages: Array<{ __typename?: 'FeaturesPage'; documentId: string; slug: string }>;
};

export type GetFeaturePageBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetFeaturePageBySlug = {
  __typename?: 'Query';
  featuresPages: Array<{
    __typename?: 'FeaturesPage';
    documentId: string;
    slug: string;
    title: string;
    subtitle: string;
    description?: string;
    youtube_video_url?: string;
    icon?: { __typename?: 'ComponentSharedIcon'; name?: Enum_Componentsharedicon_Name };
    image?: { __typename?: 'UploadFile'; documentId: string; url: string; alternativeText?: string };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type GetMenuFeaturedPagesVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  appCode: Scalars['String']['input'];
}>;

export type GetMenuFeaturedPages = {
  __typename?: 'Query';
  featuresPages: Array<{
    __typename?: 'FeaturesPage';
    documentId: string;
    slug: string;
    title: string;
    description?: string;
    image?: {
      __typename?: 'UploadFile';
      documentId: string;
      url: string;
      alternativeText?: string;
      width?: number;
      height?: number;
    };
    icon?: { __typename?: 'ComponentSharedIcon'; id: string; name?: Enum_Componentsharedicon_Name };
  }>;
};

export type FullBoatFragment = {
  __typename?: 'Boat';
  lumen_ref_user_id?: any;
  documentId: string;
  top_speed?: number;
  description?: string;
  enable_description: boolean;
  notes?: string;
  mast?: number;
  loa?: number;
  lwl?: number;
  boa?: number;
  bcl?: number;
  bh?: number;
  headroom?: number;
  bdcl?: number;
  nom?: number;
  model?: string;
  draft_max?: number;
  draft_min?: number;
  year_first?: number;
  year_last?: number;
  displacement?: number;
  ballast_type?: string;
  ballast_weight?: number;
  sail_area_displacement?: number;
  ballast_displacement?: number;
  csf?: number;
  slug?: string;
  sspd?: number;
  ksi?: number;
  displacement_hull_speed?: number;
  displacement_length?: number;
  status?: boolean;
  approved_at?: any;
  views_count?: number;
  unique_views_count?: number;
  is_featured?: boolean;
  cruising_speed?: number;
  version?: string;
  helm?: string;
  rudder?: string;
  cockpit_type?: string;
  cockpit_location?: string;
  unsinkable?: boolean;
  trailerable?: boolean;
  rotating_spars?: boolean;
  mast_configuration?: string;
  spars?: string;
  standing_rigging?: string;
  spreaders_level?: number;
  spreaders_angle?: string;
  upwind_sail_area?: number;
  downwind_sail_area?: number;
  upwind_sail_area_displacement?: number;
  downwind_sail_area_displacement?: number;
  keel_type?: Enum_Boat_Keel_Type;
  cabins?: number;
  berths?: number;
  heads?: number;
  tonnage_gross?: number;
  tonnage_net?: number;
  favorites_count?: number;
  type?: { __typename?: 'BoatsType'; documentId: string; name: string; slug: string; description?: string };
  hull_type?: { __typename?: 'BoatsHullType'; documentId: string; name: string; slug: string; description?: string };
  hull_material?: { __typename?: 'BoatsHullMaterial'; documentId: string; name: string; slug: string };
  ce_classification?: { __typename?: 'ComponentBoatsCeClassification'; a?: number; b?: number; c?: number; d?: number };
  engine?: Array<{
    __typename?: 'ComponentBoatsEngine';
    id: string;
    drive?: Enum_Componentboatsengine_Drive;
    fuel?: Enum_Componentboatsengine_Fuel;
    maker?: string;
    model?: string;
    power?: string;
    power_type?: Enum_Componentboatsengine_Power_Type;
    type?: string;
    website?: string;
  }>;
  water_heater?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
  fuel_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
  water_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
  holding_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
  manufacturer?: { __typename?: 'Manufacturer'; documentId: string; name: string; website?: string; slug: string };
  reference_price?: {
    __typename?: 'ComponentBoatsPrice';
    id: string;
    amount?: number;
    currency?: {
      __typename?: 'Currency';
      documentId: string;
      name: string;
      iso_code: string;
      symbol: string;
      iso_code_num: string;
    };
  };
  categories: Array<{
    __typename?: 'BoatsCategory';
    documentId: string;
    lumen_ref_id?: any;
    name: string;
    slug: string;
    publicBoatsCount: number;
  }>;
  hull_appendages?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
  mainsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
  headsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
  spinnaker?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
  activities: Array<{
    __typename?: 'BoatsActivity';
    documentId: string;
    name: string;
    slug?: string;
    lumen_ref_id?: any;
    description?: string;
    coverImage?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
  }>;
  image?: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    previewUrl?: string;
    provider: string;
    alternativeText?: string;
    caption?: string;
    size: number;
  };
  files: Array<{
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    previewUrl?: string;
    provider: string;
    alternativeText?: string;
    caption?: string;
    size: number;
  }>;
  boatDocuments: Array<{
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    previewUrl?: string;
    alternativeText?: string;
    caption?: string;
    size: number;
    createdAt?: any;
  }>;
  boat_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
  boat_interior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
  boat_exterior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
  documents?: Array<{
    __typename?: 'ComponentBoatsDocuments';
    id: string;
    tags: any;
    file: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      mime: string;
      size: number;
      ext?: string;
    };
  }>;
};

export type BoatCardEntityResponseCollectionFragment = {
  __typename?: 'BoatEntityResponseCollection';
  nodes: Array<{
    __typename?: 'Boat';
    documentId: string;
    slug?: string;
    model?: string;
    year_first?: number;
    views_count?: number;
    manufacturer?: { __typename?: 'Manufacturer'; name: string };
    image?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    };
    documents?: Array<{
      __typename?: 'ComponentBoatsDocuments';
      id: string;
      tags: any;
      file: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        size: number;
        ext?: string;
        mime: string;
      };
    }>;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type BoatCardFragment = {
  __typename?: 'Boat';
  documentId: string;
  slug?: string;
  model?: string;
  year_first?: number;
  views_count?: number;
  manufacturer?: { __typename?: 'Manufacturer'; name: string };
  image?: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    previewUrl?: string;
    provider: string;
    alternativeText?: string;
    caption?: string;
    size: number;
  };
  documents?: Array<{
    __typename?: 'ComponentBoatsDocuments';
    id: string;
    tags: any;
    file: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      size: number;
      ext?: string;
      mime: string;
    };
  }>;
};

export type BoatsActivityRelationResponseCollectionFragment = {
  __typename?: 'BoatsActivityRelationResponseCollection';
  nodes: Array<{
    __typename?: 'BoatsActivity';
    documentId: string;
    name: string;
    slug?: string;
    lumen_ref_id?: any;
    description?: string;
    coverImage?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
  }>;
};

export type BoatsActivityFragment = {
  __typename?: 'BoatsActivity';
  documentId: string;
  name: string;
  slug?: string;
  lumen_ref_id?: any;
  description?: string;
  coverImage?: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
};

export type BoatsCategoryRelationResponseCollectionFragment = {
  __typename?: 'BoatsCategoryRelationResponseCollection';
  nodes: Array<{
    __typename?: 'BoatsCategory';
    documentId: string;
    name: string;
    slug: string;
    lumen_ref_id?: any;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type BoatsCategoryFragment = {
  __typename?: 'BoatsCategory';
  documentId: string;
  name: string;
  slug: string;
  lumen_ref_id?: any;
  description?: string;
  publicBoatsCount: number;
};

export type BoatsHullMaterialEntityResponseFragment = {
  __typename?: 'BoatsHullMaterialEntityResponseCollection';
  nodes: Array<{
    __typename?: 'BoatsHullMaterial';
    documentId: string;
    name: string;
    slug: string;
    publicBoatsCount: number;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type BoatsHullMaterialFragment = {
  __typename?: 'BoatsHullMaterial';
  documentId: string;
  name: string;
  slug: string;
  publicBoatsCount: number;
};

export type BoatsHullTypeEntityResponseFragment = {
  __typename?: 'BoatsHullTypeEntityResponseCollection';
  nodes: Array<{
    __typename?: 'BoatsHullType';
    documentId: string;
    name: string;
    slug: string;
    description?: string;
    publicBoatsCount: number;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type BoatsHullTypeFragment = {
  __typename?: 'BoatsHullType';
  documentId: string;
  name: string;
  slug: string;
  description?: string;
  publicBoatsCount: number;
};

export type BoatsTypeEntityResponseFragment = {
  __typename?: 'BoatsTypeEntityResponseCollection';
  nodes: Array<{
    __typename?: 'BoatsType';
    documentId: string;
    name: string;
    slug: string;
    description?: string;
    publicBoatsCount: number;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type BoatsTypeFragment = {
  __typename?: 'BoatsType';
  documentId: string;
  name: string;
  slug: string;
  description?: string;
  publicBoatsCount: number;
};

export type FeaturePageFragment = {
  __typename?: 'FeaturesPage';
  documentId: string;
  slug: string;
  title: string;
  subtitle: string;
  description?: string;
  youtube_video_url?: string;
  icon?: { __typename?: 'ComponentSharedIcon'; name?: Enum_Componentsharedicon_Name };
  image?: { __typename?: 'UploadFile'; documentId: string; url: string; alternativeText?: string };
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
};

export type UploadFileRelationResponseCollectionFragment = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<{
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  }>;
};

export type UploadFileEntityResponseFragment = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<{
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type UploadFileEntityFragment = {
  __typename?: 'UploadFile';
  documentId: string;
  name: string;
  url: string;
  alternativeText?: string;
  size: number;
};

export type LegalPageResponseFragment = {
  __typename?: 'LegalPageEntityResponseCollection';
  nodes: Array<{
    __typename?: 'LegalPage';
    documentId: string;
    title?: string;
    slug?: string;
    content?: Array<{ __typename?: 'ComponentBlocksSectionTitle'; id: string; title: string; description?: string }>;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type LegalPageFragment = {
  __typename?: 'LegalPage';
  documentId: string;
  title?: string;
  slug?: string;
  content?: Array<{ __typename?: 'ComponentBlocksSectionTitle'; id: string; title: string; description?: string }>;
};

export type ManufacturerEntityResponseCollectionFragment = {
  __typename?: 'ManufacturerEntityResponseCollection';
  nodes: Array<{
    __typename?: 'Manufacturer';
    documentId: string;
    name: string;
    website?: string;
    lumen_ref_id?: any;
    description?: string;
    slug: string;
    logo?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type FullManufacturerFragment = {
  __typename?: 'Manufacturer';
  documentId: string;
  name: string;
  website?: string;
  lumen_ref_id?: any;
  description?: string;
  slug: string;
  logo?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
};

export type ComponentBoatsNameValueFragment = {
  __typename?: 'ComponentBoatsNameValue';
  id: string;
  name?: string;
  value?: string;
};

export type FullNewsFragment = {
  __typename?: 'NewsItem';
  documentId: string;
  slug: string;
  title: string;
  excerpt: string;
  showPublishDate?: boolean;
  publishDate?: any;
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
  featuredImage: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
};

export type NewsCardEntityResponseCollectionFragment = {
  __typename?: 'NewsItemEntityResponseCollection';
  nodes: Array<{
    __typename?: 'NewsItem';
    documentId: string;
    title: string;
    slug: string;
    excerpt: string;
    featuredImage: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type NewsCardFragment = {
  __typename?: 'NewsItem';
  documentId: string;
  title: string;
  slug: string;
  excerpt: string;
  featuredImage: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
};

export type PaginationFragment = {
  __typename?: 'Pagination';
  total: number;
  page: number;
  pageSize: number;
  pageCount: number;
};

export type PlanFragment = {
  __typename?: 'Plan';
  documentId: string;
  title?: string;
  description?: string;
  order: number;
  recurrence?: string;
  price?: {
    __typename?: 'ComponentBoatsPrice';
    amount?: number;
    currency?: { __typename?: 'Currency'; documentId: string; symbol: string; name: string };
  };
  icon?: { __typename?: 'ComponentSharedIcon'; id: string; name?: Enum_Componentsharedicon_Name };
};

export type PostEntityResponseFragment = {
  __typename?: 'PostEntityResponseCollection';
  nodes: Array<{
    __typename?: 'Post';
    documentId: string;
    title: string;
    slug: string;
    showPublishDate: boolean;
    publishDate?: any;
    excerpt?: string;
    reading_time?: number;
    application?: {
      __typename?: 'Application';
      documentId: string;
      name: string;
      code: string;
      description: string;
      logo?: { __typename?: 'UploadFile'; documentId: string; url: string; name: string; alternativeText?: string };
    };
    featuredImage: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
    content: Array<
      | {
          __typename?: 'ComponentBlocksImage';
          id: string;
          alt?: string;
          image?: {
            __typename?: 'UploadFile';
            documentId: string;
            name: string;
            url: string;
            alternativeText?: string;
            size: number;
          };
        }
      | { __typename?: 'ComponentBlocksRichText'; id: string; richtext?: string }
      | { __typename?: 'Error' }
    >;
    post_categories: Array<{
      __typename?: 'PostCategory';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
      tbaPostsCount: number;
      tbdPostsCount: number;
      parent_category?: {
        __typename?: 'PostCategory';
        documentId: string;
        slug: string;
        name?: string;
        description?: string;
      };
      seo?: {
        __typename?: 'ComponentSharedSeo';
        id: string;
        metaTitle?: string;
        metaDescription?: string;
        keywords?: string;
        metaRobots?: string;
        structuredData?: any;
        metaViewport?: string;
        canonicalURL?: string;
        metaImage?: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          alternativeText?: string;
        };
      };
    }>;
    post_tags: Array<{
      __typename?: 'PostTag';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
      tbaPostsCount: number;
      tbdPostsCount: number;
    }>;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type PostFragment = {
  __typename?: 'Post';
  documentId: string;
  title: string;
  slug: string;
  showPublishDate: boolean;
  publishDate?: any;
  excerpt?: string;
  reading_time?: number;
  application?: {
    __typename?: 'Application';
    documentId: string;
    name: string;
    code: string;
    description: string;
    logo?: { __typename?: 'UploadFile'; documentId: string; url: string; name: string; alternativeText?: string };
  };
  featuredImage: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
  content: Array<
    | {
        __typename?: 'ComponentBlocksImage';
        id: string;
        alt?: string;
        image?: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          alternativeText?: string;
          size: number;
        };
      }
    | { __typename?: 'ComponentBlocksRichText'; id: string; richtext?: string }
    | { __typename?: 'Error' }
  >;
  post_categories: Array<{
    __typename?: 'PostCategory';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    parent_category?: {
      __typename?: 'PostCategory';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
    };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
  post_tags: Array<{
    __typename?: 'PostTag';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
  }>;
};

export type PostCardFragment = {
  __typename?: 'Post';
  documentId: string;
  title: string;
  slug: string;
  publishedAt?: any;
  publishDate?: any;
  excerpt?: string;
  reading_time?: number;
  showPublishDate: boolean;
  content: Array<
    { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
  >;
  post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string }>;
  featuredImage: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
};

export type RecentPostFragment = {
  __typename?: 'Post';
  documentId: string;
  title: string;
  slug: string;
  excerpt?: string;
  reading_time?: number;
  featuredImage: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
};

export type RecentPostCardFragment = {
  __typename?: 'Post';
  documentId: string;
  title: string;
  slug: string;
  excerpt?: string;
  reading_time?: number;
  publishDate?: any;
  showPublishDate: boolean;
  content: Array<
    { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
  >;
  post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string; slug: string }>;
  featuredImage: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
};

export type PostCategoryRelationResponseCollectionFragment = {
  __typename?: 'PostCategoryRelationResponseCollection';
  nodes: Array<{
    __typename?: 'PostCategory';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    parent_category?: {
      __typename?: 'PostCategory';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
    };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type PostCategoryEntityResponseFragment = {
  __typename?: 'PostCategoryEntityResponseCollection';
  nodes: Array<{
    __typename?: 'PostCategory';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    parent_category?: {
      __typename?: 'PostCategory';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
    };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type PostCategoryEntityFragment = {
  __typename?: 'PostCategory';
  documentId: string;
  slug: string;
  name?: string;
  description?: string;
  tbaPostsCount: number;
  tbdPostsCount: number;
  parent_category?: {
    __typename?: 'PostCategory';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
  };
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
};

export type CategoryPageFragment = {
  __typename?: 'PostCategory';
  documentId: string;
  slug: string;
  name?: string;
  description?: string;
  tbaPostsCount: number;
  tbdPostsCount: number;
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
};

export type ComponentBoatsTankFragment = { __typename?: 'ComponentBoatsTank'; id: string; capacity?: string };

export type PricingPageFragment = {
  __typename?: 'PricingPage';
  title?: string;
  description?: string;
  faq_title?: string;
  FAQ?: Array<
    | {
        __typename?: 'ComponentBlocksCommonAskedQuestions';
        question?: string;
        answer?: string;
        name?: string;
        order: number;
        id: string;
      }
    | { __typename?: 'Error' }
  >;
  featuredImage?: {
    __typename?: 'UploadFile';
    documentId: string;
    name: string;
    url: string;
    alternativeText?: string;
    size: number;
  };
  reachSectionTitle?: { __typename?: 'ComponentBlocksRichSectionTitle'; title?: string; description: string };
  featuresTitle?: { __typename?: 'ComponentBlocksSectionTitle'; title: string; description?: string };
  comparePlansTitle?: { __typename?: 'ComponentBlocksSectionTitle'; title: string; description?: string };
  planCards?: Array<{
    __typename?: 'ComponentPricingPagePlanCards';
    id: string;
    planName: string;
    price?: string;
    recurrance?: string;
    features?: string;
    iconName?: string;
    description?: string;
  }>;
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
};

export type SeoFragment = {
  __typename?: 'ComponentSharedSeo';
  id: string;
  metaTitle?: string;
  metaDescription?: string;
  keywords?: string;
  metaRobots?: string;
  structuredData?: any;
  metaViewport?: string;
  canonicalURL?: string;
  metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
};

export type PostTagRelationResponseCollectionFragment = {
  __typename?: 'PostTagRelationResponseCollection';
  nodes: Array<{
    __typename?: 'PostTag';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type PostTagEntityResponseFragment = {
  __typename?: 'PostTagEntityResponseCollection';
  nodes: Array<{
    __typename?: 'PostTag';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type PostTagEntityFragment = {
  __typename?: 'PostTag';
  documentId: string;
  slug: string;
  name?: string;
  description?: string;
  tbaPostsCount: number;
  tbdPostsCount: number;
  seo?: {
    __typename?: 'ComponentSharedSeo';
    id: string;
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string;
    metaRobots?: string;
    structuredData?: any;
    metaViewport?: string;
    canonicalURL?: string;
    metaImage?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
  };
};

export type ComponentBoatsPriceFragment = {
  __typename?: 'ComponentBoatsPrice';
  id: string;
  amount?: number;
  currency?: {
    __typename?: 'Currency';
    documentId: string;
    name: string;
    iso_code: string;
    symbol: string;
    iso_code_num: string;
  };
};

export type CurrencyEntityResponseFragment = {
  __typename?: 'CurrencyEntityResponseCollection';
  nodes: Array<{
    __typename?: 'Currency';
    documentId: string;
    name: string;
    iso_code: string;
    symbol: string;
    iso_code_num: string;
  }>;
  pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
};

export type CurrencyFragment = {
  __typename?: 'Currency';
  documentId: string;
  name: string;
  iso_code: string;
  symbol: string;
  iso_code_num: string;
};

export type GetBoatsHullTypesVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetBoatsHullTypes = {
  __typename?: 'Query';
  boatsHullTypes: Array<{
    __typename?: 'BoatsHullType';
    documentId: string;
    name: string;
    slug: string;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type GetAllBoatsHullTypesIdVariables = Exact<{ [key: string]: never }>;

export type GetAllBoatsHullTypesId = {
  __typename?: 'Query';
  boatsHullTypes: Array<{ __typename?: 'BoatsHullType'; documentId: string; name: string; slug: string }>;
};

export type GetBoatsHullTypesBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetBoatsHullTypesBySlug = {
  __typename?: 'Query';
  boatsHullTypes: Array<{
    __typename?: 'BoatsHullType';
    documentId: string;
    name: string;
    slug: string;
    description?: string;
    publicBoatsCount: number;
  }>;
};

export type GetTheboatappHomepageVariables = Exact<{ [key: string]: never }>;

export type GetTheboatappHomepage = {
  __typename?: 'Query';
  theboatappHomepage?: {
    __typename?: 'TheboatappHomepage';
    documentId: string;
    pageCover: {
      __typename?: 'ComponentTbaLandingSectionsPageCover';
      id: string;
      title: string;
      description: string;
      getStartedLink: string;
      image: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
    availableOn: {
      __typename?: 'ComponentTbaLandingSectionsAvailableOn';
      id: string;
      title: string;
      coverImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        alternativeText?: string;
        url: string;
      };
      availableonOptions?: Array<{
        __typename?: 'ComponentBlocksAvailableonOptions';
        id: string;
        title?: string;
        availableonImage?: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          alternativeText?: string;
          url: string;
        };
      }>;
    };
    imagesGridWithVideo: {
      __typename?: 'ComponentTbaLandingSectionsImagesGridWithVideo';
      id: string;
      title: string;
      description: string;
      videoUrl?: string;
      gridImages: Array<{
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        alternativeText?: string;
        url: string;
      }>;
    };
    featuresCarousel: { __typename?: 'ComponentBlocksSectionTitle'; id: string; title: string; description?: string };
    checklistCarousel: { __typename?: 'ComponentBlocksSectionTitle'; id: string; title: string; description?: string };
    pricingCards: { __typename?: 'ComponentBlocksSectionTitle'; id: string; title: string; description?: string };
    showcase: {
      __typename?: 'ComponentTbaLandingSectionsShowcase';
      id: string;
      title: string;
      description: string;
      getStartedLink: string;
      image: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
    joinUs: {
      __typename?: 'ComponentTbaLandingSectionsJoinUs';
      id: string;
      title: string;
      description: string;
      joinUrl: string;
    };
  };
};

export type GetMarinedatacloudHomepageVariables = Exact<{ [key: string]: never }>;

export type GetMarinedatacloudHomepage = {
  __typename?: 'Query';
  marinedatacloudHomepage?: {
    __typename?: 'MarinedatacloudHomepage';
    documentId: string;
    pageCover: {
      __typename?: 'ComponentMdcLandingSectionsSlogan';
      id: string;
      title: string;
      description: string;
      appLinks?: Array<{
        __typename?: 'ComponentBlocksPlatformCard';
        id: string;
        description: string;
        url: string;
        image: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
      }>;
      image: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
    ourStory: {
      __typename?: 'ComponentMdcLandingSectionsStory';
      id: string;
      title: string;
      description: string;
      image: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
    mission: {
      __typename?: 'ComponentMdcLandingSectionsMission';
      id: string;
      label: string;
      title: string;
      description: string;
      image?: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
    vision: {
      __typename?: 'ComponentMdcLandingSectionsVision';
      id: string;
      label: string;
      title: string;
      description: string;
      image?: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
    values: { __typename?: 'ComponentMdcLandingSectionsValues'; id: string; title: string; description: string };
    workWithUs: {
      __typename?: 'ComponentMdcLandingSectionsWorkWithUs';
      id: string;
      title: string;
      description: string;
      image: { __typename?: 'UploadFile'; documentId: string; name: string; alternativeText?: string; url: string };
    };
  };
};

export type GetLegalPageBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetLegalPageBySlug = {
  __typename?: 'Query';
  legalPages: Array<{
    __typename?: 'LegalPage';
    documentId: string;
    title?: string;
    slug?: string;
    content?: Array<{ __typename?: 'ComponentBlocksSectionTitle'; id: string; title: string; description?: string }>;
  }>;
};

export type GetLegalPagesSlugsVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLegalPagesSlugs = {
  __typename?: 'Query';
  legalPages: Array<{ __typename?: 'LegalPage'; slug?: string }>;
};

export type GetManufacturersVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetManufacturers = {
  __typename?: 'Query';
  manufacturers_connection?: {
    __typename?: 'ManufacturerEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Manufacturer';
      documentId: string;
      name: string;
      website?: string;
      lumen_ref_id?: any;
      description?: string;
      slug: string;
      logo?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
      seo?: {
        __typename?: 'ComponentSharedSeo';
        id: string;
        metaTitle?: string;
        metaDescription?: string;
        keywords?: string;
        metaRobots?: string;
        structuredData?: any;
        metaViewport?: string;
        canonicalURL?: string;
        metaImage?: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          alternativeText?: string;
        };
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetManufacturersBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetManufacturersBySlug = {
  __typename?: 'Query';
  manufacturers_connection?: {
    __typename?: 'ManufacturerEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Manufacturer';
      documentId: string;
      name: string;
      website?: string;
      lumen_ref_id?: any;
      description?: string;
      slug: string;
      logo?: { __typename?: 'UploadFile'; documentId: string; name: string; url: string; alternativeText?: string };
      seo?: {
        __typename?: 'ComponentSharedSeo';
        id: string;
        metaTitle?: string;
        metaDescription?: string;
        keywords?: string;
        metaRobots?: string;
        structuredData?: any;
        metaViewport?: string;
        canonicalURL?: string;
        metaImage?: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          alternativeText?: string;
        };
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetAllNewsVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetAllNews = {
  __typename?: 'Query';
  newsItems_connection?: {
    __typename?: 'NewsItemEntityResponseCollection';
    nodes: Array<{
      __typename?: 'NewsItem';
      documentId: string;
      title: string;
      slug: string;
      excerpt: string;
      showPublishDate?: boolean;
      publishDate?: any;
      createdAt?: any;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetAllNewsSlugsVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type GetAllNewsSlugs = {
  __typename?: 'Query';
  newsItems_connection?: {
    __typename?: 'NewsItemEntityResponseCollection';
    nodes: Array<{ __typename?: 'NewsItem'; slug: string }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetSingleNewsVariables = Exact<{
  appCode: Scalars['String']['input'];
  newsSlug: Scalars['String']['input'];
}>;

export type GetSingleNews = {
  __typename?: 'Query';
  newsItems: Array<{
    __typename?: 'NewsItem';
    documentId: string;
    title: string;
    slug: string;
    excerpt: string;
    showPublishDate?: boolean;
    publishDate?: any;
    createdAt?: any;
    featuredImage: { __typename?: 'UploadFile'; documentId: string; url: string; alternativeText?: string };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      metaViewport?: string;
      canonicalURL?: string;
      structuredData?: any;
      metaImage?: { __typename?: 'UploadFile'; documentId: string; url: string; alternativeText?: string };
    };
    content?: Array<{ __typename: 'ComponentBlocksRichText'; id: string; richtext?: string } | { __typename: 'Error' }>;
  }>;
};

export type GetRecentNewsVariables = Exact<{
  appCode: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetRecentNews = {
  __typename?: 'Query';
  newsItems_connection?: {
    __typename?: 'NewsItemEntityResponseCollection';
    nodes: Array<{
      __typename?: 'NewsItem';
      documentId: string;
      title: string;
      slug: string;
      excerpt: string;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetNewsCardVariables = Exact<{
  appCode: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetNewsCard = {
  __typename?: 'Query';
  newsItems_connection?: {
    __typename?: 'NewsItemEntityResponseCollection';
    nodes: Array<{
      __typename?: 'NewsItem';
      documentId: string;
      title: string;
      slug: string;
      excerpt: string;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetPricingPlansVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPricingPlans = {
  __typename?: 'Query';
  plans: Array<{
    __typename?: 'Plan';
    documentId: string;
    title?: string;
    description?: string;
    order: number;
    recurrence?: string;
    price?: {
      __typename?: 'ComponentBoatsPrice';
      amount?: number;
      currency?: { __typename?: 'Currency'; documentId: string; symbol: string; name: string };
    };
    icon?: { __typename?: 'ComponentSharedIcon'; id: string; name?: Enum_Componentsharedicon_Name };
  }>;
};

export type GetPostsCategoriesVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
}>;

export type GetPostsCategories = {
  __typename?: 'Query';
  postCategories: Array<{
    __typename?: 'PostCategory';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    parent_category?: {
      __typename?: 'PostCategory';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
    };
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type GetPostsByCategoryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  appCode: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type GetPostsByCategory = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      publishedAt?: any;
      publishDate?: any;
      excerpt?: string;
      reading_time?: number;
      showPublishDate: boolean;
      content: Array<
        { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
      >;
      post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string }>;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetCategoryBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetCategoryBySlug = {
  __typename?: 'Query';
  postCategories: Array<{
    __typename?: 'PostCategory';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type GetTagsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
}>;

export type GetTags = {
  __typename?: 'Query';
  postTags: Array<{
    __typename?: 'PostTag';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type GetPostsByTagVariables = Exact<{
  tagSlug: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  appCode: Scalars['String']['input'];
}>;

export type GetPostsByTag = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      publishedAt?: any;
      publishDate?: any;
      excerpt?: string;
      reading_time?: number;
      showPublishDate: boolean;
      content: Array<
        { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
      >;
      post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string }>;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetTagBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetTagBySlug = {
  __typename?: 'Query';
  postTags: Array<{
    __typename?: 'PostTag';
    documentId: string;
    slug: string;
    name?: string;
    description?: string;
    tbaPostsCount: number;
    tbdPostsCount: number;
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  }>;
};

export type GetAllPostsSlugVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type GetAllPostsSlug = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{ __typename?: 'Post'; documentId: string; slug: string }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetAllPostsVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type GetAllPosts = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      showPublishDate: boolean;
      publishDate?: any;
      excerpt?: string;
      reading_time?: number;
      application?: {
        __typename?: 'Application';
        documentId: string;
        name: string;
        code: string;
        description: string;
        logo?: { __typename?: 'UploadFile'; documentId: string; url: string; name: string; alternativeText?: string };
      };
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
      content: Array<
        | {
            __typename?: 'ComponentBlocksImage';
            id: string;
            alt?: string;
            image?: {
              __typename?: 'UploadFile';
              documentId: string;
              name: string;
              url: string;
              alternativeText?: string;
              size: number;
            };
          }
        | { __typename?: 'ComponentBlocksRichText'; id: string; richtext?: string }
        | { __typename?: 'Error' }
      >;
      post_categories: Array<{
        __typename?: 'PostCategory';
        documentId: string;
        slug: string;
        name?: string;
        description?: string;
        tbaPostsCount: number;
        tbdPostsCount: number;
        parent_category?: {
          __typename?: 'PostCategory';
          documentId: string;
          slug: string;
          name?: string;
          description?: string;
        };
        seo?: {
          __typename?: 'ComponentSharedSeo';
          id: string;
          metaTitle?: string;
          metaDescription?: string;
          keywords?: string;
          metaRobots?: string;
          structuredData?: any;
          metaViewport?: string;
          canonicalURL?: string;
          metaImage?: {
            __typename?: 'UploadFile';
            documentId: string;
            name: string;
            url: string;
            alternativeText?: string;
          };
        };
      }>;
      post_tags: Array<{
        __typename?: 'PostTag';
        documentId: string;
        slug: string;
        name?: string;
        description?: string;
        tbaPostsCount: number;
        tbdPostsCount: number;
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetPostsCardVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetPostsCard = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      publishedAt?: any;
      publishDate?: any;
      excerpt?: string;
      reading_time?: number;
      showPublishDate: boolean;
      content: Array<
        { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
      >;
      post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string }>;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type SearchPostsVariables = Exact<{
  search: Scalars['String']['input'];
  appCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchPosts = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      publishedAt?: any;
      publishDate?: any;
      excerpt?: string;
      reading_time?: number;
      showPublishDate: boolean;
      content: Array<
        { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
      >;
      post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string }>;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetPostsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  appCode: Scalars['String']['input'];
}>;

export type GetPosts = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      showPublishDate: boolean;
      publishDate?: any;
      excerpt?: string;
      reading_time?: number;
      application?: {
        __typename?: 'Application';
        documentId: string;
        name: string;
        code: string;
        description: string;
        logo?: { __typename?: 'UploadFile'; documentId: string; url: string; name: string; alternativeText?: string };
      };
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
      content: Array<
        | {
            __typename?: 'ComponentBlocksImage';
            id: string;
            alt?: string;
            image?: {
              __typename?: 'UploadFile';
              documentId: string;
              name: string;
              url: string;
              alternativeText?: string;
              size: number;
            };
          }
        | { __typename?: 'ComponentBlocksRichText'; id: string; richtext?: string }
        | { __typename?: 'Error' }
      >;
      post_categories: Array<{
        __typename?: 'PostCategory';
        documentId: string;
        slug: string;
        name?: string;
        description?: string;
        tbaPostsCount: number;
        tbdPostsCount: number;
        parent_category?: {
          __typename?: 'PostCategory';
          documentId: string;
          slug: string;
          name?: string;
          description?: string;
        };
        seo?: {
          __typename?: 'ComponentSharedSeo';
          id: string;
          metaTitle?: string;
          metaDescription?: string;
          keywords?: string;
          metaRobots?: string;
          structuredData?: any;
          metaViewport?: string;
          canonicalURL?: string;
          metaImage?: {
            __typename?: 'UploadFile';
            documentId: string;
            name: string;
            url: string;
            alternativeText?: string;
          };
        };
      }>;
      post_tags: Array<{
        __typename?: 'PostTag';
        documentId: string;
        slug: string;
        name?: string;
        description?: string;
        tbaPostsCount: number;
        tbdPostsCount: number;
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetRecentPostsVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetRecentPosts = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      excerpt?: string;
      reading_time?: number;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetRecentPostsCardsVariables = Exact<{
  appCode: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetRecentPostsCards = {
  __typename?: 'Query';
  posts_connection?: {
    __typename?: 'PostEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Post';
      documentId: string;
      title: string;
      slug: string;
      excerpt?: string;
      reading_time?: number;
      publishDate?: any;
      showPublishDate: boolean;
      content: Array<
        { __typename: 'ComponentBlocksImage' } | { __typename: 'ComponentBlocksRichText' } | { __typename: 'Error' }
      >;
      post_categories: Array<{ __typename?: 'PostCategory'; documentId: string; name?: string; slug: string }>;
      featuredImage: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetPostBySlugVariables = Exact<{
  appCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;

export type GetPostBySlug = {
  __typename?: 'Query';
  posts: Array<{
    __typename?: 'Post';
    documentId: string;
    title: string;
    slug: string;
    showPublishDate: boolean;
    publishDate?: any;
    excerpt?: string;
    reading_time?: number;
    application?: {
      __typename?: 'Application';
      documentId: string;
      name: string;
      code: string;
      description: string;
      logo?: { __typename?: 'UploadFile'; documentId: string; url: string; name: string; alternativeText?: string };
    };
    featuredImage: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
    content: Array<
      | {
          __typename?: 'ComponentBlocksImage';
          id: string;
          alt?: string;
          image?: {
            __typename?: 'UploadFile';
            documentId: string;
            name: string;
            url: string;
            alternativeText?: string;
            size: number;
          };
        }
      | { __typename?: 'ComponentBlocksRichText'; id: string; richtext?: string }
      | { __typename?: 'Error' }
    >;
    post_categories: Array<{
      __typename?: 'PostCategory';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
      tbaPostsCount: number;
      tbdPostsCount: number;
      parent_category?: {
        __typename?: 'PostCategory';
        documentId: string;
        slug: string;
        name?: string;
        description?: string;
      };
      seo?: {
        __typename?: 'ComponentSharedSeo';
        id: string;
        metaTitle?: string;
        metaDescription?: string;
        keywords?: string;
        metaRobots?: string;
        structuredData?: any;
        metaViewport?: string;
        canonicalURL?: string;
        metaImage?: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          alternativeText?: string;
        };
      };
    }>;
    post_tags: Array<{
      __typename?: 'PostTag';
      documentId: string;
      slug: string;
      name?: string;
      description?: string;
      tbaPostsCount: number;
      tbdPostsCount: number;
    }>;
  }>;
};

export type GetPricingPageVariables = Exact<{
  publicationStatus?: InputMaybe<PublicationStatus>;
}>;

export type GetPricingPage = {
  __typename?: 'Query';
  pricingPage?: {
    __typename?: 'PricingPage';
    title?: string;
    description?: string;
    faq_title?: string;
    features: Array<{
      __typename?: 'Feature';
      documentId: string;
      title: string;
      description: string;
      badge?: string;
      order: number;
      group?: Enum_Feature_Group;
      link?: string;
      subGroup?: Enum_Feature_Subgroup;
      showOnCard: boolean;
      showOnCarousel: boolean;
      carouselDescription?: string;
      icon?: { __typename?: 'ComponentSharedIcon'; name?: Enum_Componentsharedicon_Name };
      availableOn?: Array<{
        __typename?: 'ComponentBlocksAvailableOn';
        id: string;
        availabilityTitle?: string;
        availabilitySubtitle?: string;
        cardTitle?: string;
        plan?: {
          __typename?: 'Plan';
          documentId: string;
          title?: string;
          description?: string;
          recurrence?: string;
          price?: {
            __typename?: 'ComponentBoatsPrice';
            amount?: number;
            currency?: { __typename?: 'Currency'; documentId: string; iso_code: string; symbol: string };
          };
          icon?: { __typename?: 'ComponentSharedIcon'; name?: Enum_Componentsharedicon_Name };
        };
      }>;
    }>;
    FAQ?: Array<
      | {
          __typename?: 'ComponentBlocksCommonAskedQuestions';
          question?: string;
          answer?: string;
          name?: string;
          order: number;
          id: string;
        }
      | { __typename?: 'Error' }
    >;
    featuredImage?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      alternativeText?: string;
      size: number;
    };
    reachSectionTitle?: { __typename?: 'ComponentBlocksRichSectionTitle'; title?: string; description: string };
    featuresTitle?: { __typename?: 'ComponentBlocksSectionTitle'; title: string; description?: string };
    comparePlansTitle?: { __typename?: 'ComponentBlocksSectionTitle'; title: string; description?: string };
    planCards?: Array<{
      __typename?: 'ComponentPricingPagePlanCards';
      id: string;
      planName: string;
      price?: string;
      recurrance?: string;
      features?: string;
      iconName?: string;
      description?: string;
    }>;
    seo?: {
      __typename?: 'ComponentSharedSeo';
      id: string;
      metaTitle?: string;
      metaDescription?: string;
      keywords?: string;
      metaRobots?: string;
      structuredData?: any;
      metaViewport?: string;
      canonicalURL?: string;
      metaImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
      };
    };
  };
};

export type GetManufacturerBoatsVariables = Exact<{
  manufacturerId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetManufacturerBoats = {
  __typename?: 'Query';
  boats_connection?: {
    __typename?: 'BoatEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Boat';
      documentId: string;
      slug?: string;
      model?: string;
      year_first?: number;
      views_count?: number;
      manufacturer?: { __typename?: 'Manufacturer'; name: string };
      image?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        previewUrl?: string;
        provider: string;
        alternativeText?: string;
        caption?: string;
        size: number;
      };
      documents?: Array<{
        __typename?: 'ComponentBoatsDocuments';
        id: string;
        tags: any;
        file: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          size: number;
          ext?: string;
          mime: string;
        };
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetCategoryBoatsVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetCategoryBoats = {
  __typename?: 'Query';
  boats_connection?: {
    __typename?: 'BoatEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Boat';
      documentId: string;
      slug?: string;
      model?: string;
      year_first?: number;
      views_count?: number;
      manufacturer?: { __typename?: 'Manufacturer'; name: string };
      image?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        previewUrl?: string;
        provider: string;
        alternativeText?: string;
        caption?: string;
        size: number;
      };
      documents?: Array<{
        __typename?: 'ComponentBoatsDocuments';
        id: string;
        tags: any;
        file: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          size: number;
          ext?: string;
          mime: string;
        };
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetActivityBoatsVariables = Exact<{
  activityId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetActivityBoats = {
  __typename?: 'Query';
  boats_connection?: {
    __typename?: 'BoatEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Boat';
      documentId: string;
      slug?: string;
      model?: string;
      year_first?: number;
      views_count?: number;
      manufacturer?: { __typename?: 'Manufacturer'; name: string };
      image?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        previewUrl?: string;
        provider: string;
        alternativeText?: string;
        caption?: string;
        size: number;
      };
      documents?: Array<{
        __typename?: 'ComponentBoatsDocuments';
        id: string;
        tags: any;
        file: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          size: number;
          ext?: string;
          mime: string;
        };
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetTypeBoatsVariables = Exact<{
  typeId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetTypeBoats = {
  __typename?: 'Query';
  boats_connection?: {
    __typename?: 'BoatEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Boat';
      documentId: string;
      slug?: string;
      model?: string;
      year_first?: number;
      views_count?: number;
      manufacturer?: { __typename?: 'Manufacturer'; name: string };
      image?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        previewUrl?: string;
        provider: string;
        alternativeText?: string;
        caption?: string;
        size: number;
      };
      documents?: Array<{
        __typename?: 'ComponentBoatsDocuments';
        id: string;
        tags: any;
        file: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          size: number;
          ext?: string;
          mime: string;
        };
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetHullTypeBoatsVariables = Exact<{
  hullTypeId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetHullTypeBoats = {
  __typename?: 'Query';
  boats_connection?: {
    __typename?: 'BoatEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Boat';
      documentId: string;
      slug?: string;
      model?: string;
      year_first?: number;
      views_count?: number;
      manufacturer?: { __typename?: 'Manufacturer'; name: string };
      image?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        previewUrl?: string;
        provider: string;
        alternativeText?: string;
        caption?: string;
        size: number;
      };
      documents?: Array<{
        __typename?: 'ComponentBoatsDocuments';
        id: string;
        tags: any;
        file: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          size: number;
          ext?: string;
          mime: string;
        };
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export type GetFeaturedBoatsVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFeaturedBoats = {
  __typename?: 'Query';
  boats: Array<{
    __typename?: 'Boat';
    documentId: string;
    slug?: string;
    model?: string;
    year_first?: number;
    views_count?: number;
    manufacturer?: { __typename?: 'Manufacturer'; name: string };
    image?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    };
    documents?: Array<{
      __typename?: 'ComponentBoatsDocuments';
      id: string;
      tags: any;
      file: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        size: number;
        ext?: string;
        mime: string;
      };
    }>;
  }>;
};

export type GetBoatBySlugVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetBoatBySlug = {
  __typename?: 'Query';
  boats: Array<{
    __typename?: 'Boat';
    lumen_ref_user_id?: any;
    documentId: string;
    top_speed?: number;
    description?: string;
    enable_description: boolean;
    notes?: string;
    mast?: number;
    loa?: number;
    lwl?: number;
    boa?: number;
    bcl?: number;
    bh?: number;
    headroom?: number;
    bdcl?: number;
    nom?: number;
    model?: string;
    draft_max?: number;
    draft_min?: number;
    year_first?: number;
    year_last?: number;
    displacement?: number;
    ballast_type?: string;
    ballast_weight?: number;
    sail_area_displacement?: number;
    ballast_displacement?: number;
    csf?: number;
    slug?: string;
    sspd?: number;
    ksi?: number;
    displacement_hull_speed?: number;
    displacement_length?: number;
    status?: boolean;
    approved_at?: any;
    views_count?: number;
    unique_views_count?: number;
    is_featured?: boolean;
    cruising_speed?: number;
    version?: string;
    helm?: string;
    rudder?: string;
    cockpit_type?: string;
    cockpit_location?: string;
    unsinkable?: boolean;
    trailerable?: boolean;
    rotating_spars?: boolean;
    mast_configuration?: string;
    spars?: string;
    standing_rigging?: string;
    spreaders_level?: number;
    spreaders_angle?: string;
    upwind_sail_area?: number;
    downwind_sail_area?: number;
    upwind_sail_area_displacement?: number;
    downwind_sail_area_displacement?: number;
    keel_type?: Enum_Boat_Keel_Type;
    cabins?: number;
    berths?: number;
    heads?: number;
    tonnage_gross?: number;
    tonnage_net?: number;
    favorites_count?: number;
    type?: { __typename?: 'BoatsType'; documentId: string; name: string; slug: string; description?: string };
    hull_type?: { __typename?: 'BoatsHullType'; documentId: string; name: string; slug: string; description?: string };
    hull_material?: { __typename?: 'BoatsHullMaterial'; documentId: string; name: string; slug: string };
    ce_classification?: {
      __typename?: 'ComponentBoatsCeClassification';
      a?: number;
      b?: number;
      c?: number;
      d?: number;
    };
    engine?: Array<{
      __typename?: 'ComponentBoatsEngine';
      id: string;
      drive?: Enum_Componentboatsengine_Drive;
      fuel?: Enum_Componentboatsengine_Fuel;
      maker?: string;
      model?: string;
      power?: string;
      power_type?: Enum_Componentboatsengine_Power_Type;
      type?: string;
      website?: string;
    }>;
    water_heater?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    fuel_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    water_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    holding_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    manufacturer?: { __typename?: 'Manufacturer'; documentId: string; name: string; website?: string; slug: string };
    reference_price?: {
      __typename?: 'ComponentBoatsPrice';
      id: string;
      amount?: number;
      currency?: {
        __typename?: 'Currency';
        documentId: string;
        name: string;
        iso_code: string;
        symbol: string;
        iso_code_num: string;
      };
    };
    categories: Array<{
      __typename?: 'BoatsCategory';
      documentId: string;
      lumen_ref_id?: any;
      name: string;
      slug: string;
      publicBoatsCount: number;
    }>;
    hull_appendages?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    mainsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    headsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    spinnaker?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    activities: Array<{
      __typename?: 'BoatsActivity';
      documentId: string;
      name: string;
      slug?: string;
      lumen_ref_id?: any;
      description?: string;
      coverImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    image?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    };
    files: Array<{
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    }>;
    boatDocuments: Array<{
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      alternativeText?: string;
      caption?: string;
      size: number;
      createdAt?: any;
    }>;
    boat_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    boat_interior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    boat_exterior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    documents?: Array<{
      __typename?: 'ComponentBoatsDocuments';
      id: string;
      tags: any;
      file: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        mime: string;
        size: number;
        ext?: string;
      };
    }>;
  }>;
};

export type GetBoatByIdVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type GetBoatById = {
  __typename?: 'Query';
  boat?: {
    __typename?: 'Boat';
    lumen_ref_user_id?: any;
    documentId: string;
    top_speed?: number;
    description?: string;
    enable_description: boolean;
    notes?: string;
    mast?: number;
    loa?: number;
    lwl?: number;
    boa?: number;
    bcl?: number;
    bh?: number;
    headroom?: number;
    bdcl?: number;
    nom?: number;
    model?: string;
    draft_max?: number;
    draft_min?: number;
    year_first?: number;
    year_last?: number;
    displacement?: number;
    ballast_type?: string;
    ballast_weight?: number;
    sail_area_displacement?: number;
    ballast_displacement?: number;
    csf?: number;
    slug?: string;
    sspd?: number;
    ksi?: number;
    displacement_hull_speed?: number;
    displacement_length?: number;
    status?: boolean;
    approved_at?: any;
    views_count?: number;
    unique_views_count?: number;
    is_featured?: boolean;
    cruising_speed?: number;
    version?: string;
    helm?: string;
    rudder?: string;
    cockpit_type?: string;
    cockpit_location?: string;
    unsinkable?: boolean;
    trailerable?: boolean;
    rotating_spars?: boolean;
    mast_configuration?: string;
    spars?: string;
    standing_rigging?: string;
    spreaders_level?: number;
    spreaders_angle?: string;
    upwind_sail_area?: number;
    downwind_sail_area?: number;
    upwind_sail_area_displacement?: number;
    downwind_sail_area_displacement?: number;
    keel_type?: Enum_Boat_Keel_Type;
    cabins?: number;
    berths?: number;
    heads?: number;
    tonnage_gross?: number;
    tonnage_net?: number;
    favorites_count?: number;
    type?: { __typename?: 'BoatsType'; documentId: string; name: string; slug: string; description?: string };
    hull_type?: { __typename?: 'BoatsHullType'; documentId: string; name: string; slug: string; description?: string };
    hull_material?: { __typename?: 'BoatsHullMaterial'; documentId: string; name: string; slug: string };
    ce_classification?: {
      __typename?: 'ComponentBoatsCeClassification';
      a?: number;
      b?: number;
      c?: number;
      d?: number;
    };
    engine?: Array<{
      __typename?: 'ComponentBoatsEngine';
      id: string;
      drive?: Enum_Componentboatsengine_Drive;
      fuel?: Enum_Componentboatsengine_Fuel;
      maker?: string;
      model?: string;
      power?: string;
      power_type?: Enum_Componentboatsengine_Power_Type;
      type?: string;
      website?: string;
    }>;
    water_heater?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    fuel_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    water_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    holding_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    manufacturer?: { __typename?: 'Manufacturer'; documentId: string; name: string; website?: string; slug: string };
    reference_price?: {
      __typename?: 'ComponentBoatsPrice';
      id: string;
      amount?: number;
      currency?: {
        __typename?: 'Currency';
        documentId: string;
        name: string;
        iso_code: string;
        symbol: string;
        iso_code_num: string;
      };
    };
    categories: Array<{
      __typename?: 'BoatsCategory';
      documentId: string;
      lumen_ref_id?: any;
      name: string;
      slug: string;
      publicBoatsCount: number;
    }>;
    hull_appendages?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    mainsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    headsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    spinnaker?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    activities: Array<{
      __typename?: 'BoatsActivity';
      documentId: string;
      name: string;
      slug?: string;
      lumen_ref_id?: any;
      description?: string;
      coverImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    image?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    };
    files: Array<{
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    }>;
    boatDocuments: Array<{
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      alternativeText?: string;
      caption?: string;
      size: number;
      createdAt?: any;
    }>;
    boat_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    boat_interior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    boat_exterior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    documents?: Array<{
      __typename?: 'ComponentBoatsDocuments';
      id: string;
      tags: any;
      file: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        mime: string;
        size: number;
        ext?: string;
      };
    }>;
  };
};

export type GetBoatsListByIDsVariables = Exact<{
  idFilters?: InputMaybe<Array<InputMaybe<BoatFiltersInput>> | InputMaybe<BoatFiltersInput>>;
}>;

export type GetBoatsListByIDs = {
  __typename?: 'Query';
  boats: Array<{
    __typename?: 'Boat';
    lumen_ref_user_id?: any;
    documentId: string;
    top_speed?: number;
    description?: string;
    enable_description: boolean;
    notes?: string;
    mast?: number;
    loa?: number;
    lwl?: number;
    boa?: number;
    bcl?: number;
    bh?: number;
    headroom?: number;
    bdcl?: number;
    nom?: number;
    model?: string;
    draft_max?: number;
    draft_min?: number;
    year_first?: number;
    year_last?: number;
    displacement?: number;
    ballast_type?: string;
    ballast_weight?: number;
    sail_area_displacement?: number;
    ballast_displacement?: number;
    csf?: number;
    slug?: string;
    sspd?: number;
    ksi?: number;
    displacement_hull_speed?: number;
    displacement_length?: number;
    status?: boolean;
    approved_at?: any;
    views_count?: number;
    unique_views_count?: number;
    is_featured?: boolean;
    cruising_speed?: number;
    version?: string;
    helm?: string;
    rudder?: string;
    cockpit_type?: string;
    cockpit_location?: string;
    unsinkable?: boolean;
    trailerable?: boolean;
    rotating_spars?: boolean;
    mast_configuration?: string;
    spars?: string;
    standing_rigging?: string;
    spreaders_level?: number;
    spreaders_angle?: string;
    upwind_sail_area?: number;
    downwind_sail_area?: number;
    upwind_sail_area_displacement?: number;
    downwind_sail_area_displacement?: number;
    keel_type?: Enum_Boat_Keel_Type;
    cabins?: number;
    berths?: number;
    heads?: number;
    tonnage_gross?: number;
    tonnage_net?: number;
    favorites_count?: number;
    type?: { __typename?: 'BoatsType'; documentId: string; name: string; slug: string; description?: string };
    hull_type?: { __typename?: 'BoatsHullType'; documentId: string; name: string; slug: string; description?: string };
    hull_material?: { __typename?: 'BoatsHullMaterial'; documentId: string; name: string; slug: string };
    ce_classification?: {
      __typename?: 'ComponentBoatsCeClassification';
      a?: number;
      b?: number;
      c?: number;
      d?: number;
    };
    engine?: Array<{
      __typename?: 'ComponentBoatsEngine';
      id: string;
      drive?: Enum_Componentboatsengine_Drive;
      fuel?: Enum_Componentboatsengine_Fuel;
      maker?: string;
      model?: string;
      power?: string;
      power_type?: Enum_Componentboatsengine_Power_Type;
      type?: string;
      website?: string;
    }>;
    water_heater?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    fuel_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    water_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    holding_tank?: Array<{ __typename?: 'ComponentBoatsTank'; id: string; capacity?: string }>;
    manufacturer?: { __typename?: 'Manufacturer'; documentId: string; name: string; website?: string; slug: string };
    reference_price?: {
      __typename?: 'ComponentBoatsPrice';
      id: string;
      amount?: number;
      currency?: {
        __typename?: 'Currency';
        documentId: string;
        name: string;
        iso_code: string;
        symbol: string;
        iso_code_num: string;
      };
    };
    categories: Array<{
      __typename?: 'BoatsCategory';
      documentId: string;
      lumen_ref_id?: any;
      name: string;
      slug: string;
      publicBoatsCount: number;
    }>;
    hull_appendages?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    mainsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    headsail?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    spinnaker?: Array<{ __typename?: 'ComponentBoatsNameValue'; id: string; name?: string; value?: string }>;
    activities: Array<{
      __typename?: 'BoatsActivity';
      documentId: string;
      name: string;
      slug?: string;
      lumen_ref_id?: any;
      description?: string;
      coverImage?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        alternativeText?: string;
        size: number;
      };
    }>;
    image?: {
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    };
    files: Array<{
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      provider: string;
      alternativeText?: string;
      caption?: string;
      size: number;
    }>;
    boatDocuments: Array<{
      __typename?: 'UploadFile';
      documentId: string;
      name: string;
      url: string;
      previewUrl?: string;
      alternativeText?: string;
      caption?: string;
      size: number;
      createdAt?: any;
    }>;
    boat_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    boat_interior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    boat_exterior_designers: Array<{ __typename?: 'BoatDesigner'; documentId: string; name: string; website?: string }>;
    documents?: Array<{
      __typename?: 'ComponentBoatsDocuments';
      id: string;
      tags: any;
      file: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        mime: string;
        size: number;
        ext?: string;
      };
    }>;
  }>;
};

export type GetAllSlugsPublicBoatsVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAllSlugsPublicBoats = {
  __typename?: 'Query';
  boats: Array<{ __typename?: 'Boat'; documentId: string; slug?: string }>;
};

export type MasterBoatsCardsQueryVariables = Exact<{
  filters?: InputMaybe<BoatFiltersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MasterBoatsCardsQuery = {
  __typename?: 'Query';
  boats_connection?: {
    __typename?: 'BoatEntityResponseCollection';
    nodes: Array<{
      __typename?: 'Boat';
      documentId: string;
      slug?: string;
      model?: string;
      year_first?: number;
      views_count?: number;
      manufacturer?: { __typename?: 'Manufacturer'; name: string };
      image?: {
        __typename?: 'UploadFile';
        documentId: string;
        name: string;
        url: string;
        previewUrl?: string;
        provider: string;
        alternativeText?: string;
        caption?: string;
        size: number;
      };
      documents?: Array<{
        __typename?: 'ComponentBoatsDocuments';
        id: string;
        tags: any;
        file: {
          __typename?: 'UploadFile';
          documentId: string;
          name: string;
          url: string;
          size: number;
          ext?: string;
          mime: string;
        };
      }>;
    }>;
    pageInfo: { __typename?: 'Pagination'; total: number; page: number; pageSize: number; pageCount: number };
  };
};

export const ComponentBoatsTankFragment = `
    fragment ComponentBoatsTankFragment on ComponentBoatsTank {
  id
  capacity
}
    `;
export const CurrencyFragment = `
    fragment CurrencyFragment on Currency {
  documentId
  name
  iso_code
  symbol
  iso_code_num
}
    `;
export const ComponentBoatsPriceFragment = `
    fragment ComponentBoatsPriceFragment on ComponentBoatsPrice {
  id
  amount
  currency {
    ...CurrencyFragment
  }
}
    ${CurrencyFragment}`;
export const ComponentBoatsNameValueFragment = `
    fragment ComponentBoatsNameValueFragment on ComponentBoatsNameValue {
  id
  name
  value
}
    `;
export const UploadFileEntityFragment = `
    fragment UploadFileEntityFragment on UploadFile {
  documentId
  name
  url
  alternativeText
  size
}
    `;
export const FullBoatFragment = `
    fragment FullBoatFragment on Boat {
  lumen_ref_user_id
  documentId
  type {
    documentId
    name
    slug
    description
  }
  hull_type {
    documentId
    name
    slug
    description
  }
  hull_material {
    documentId
    name
    slug
  }
  ce_classification {
    a
    b
    c
    d
  }
  top_speed
  description
  enable_description
  notes
  mast
  loa
  lwl
  boa
  bcl
  bh
  headroom
  bdcl
  nom
  engine {
    id
    drive
    fuel
    maker
    model
    power
    power_type
    type
    website
  }
  model
  water_heater {
    ...ComponentBoatsTankFragment
  }
  draft_max
  draft_min
  year_first
  year_last
  displacement
  ballast_type
  ballast_weight
  fuel_tank {
    ...ComponentBoatsTankFragment
  }
  water_tank {
    ...ComponentBoatsTankFragment
  }
  holding_tank {
    ...ComponentBoatsTankFragment
  }
  sail_area_displacement
  ballast_displacement
  csf
  slug
  sspd
  ksi
  displacement_hull_speed
  displacement_length
  status
  approved_at
  year_last
  year_first
  views_count
  unique_views_count
  is_featured
  cruising_speed
  version
  helm
  rudder
  cockpit_type
  cockpit_location
  unsinkable
  trailerable
  rotating_spars
  mast_configuration
  spars
  standing_rigging
  spreaders_level
  spreaders_angle
  upwind_sail_area
  downwind_sail_area
  upwind_sail_area_displacement
  downwind_sail_area_displacement
  keel_type
  cabins
  berths
  heads
  tonnage_gross
  tonnage_net
  manufacturer {
    documentId
    name
    website
    slug
  }
  reference_price {
    ...ComponentBoatsPriceFragment
  }
  categories {
    documentId
    lumen_ref_id
    name
    slug
    publicBoatsCount
  }
  hull_appendages {
    ...ComponentBoatsNameValueFragment
  }
  mainsail {
    ...ComponentBoatsNameValueFragment
  }
  headsail {
    ...ComponentBoatsNameValueFragment
  }
  spinnaker {
    ...ComponentBoatsNameValueFragment
  }
  activities {
    documentId
    name
    slug
    lumen_ref_id
    description
    coverImage {
      ...UploadFileEntityFragment
    }
  }
  image {
    documentId
    name
    url
    previewUrl
    provider
    alternativeText
    caption
    size
  }
  files {
    documentId
    name
    url
    previewUrl
    provider
    alternativeText
    caption
    size
  }
  boatDocuments {
    documentId
    name
    url
    previewUrl
    alternativeText
    caption
    size
    createdAt
  }
  boat_designers {
    documentId
    name
    website
  }
  boat_interior_designers {
    documentId
    name
    website
  }
  boat_exterior_designers {
    documentId
    name
    website
  }
  favorites_count
  documents {
    id
    file {
      documentId
      name
      url
      mime
      size
      ext
    }
    tags
  }
}
    ${ComponentBoatsTankFragment}
${ComponentBoatsPriceFragment}
${ComponentBoatsNameValueFragment}
${UploadFileEntityFragment}`;
export const BoatCardFragment = `
    fragment BoatCardFragment on Boat {
  documentId
  slug
  model
  manufacturer {
    name
  }
  year_first
  views_count
  image {
    documentId
    name
    url
    previewUrl
    provider
    alternativeText
    caption
    size
  }
  documents {
    id
    file {
      documentId
      name
      url
      size
      ext
      mime
    }
    tags
  }
}
    `;
export const BoatCardEntityResponseCollectionFragment = `
    fragment BoatCardEntityResponseCollectionFragment on BoatEntityResponseCollection {
  nodes {
    ...BoatCardFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${BoatCardFragment}`;
export const BoatsActivityFragment = `
    fragment BoatsActivityFragment on BoatsActivity {
  documentId
  name
  slug
  lumen_ref_id
  description
  coverImage {
    ...UploadFileEntityFragment
  }
}
    ${UploadFileEntityFragment}`;
export const BoatsActivityRelationResponseCollectionFragment = `
    fragment BoatsActivityRelationResponseCollectionFragment on BoatsActivityRelationResponseCollection {
  nodes {
    ...BoatsActivityFragment
  }
}
    ${BoatsActivityFragment}`;
export const BoatsCategoryFragment = `
    fragment BoatsCategoryFragment on BoatsCategory {
  documentId
  name
  slug
  lumen_ref_id
  description
  publicBoatsCount
}
    `;
export const BoatsCategoryRelationResponseCollectionFragment = `
    fragment BoatsCategoryRelationResponseCollectionFragment on BoatsCategoryRelationResponseCollection {
  nodes {
    ...BoatsCategoryFragment
  }
}
    ${BoatsCategoryFragment}`;
export const BoatsHullMaterialFragment = `
    fragment BoatsHullMaterialFragment on BoatsHullMaterial {
  documentId
  name
  slug
  publicBoatsCount
}
    `;
export const BoatsHullMaterialEntityResponseFragment = `
    fragment BoatsHullMaterialEntityResponseFragment on BoatsHullMaterialEntityResponseCollection {
  nodes {
    ...BoatsHullMaterialFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${BoatsHullMaterialFragment}`;
export const BoatsHullTypeFragment = `
    fragment BoatsHullTypeFragment on BoatsHullType {
  documentId
  name
  slug
  description
  publicBoatsCount
}
    `;
export const BoatsHullTypeEntityResponseFragment = `
    fragment BoatsHullTypeEntityResponseFragment on BoatsHullTypeEntityResponseCollection {
  nodes {
    ...BoatsHullTypeFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${BoatsHullTypeFragment}`;
export const BoatsTypeFragment = `
    fragment BoatsTypeFragment on BoatsType {
  documentId
  name
  slug
  description
  publicBoatsCount
}
    `;
export const BoatsTypeEntityResponseFragment = `
    fragment BoatsTypeEntityResponseFragment on BoatsTypeEntityResponseCollection {
  nodes {
    ...BoatsTypeFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${BoatsTypeFragment}`;
export const SeoFragment = `
    fragment SeoFragment on ComponentSharedSeo {
  id
  metaTitle
  metaDescription
  metaImage {
    documentId
    name
    url
    alternativeText
  }
  keywords
  metaRobots
  structuredData
  metaViewport
  canonicalURL
}
    `;
export const FeaturePageFragment = `
    fragment FeaturePageFragment on FeaturesPage {
  documentId
  slug
  title
  subtitle
  description
  icon {
    name
  }
  youtube_video_url
  image {
    documentId
    url
    alternativeText
  }
  seo {
    ...SeoFragment
  }
}
    ${SeoFragment}`;
export const UploadFileRelationResponseCollectionFragment = `
    fragment UploadFileRelationResponseCollectionFragment on UploadFileRelationResponseCollection {
  nodes {
    ...UploadFileEntityFragment
  }
}
    ${UploadFileEntityFragment}`;
export const UploadFileEntityResponseFragment = `
    fragment UploadFileEntityResponseFragment on UploadFileEntityResponseCollection {
  nodes {
    ...UploadFileEntityFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${UploadFileEntityFragment}`;
export const LegalPageFragment = `
    fragment LegalPageFragment on LegalPage {
  documentId
  title
  slug
  content {
    id
    title
    description
  }
}
    `;
export const LegalPageResponseFragment = `
    fragment LegalPageResponseFragment on LegalPageEntityResponseCollection {
  nodes {
    ...LegalPageFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${LegalPageFragment}`;
export const FullManufacturerFragment = `
    fragment FullManufacturerFragment on Manufacturer {
  documentId
  name
  website
  lumen_ref_id
  description
  slug
  logo {
    documentId
    name
    url
    alternativeText
  }
  seo {
    ...SeoFragment
  }
}
    ${SeoFragment}`;
export const ManufacturerEntityResponseCollectionFragment = `
    fragment ManufacturerEntityResponseCollectionFragment on ManufacturerEntityResponseCollection {
  nodes {
    ...FullManufacturerFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${FullManufacturerFragment}`;
export const FullNewsFragment = `
    fragment FullNewsFragment on NewsItem {
  documentId
  seo {
    ...SeoFragment
  }
  slug
  title
  excerpt
  featuredImage {
    ...UploadFileEntityFragment
  }
  showPublishDate
  publishDate
}
    ${SeoFragment}
${UploadFileEntityFragment}`;
export const NewsCardFragment = `
    fragment NewsCardFragment on NewsItem {
  documentId
  title
  slug
  excerpt
  featuredImage {
    ...UploadFileEntityFragment
  }
}
    ${UploadFileEntityFragment}`;
export const NewsCardEntityResponseCollectionFragment = `
    fragment NewsCardEntityResponseCollectionFragment on NewsItemEntityResponseCollection {
  nodes {
    ...NewsCardFragment
  }
  pageInfo {
    total
    page
    pageSize
    pageCount
  }
}
    ${NewsCardFragment}`;
export const PlanFragment = `
    fragment PlanFragment on Plan {
  documentId
  title
  description
  order
  price {
    amount
    currency {
      documentId
      symbol
      name
    }
  }
  icon {
    id
    name
  }
  recurrence
}
    `;
export const PostCategoryEntityFragment = `
    fragment PostCategoryEntityFragment on PostCategory {
  documentId
  slug
  name
  description
  tbaPostsCount
  tbdPostsCount
  parent_category {
    documentId
    slug
    name
    description
  }
  seo {
    ...SeoFragment
  }
}
    ${SeoFragment}`;
export const PostFragment = `
    fragment PostFragment on Post {
  documentId
  title
  slug
  showPublishDate
  publishDate
  excerpt
  reading_time
  application {
    documentId
    name
    code
    description
    logo {
      documentId
      url
      name
      alternativeText
    }
  }
  featuredImage {
    ...UploadFileEntityFragment
  }
  content {
    ... on ComponentBlocksRichText {
      id
      richtext
    }
    ... on ComponentBlocksImage {
      id
      image {
        ...UploadFileEntityFragment
      }
      alt
    }
  }
  post_categories {
    ...PostCategoryEntityFragment
  }
  post_tags {
    documentId
    slug
    name
    description
    tbaPostsCount
    tbdPostsCount
  }
}
    ${UploadFileEntityFragment}
${PostCategoryEntityFragment}`;
export const PaginationFragment = `
    fragment PaginationFragment on Pagination {
  total
  page
  pageSize
  pageCount
}
    `;
export const PostEntityResponseFragment = `
    fragment PostEntityResponseFragment on PostEntityResponseCollection {
  nodes {
    ...PostFragment
  }
  pageInfo {
    ...PaginationFragment
  }
}
    ${PostFragment}
${PaginationFragment}`;
export const PostCardFragment = `
    fragment PostCardFragment on Post {
  documentId
  title
  slug
  publishedAt
  publishDate
  excerpt
  reading_time
  showPublishDate
  content {
    __typename
  }
  post_categories(pagination: {limit: 3}) {
    documentId
    name
  }
  featuredImage {
    ...UploadFileEntityFragment
  }
}
    ${UploadFileEntityFragment}`;
export const RecentPostFragment = `
    fragment RecentPostFragment on Post {
  documentId
  title
  slug
  excerpt
  reading_time
  featuredImage {
    ...UploadFileEntityFragment
  }
}
    ${UploadFileEntityFragment}`;
export const RecentPostCardFragment = `
    fragment RecentPostCardFragment on Post {
  documentId
  title
  slug
  excerpt
  content {
    __typename
  }
  reading_time
  publishDate
  showPublishDate
  post_categories(pagination: {limit: 3}) {
    documentId
    name
    slug
  }
  featuredImage {
    ...UploadFileEntityFragment
  }
}
    ${UploadFileEntityFragment}`;
export const PostCategoryRelationResponseCollectionFragment = `
    fragment PostCategoryRelationResponseCollectionFragment on PostCategoryRelationResponseCollection {
  nodes {
    ...PostCategoryEntityFragment
  }
}
    ${PostCategoryEntityFragment}`;
export const PostCategoryEntityResponseFragment = `
    fragment PostCategoryEntityResponseFragment on PostCategoryEntityResponseCollection {
  nodes {
    ...PostCategoryEntityFragment
  }
  pageInfo {
    ...PaginationFragment
  }
}
    ${PostCategoryEntityFragment}
${PaginationFragment}`;
export const CategoryPageFragment = `
    fragment CategoryPageFragment on PostCategory {
  documentId
  slug
  name
  description
  tbaPostsCount
  tbdPostsCount
  seo {
    ...SeoFragment
  }
}
    ${SeoFragment}`;
export const PricingPageFragment = `
    fragment PricingPageFragment on PricingPage {
  title
  description
  faq_title
  FAQ {
    ... on ComponentBlocksCommonAskedQuestions {
      question
      answer
      name
      order
      id
    }
  }
  featuredImage {
    ...UploadFileEntityFragment
  }
  reachSectionTitle {
    title
    description
  }
  featuresTitle {
    title
    description
  }
  comparePlansTitle {
    title
    description
  }
  planCards {
    id
    planName
    price
    recurrance
    features
    iconName
    description
  }
  seo {
    ...SeoFragment
  }
}
    ${UploadFileEntityFragment}
${SeoFragment}`;
export const PostTagEntityFragment = `
    fragment PostTagEntityFragment on PostTag {
  documentId
  slug
  name
  description
  tbaPostsCount
  tbdPostsCount
  seo {
    ...SeoFragment
  }
}
    ${SeoFragment}`;
export const PostTagRelationResponseCollectionFragment = `
    fragment PostTagRelationResponseCollectionFragment on PostTagRelationResponseCollection {
  nodes {
    ...PostTagEntityFragment
  }
}
    ${PostTagEntityFragment}`;
export const PostTagEntityResponseFragment = `
    fragment PostTagEntityResponseFragment on PostTagEntityResponseCollection {
  nodes {
    ...PostTagEntityFragment
  }
  pageInfo {
    ...PaginationFragment
  }
}
    ${PostTagEntityFragment}
${PaginationFragment}`;
export const CurrencyEntityResponseFragment = `
    fragment CurrencyEntityResponseFragment on CurrencyEntityResponseCollection {
  nodes {
    ...CurrencyFragment
  }
  pageInfo {
    ...PaginationFragment
  }
}
    ${CurrencyFragment}
${PaginationFragment}`;
export const GetAnnouncementsDocument = `
    query getAnnouncements($appCode: String, $expirationDate: DateTime) {
  announcements(
    filters: {applications: {code: {eq: $appCode}}, expiration_date: {gt: $expirationDate}}
    status: PUBLISHED
  ) {
    documentId
    title
    description
    level
    applications {
      documentId
      code
    }
    action_title
    action_link
    expiration_date
  }
}
    `;

export const useGetAnnouncements = <TData = GetAnnouncements, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAnnouncementsVariables,
  options?: Omit<UseQueryOptions<GetAnnouncements, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAnnouncements, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAnnouncements, TError, TData>({
    queryKey: variables === undefined ? ['getAnnouncements'] : ['getAnnouncements', variables],
    queryFn: fetcher<GetAnnouncements, GetAnnouncementsVariables>(client, GetAnnouncementsDocument, variables, headers),
    ...options,
  });
};

useGetAnnouncements.getKey = (variables?: GetAnnouncementsVariables) =>
  variables === undefined ? ['getAnnouncements'] : ['getAnnouncements', variables];

export const useInfiniteGetAnnouncements = <TData = InfiniteData<GetAnnouncements>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAnnouncementsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAnnouncements, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAnnouncements, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAnnouncements, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getAnnouncements.infinite']
            : ['getAnnouncements.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAnnouncements, GetAnnouncementsVariables>(
            client,
            GetAnnouncementsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAnnouncements.getKey = (variables?: GetAnnouncementsVariables) =>
  variables === undefined ? ['getAnnouncements.infinite'] : ['getAnnouncements.infinite', variables];

useGetAnnouncements.fetcher = (
  client: GraphQLClient,
  variables?: GetAnnouncementsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetAnnouncements, GetAnnouncementsVariables>(client, GetAnnouncementsDocument, variables, headers);

export const GetApplicationsInfoDocument = `
    query getApplicationsInfo($filters: ApplicationFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = [], $publicationStatus: PublicationStatus = PUBLISHED) {
  applications(
    filters: $filters
    pagination: $pagination
    sort: $sort
    status: $publicationStatus
  ) {
    documentId
    name
    code
    currentVersion
    updateRequired
  }
}
    `;

export const useGetApplicationsInfo = <TData = GetApplicationsInfo, TError = unknown>(
  client: GraphQLClient,
  variables?: GetApplicationsInfoVariables,
  options?: Omit<UseQueryOptions<GetApplicationsInfo, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetApplicationsInfo, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetApplicationsInfo, TError, TData>({
    queryKey: variables === undefined ? ['getApplicationsInfo'] : ['getApplicationsInfo', variables],
    queryFn: fetcher<GetApplicationsInfo, GetApplicationsInfoVariables>(
      client,
      GetApplicationsInfoDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetApplicationsInfo.getKey = (variables?: GetApplicationsInfoVariables) =>
  variables === undefined ? ['getApplicationsInfo'] : ['getApplicationsInfo', variables];

export const useInfiniteGetApplicationsInfo = <TData = InfiniteData<GetApplicationsInfo>, TError = unknown>(
  client: GraphQLClient,
  variables: GetApplicationsInfoVariables,
  options: Omit<UseInfiniteQueryOptions<GetApplicationsInfo, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetApplicationsInfo, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetApplicationsInfo, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getApplicationsInfo.infinite']
            : ['getApplicationsInfo.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetApplicationsInfo, GetApplicationsInfoVariables>(
            client,
            GetApplicationsInfoDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetApplicationsInfo.getKey = (variables?: GetApplicationsInfoVariables) =>
  variables === undefined ? ['getApplicationsInfo.infinite'] : ['getApplicationsInfo.infinite', variables];

useGetApplicationsInfo.fetcher = (
  client: GraphQLClient,
  variables?: GetApplicationsInfoVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetApplicationsInfo, GetApplicationsInfoVariables>(client, GetApplicationsInfoDocument, variables, headers);

export const GetBoatsActivitiesDocument = `
    query getBoatsActivities($limit: Int = 15, $filters: BoatsActivityFiltersInput) {
  boatsActivities(
    pagination: {limit: $limit}
    filters: $filters
    status: PUBLISHED
  ) {
    ...BoatsActivityFragment
  }
}
    ${BoatsActivityFragment}`;

export const useGetBoatsActivities = <TData = GetBoatsActivities, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatsActivitiesVariables,
  options?: Omit<UseQueryOptions<GetBoatsActivities, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsActivities, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsActivities, TError, TData>({
    queryKey: variables === undefined ? ['getBoatsActivities'] : ['getBoatsActivities', variables],
    queryFn: fetcher<GetBoatsActivities, GetBoatsActivitiesVariables>(
      client,
      GetBoatsActivitiesDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsActivities.getKey = (variables?: GetBoatsActivitiesVariables) =>
  variables === undefined ? ['getBoatsActivities'] : ['getBoatsActivities', variables];

export const useInfiniteGetBoatsActivities = <TData = InfiniteData<GetBoatsActivities>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsActivitiesVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsActivities, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsActivities, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsActivities, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatsActivities.infinite']
            : ['getBoatsActivities.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsActivities, GetBoatsActivitiesVariables>(
            client,
            GetBoatsActivitiesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsActivities.getKey = (variables?: GetBoatsActivitiesVariables) =>
  variables === undefined ? ['getBoatsActivities.infinite'] : ['getBoatsActivities.infinite', variables];

useGetBoatsActivities.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatsActivitiesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatsActivities, GetBoatsActivitiesVariables>(client, GetBoatsActivitiesDocument, variables, headers);

export const GetAllBoatsActivitiesIdDocument = `
    query getAllBoatsActivitiesId {
  boatsActivities(pagination: {limit: 200}, status: PUBLISHED) {
    documentId
    name
    slug
  }
}
    `;

export const useGetAllBoatsActivitiesId = <TData = GetAllBoatsActivitiesId, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAllBoatsActivitiesIdVariables,
  options?: Omit<UseQueryOptions<GetAllBoatsActivitiesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllBoatsActivitiesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllBoatsActivitiesId, TError, TData>({
    queryKey: variables === undefined ? ['getAllBoatsActivitiesId'] : ['getAllBoatsActivitiesId', variables],
    queryFn: fetcher<GetAllBoatsActivitiesId, GetAllBoatsActivitiesIdVariables>(
      client,
      GetAllBoatsActivitiesIdDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetAllBoatsActivitiesId.getKey = (variables?: GetAllBoatsActivitiesIdVariables) =>
  variables === undefined ? ['getAllBoatsActivitiesId'] : ['getAllBoatsActivitiesId', variables];

export const useInfiniteGetAllBoatsActivitiesId = <TData = InfiniteData<GetAllBoatsActivitiesId>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllBoatsActivitiesIdVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllBoatsActivitiesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllBoatsActivitiesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllBoatsActivitiesId, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getAllBoatsActivitiesId.infinite']
            : ['getAllBoatsActivitiesId.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllBoatsActivitiesId, GetAllBoatsActivitiesIdVariables>(
            client,
            GetAllBoatsActivitiesIdDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllBoatsActivitiesId.getKey = (variables?: GetAllBoatsActivitiesIdVariables) =>
  variables === undefined ? ['getAllBoatsActivitiesId.infinite'] : ['getAllBoatsActivitiesId.infinite', variables];

useGetAllBoatsActivitiesId.fetcher = (
  client: GraphQLClient,
  variables?: GetAllBoatsActivitiesIdVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetAllBoatsActivitiesId, GetAllBoatsActivitiesIdVariables>(
    client,
    GetAllBoatsActivitiesIdDocument,
    variables,
    headers,
  );

export const GetBoatsActivityBySlugDocument = `
    query getBoatsActivityBySlug($slug: String!) {
  boatsActivities(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...BoatsActivityFragment
  }
}
    ${BoatsActivityFragment}`;

export const useGetBoatsActivityBySlug = <TData = GetBoatsActivityBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsActivityBySlugVariables,
  options?: Omit<UseQueryOptions<GetBoatsActivityBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsActivityBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsActivityBySlug, TError, TData>({
    queryKey: ['getBoatsActivityBySlug', variables],
    queryFn: fetcher<GetBoatsActivityBySlug, GetBoatsActivityBySlugVariables>(
      client,
      GetBoatsActivityBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsActivityBySlug.getKey = (variables: GetBoatsActivityBySlugVariables) => [
  'getBoatsActivityBySlug',
  variables,
];

export const useInfiniteGetBoatsActivityBySlug = <TData = InfiniteData<GetBoatsActivityBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsActivityBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsActivityBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsActivityBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsActivityBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatsActivityBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsActivityBySlug, GetBoatsActivityBySlugVariables>(
            client,
            GetBoatsActivityBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsActivityBySlug.getKey = (variables: GetBoatsActivityBySlugVariables) => [
  'getBoatsActivityBySlug.infinite',
  variables,
];

useGetBoatsActivityBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetBoatsActivityBySlugVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetBoatsActivityBySlug, GetBoatsActivityBySlugVariables>(
    client,
    GetBoatsActivityBySlugDocument,
    variables,
    headers,
  );

export const GetBoatsCategoriesDocument = `
    query getBoatsCategories($limit: Int = 15) {
  boatsCategories(pagination: {limit: $limit}, status: PUBLISHED) {
    ...BoatsCategoryFragment
  }
}
    ${BoatsCategoryFragment}`;

export const useGetBoatsCategories = <TData = GetBoatsCategories, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatsCategoriesVariables,
  options?: Omit<UseQueryOptions<GetBoatsCategories, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsCategories, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsCategories, TError, TData>({
    queryKey: variables === undefined ? ['getBoatsCategories'] : ['getBoatsCategories', variables],
    queryFn: fetcher<GetBoatsCategories, GetBoatsCategoriesVariables>(
      client,
      GetBoatsCategoriesDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsCategories.getKey = (variables?: GetBoatsCategoriesVariables) =>
  variables === undefined ? ['getBoatsCategories'] : ['getBoatsCategories', variables];

export const useInfiniteGetBoatsCategories = <TData = InfiniteData<GetBoatsCategories>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsCategoriesVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsCategories, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsCategories, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsCategories, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatsCategories.infinite']
            : ['getBoatsCategories.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsCategories, GetBoatsCategoriesVariables>(
            client,
            GetBoatsCategoriesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsCategories.getKey = (variables?: GetBoatsCategoriesVariables) =>
  variables === undefined ? ['getBoatsCategories.infinite'] : ['getBoatsCategories.infinite', variables];

useGetBoatsCategories.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatsCategoriesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatsCategories, GetBoatsCategoriesVariables>(client, GetBoatsCategoriesDocument, variables, headers);

export const GetAllBoatsCategoriesIdDocument = `
    query getAllBoatsCategoriesId {
  boatsCategories(pagination: {limit: 200}, status: PUBLISHED) {
    documentId
    name
    slug
  }
}
    `;

export const useGetAllBoatsCategoriesId = <TData = GetAllBoatsCategoriesId, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAllBoatsCategoriesIdVariables,
  options?: Omit<UseQueryOptions<GetAllBoatsCategoriesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllBoatsCategoriesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllBoatsCategoriesId, TError, TData>({
    queryKey: variables === undefined ? ['getAllBoatsCategoriesId'] : ['getAllBoatsCategoriesId', variables],
    queryFn: fetcher<GetAllBoatsCategoriesId, GetAllBoatsCategoriesIdVariables>(
      client,
      GetAllBoatsCategoriesIdDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetAllBoatsCategoriesId.getKey = (variables?: GetAllBoatsCategoriesIdVariables) =>
  variables === undefined ? ['getAllBoatsCategoriesId'] : ['getAllBoatsCategoriesId', variables];

export const useInfiniteGetAllBoatsCategoriesId = <TData = InfiniteData<GetAllBoatsCategoriesId>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllBoatsCategoriesIdVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllBoatsCategoriesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllBoatsCategoriesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllBoatsCategoriesId, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getAllBoatsCategoriesId.infinite']
            : ['getAllBoatsCategoriesId.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllBoatsCategoriesId, GetAllBoatsCategoriesIdVariables>(
            client,
            GetAllBoatsCategoriesIdDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllBoatsCategoriesId.getKey = (variables?: GetAllBoatsCategoriesIdVariables) =>
  variables === undefined ? ['getAllBoatsCategoriesId.infinite'] : ['getAllBoatsCategoriesId.infinite', variables];

useGetAllBoatsCategoriesId.fetcher = (
  client: GraphQLClient,
  variables?: GetAllBoatsCategoriesIdVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetAllBoatsCategoriesId, GetAllBoatsCategoriesIdVariables>(
    client,
    GetAllBoatsCategoriesIdDocument,
    variables,
    headers,
  );

export const GetBoatsCategoriesBySlugDocument = `
    query getBoatsCategoriesBySlug($slug: String!) {
  boatsCategories(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...BoatsCategoryFragment
  }
}
    ${BoatsCategoryFragment}`;

export const useGetBoatsCategoriesBySlug = <TData = GetBoatsCategoriesBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsCategoriesBySlugVariables,
  options?: Omit<UseQueryOptions<GetBoatsCategoriesBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsCategoriesBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsCategoriesBySlug, TError, TData>({
    queryKey: ['getBoatsCategoriesBySlug', variables],
    queryFn: fetcher<GetBoatsCategoriesBySlug, GetBoatsCategoriesBySlugVariables>(
      client,
      GetBoatsCategoriesBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsCategoriesBySlug.getKey = (variables: GetBoatsCategoriesBySlugVariables) => [
  'getBoatsCategoriesBySlug',
  variables,
];

export const useInfiniteGetBoatsCategoriesBySlug = <TData = InfiniteData<GetBoatsCategoriesBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsCategoriesBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsCategoriesBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsCategoriesBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsCategoriesBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatsCategoriesBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsCategoriesBySlug, GetBoatsCategoriesBySlugVariables>(
            client,
            GetBoatsCategoriesBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsCategoriesBySlug.getKey = (variables: GetBoatsCategoriesBySlugVariables) => [
  'getBoatsCategoriesBySlug.infinite',
  variables,
];

useGetBoatsCategoriesBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetBoatsCategoriesBySlugVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetBoatsCategoriesBySlug, GetBoatsCategoriesBySlugVariables>(
    client,
    GetBoatsCategoriesBySlugDocument,
    variables,
    headers,
  );

export const AllBoatsCategoriesWithLumenIdQueryDocument = `
    query allBoatsCategoriesWithLumenIdQuery {
  boatsCategories(pagination: {limit: 200}, status: PUBLISHED) {
    documentId
    name
    slug
    lumen_ref_id
  }
}
    `;

export const useAllBoatsCategoriesWithLumenIdQuery = <TData = AllBoatsCategoriesWithLumenIdQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: AllBoatsCategoriesWithLumenIdQueryVariables,
  options?: Omit<UseQueryOptions<AllBoatsCategoriesWithLumenIdQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AllBoatsCategoriesWithLumenIdQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<AllBoatsCategoriesWithLumenIdQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['allBoatsCategoriesWithLumenIdQuery']
        : ['allBoatsCategoriesWithLumenIdQuery', variables],
    queryFn: fetcher<AllBoatsCategoriesWithLumenIdQuery, AllBoatsCategoriesWithLumenIdQueryVariables>(
      client,
      AllBoatsCategoriesWithLumenIdQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useAllBoatsCategoriesWithLumenIdQuery.getKey = (variables?: AllBoatsCategoriesWithLumenIdQueryVariables) =>
  variables === undefined ? ['allBoatsCategoriesWithLumenIdQuery'] : ['allBoatsCategoriesWithLumenIdQuery', variables];

export const useInfiniteAllBoatsCategoriesWithLumenIdQuery = <
  TData = InfiniteData<AllBoatsCategoriesWithLumenIdQuery>,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: AllBoatsCategoriesWithLumenIdQueryVariables,
  options: Omit<UseInfiniteQueryOptions<AllBoatsCategoriesWithLumenIdQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<AllBoatsCategoriesWithLumenIdQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<AllBoatsCategoriesWithLumenIdQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['allBoatsCategoriesWithLumenIdQuery.infinite']
            : ['allBoatsCategoriesWithLumenIdQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<AllBoatsCategoriesWithLumenIdQuery, AllBoatsCategoriesWithLumenIdQueryVariables>(
            client,
            AllBoatsCategoriesWithLumenIdQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteAllBoatsCategoriesWithLumenIdQuery.getKey = (variables?: AllBoatsCategoriesWithLumenIdQueryVariables) =>
  variables === undefined
    ? ['allBoatsCategoriesWithLumenIdQuery.infinite']
    : ['allBoatsCategoriesWithLumenIdQuery.infinite', variables];

useAllBoatsCategoriesWithLumenIdQuery.fetcher = (
  client: GraphQLClient,
  variables?: AllBoatsCategoriesWithLumenIdQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<AllBoatsCategoriesWithLumenIdQuery, AllBoatsCategoriesWithLumenIdQueryVariables>(
    client,
    AllBoatsCategoriesWithLumenIdQueryDocument,
    variables,
    headers,
  );

export const AllBoatsActivitiesWithLumenIdQueryDocument = `
    query allBoatsActivitiesWithLumenIdQuery {
  boatsActivities(pagination: {limit: 200}, status: PUBLISHED) {
    documentId
    name
    slug
    lumen_ref_id
  }
}
    `;

export const useAllBoatsActivitiesWithLumenIdQuery = <TData = AllBoatsActivitiesWithLumenIdQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: AllBoatsActivitiesWithLumenIdQueryVariables,
  options?: Omit<UseQueryOptions<AllBoatsActivitiesWithLumenIdQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<AllBoatsActivitiesWithLumenIdQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<AllBoatsActivitiesWithLumenIdQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['allBoatsActivitiesWithLumenIdQuery']
        : ['allBoatsActivitiesWithLumenIdQuery', variables],
    queryFn: fetcher<AllBoatsActivitiesWithLumenIdQuery, AllBoatsActivitiesWithLumenIdQueryVariables>(
      client,
      AllBoatsActivitiesWithLumenIdQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useAllBoatsActivitiesWithLumenIdQuery.getKey = (variables?: AllBoatsActivitiesWithLumenIdQueryVariables) =>
  variables === undefined ? ['allBoatsActivitiesWithLumenIdQuery'] : ['allBoatsActivitiesWithLumenIdQuery', variables];

export const useInfiniteAllBoatsActivitiesWithLumenIdQuery = <
  TData = InfiniteData<AllBoatsActivitiesWithLumenIdQuery>,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: AllBoatsActivitiesWithLumenIdQueryVariables,
  options: Omit<UseInfiniteQueryOptions<AllBoatsActivitiesWithLumenIdQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<AllBoatsActivitiesWithLumenIdQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<AllBoatsActivitiesWithLumenIdQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['allBoatsActivitiesWithLumenIdQuery.infinite']
            : ['allBoatsActivitiesWithLumenIdQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<AllBoatsActivitiesWithLumenIdQuery, AllBoatsActivitiesWithLumenIdQueryVariables>(
            client,
            AllBoatsActivitiesWithLumenIdQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteAllBoatsActivitiesWithLumenIdQuery.getKey = (variables?: AllBoatsActivitiesWithLumenIdQueryVariables) =>
  variables === undefined
    ? ['allBoatsActivitiesWithLumenIdQuery.infinite']
    : ['allBoatsActivitiesWithLumenIdQuery.infinite', variables];

useAllBoatsActivitiesWithLumenIdQuery.fetcher = (
  client: GraphQLClient,
  variables?: AllBoatsActivitiesWithLumenIdQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<AllBoatsActivitiesWithLumenIdQuery, AllBoatsActivitiesWithLumenIdQueryVariables>(
    client,
    AllBoatsActivitiesWithLumenIdQueryDocument,
    variables,
    headers,
  );

export const GetBoatsTypesDocument = `
    query getBoatsTypes($limit: Int = 15) {
  boatsTypes(pagination: {limit: $limit}, status: PUBLISHED) {
    ...BoatsTypeFragment
  }
}
    ${BoatsTypeFragment}`;

export const useGetBoatsTypes = <TData = GetBoatsTypes, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatsTypesVariables,
  options?: Omit<UseQueryOptions<GetBoatsTypes, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsTypes, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsTypes, TError, TData>({
    queryKey: variables === undefined ? ['getBoatsTypes'] : ['getBoatsTypes', variables],
    queryFn: fetcher<GetBoatsTypes, GetBoatsTypesVariables>(client, GetBoatsTypesDocument, variables, headers),
    ...options,
  });
};

useGetBoatsTypes.getKey = (variables?: GetBoatsTypesVariables) =>
  variables === undefined ? ['getBoatsTypes'] : ['getBoatsTypes', variables];

export const useInfiniteGetBoatsTypes = <TData = InfiniteData<GetBoatsTypes>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsTypesVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsTypes, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsTypes, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsTypes, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatsTypes.infinite']
            : ['getBoatsTypes.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsTypes, GetBoatsTypesVariables>(
            client,
            GetBoatsTypesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsTypes.getKey = (variables?: GetBoatsTypesVariables) =>
  variables === undefined ? ['getBoatsTypes.infinite'] : ['getBoatsTypes.infinite', variables];

useGetBoatsTypes.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatsTypesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatsTypes, GetBoatsTypesVariables>(client, GetBoatsTypesDocument, variables, headers);

export const GetAllBoatsTypesIdDocument = `
    query getAllBoatsTypesId {
  boatsTypes(pagination: {limit: 200}) {
    documentId
    name
    slug
  }
}
    `;

export const useGetAllBoatsTypesId = <TData = GetAllBoatsTypesId, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAllBoatsTypesIdVariables,
  options?: Omit<UseQueryOptions<GetAllBoatsTypesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllBoatsTypesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllBoatsTypesId, TError, TData>({
    queryKey: variables === undefined ? ['getAllBoatsTypesId'] : ['getAllBoatsTypesId', variables],
    queryFn: fetcher<GetAllBoatsTypesId, GetAllBoatsTypesIdVariables>(
      client,
      GetAllBoatsTypesIdDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetAllBoatsTypesId.getKey = (variables?: GetAllBoatsTypesIdVariables) =>
  variables === undefined ? ['getAllBoatsTypesId'] : ['getAllBoatsTypesId', variables];

export const useInfiniteGetAllBoatsTypesId = <TData = InfiniteData<GetAllBoatsTypesId>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllBoatsTypesIdVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllBoatsTypesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllBoatsTypesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllBoatsTypesId, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getAllBoatsTypesId.infinite']
            : ['getAllBoatsTypesId.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllBoatsTypesId, GetAllBoatsTypesIdVariables>(
            client,
            GetAllBoatsTypesIdDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllBoatsTypesId.getKey = (variables?: GetAllBoatsTypesIdVariables) =>
  variables === undefined ? ['getAllBoatsTypesId.infinite'] : ['getAllBoatsTypesId.infinite', variables];

useGetAllBoatsTypesId.fetcher = (
  client: GraphQLClient,
  variables?: GetAllBoatsTypesIdVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetAllBoatsTypesId, GetAllBoatsTypesIdVariables>(client, GetAllBoatsTypesIdDocument, variables, headers);

export const GetBoatsTypesBySlugDocument = `
    query getBoatsTypesBySlug($slug: String!) {
  boatsTypes(filters: {slug: {eq: $slug}}) {
    ...BoatsTypeFragment
  }
}
    ${BoatsTypeFragment}`;

export const useGetBoatsTypesBySlug = <TData = GetBoatsTypesBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsTypesBySlugVariables,
  options?: Omit<UseQueryOptions<GetBoatsTypesBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsTypesBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsTypesBySlug, TError, TData>({
    queryKey: ['getBoatsTypesBySlug', variables],
    queryFn: fetcher<GetBoatsTypesBySlug, GetBoatsTypesBySlugVariables>(
      client,
      GetBoatsTypesBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsTypesBySlug.getKey = (variables: GetBoatsTypesBySlugVariables) => ['getBoatsTypesBySlug', variables];

export const useInfiniteGetBoatsTypesBySlug = <TData = InfiniteData<GetBoatsTypesBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsTypesBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsTypesBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsTypesBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsTypesBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatsTypesBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsTypesBySlug, GetBoatsTypesBySlugVariables>(
            client,
            GetBoatsTypesBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsTypesBySlug.getKey = (variables: GetBoatsTypesBySlugVariables) => [
  'getBoatsTypesBySlug.infinite',
  variables,
];

useGetBoatsTypesBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetBoatsTypesBySlugVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetBoatsTypesBySlug, GetBoatsTypesBySlugVariables>(client, GetBoatsTypesBySlugDocument, variables, headers);

export const GetChangelogsDocument = `
    query getChangelogs($code: String!, $page: Int!) {
  changelogs_connection(
    filters: {application: {code: {eq: $code}}}
    pagination: {page: $page, pageSize: 5}
    sort: "date:desc"
    status: PUBLISHED
  ) {
    nodes {
      documentId
      title
      subtitle
      date
      version
      description {
        id
        type
        details
      }
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PaginationFragment}`;

export const useGetChangelogs = <TData = GetChangelogs, TError = unknown>(
  client: GraphQLClient,
  variables: GetChangelogsVariables,
  options?: Omit<UseQueryOptions<GetChangelogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetChangelogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetChangelogs, TError, TData>({
    queryKey: ['getChangelogs', variables],
    queryFn: fetcher<GetChangelogs, GetChangelogsVariables>(client, GetChangelogsDocument, variables, headers),
    ...options,
  });
};

useGetChangelogs.getKey = (variables: GetChangelogsVariables) => ['getChangelogs', variables];

export const useInfiniteGetChangelogs = <TData = InfiniteData<GetChangelogs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetChangelogsVariables,
  options: Omit<UseInfiniteQueryOptions<GetChangelogs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetChangelogs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetChangelogs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getChangelogs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetChangelogs, GetChangelogsVariables>(
            client,
            GetChangelogsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetChangelogs.getKey = (variables: GetChangelogsVariables) => ['getChangelogs.infinite', variables];

useGetChangelogs.fetcher = (
  client: GraphQLClient,
  variables: GetChangelogsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetChangelogs, GetChangelogsVariables>(client, GetChangelogsDocument, variables, headers);

export const GetUserFavoriteBoatsDocument = `
    query getUserFavoriteBoats($userId: String) {
  userFavoriteBoats(filters: {userId: {eq: $userId}}, status: PUBLISHED) {
    documentId
    boats {
      documentId
    }
  }
}
    `;

export const useGetUserFavoriteBoats = <TData = GetUserFavoriteBoats, TError = unknown>(
  client: GraphQLClient,
  variables?: GetUserFavoriteBoatsVariables,
  options?: Omit<UseQueryOptions<GetUserFavoriteBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetUserFavoriteBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetUserFavoriteBoats, TError, TData>({
    queryKey: variables === undefined ? ['getUserFavoriteBoats'] : ['getUserFavoriteBoats', variables],
    queryFn: fetcher<GetUserFavoriteBoats, GetUserFavoriteBoatsVariables>(
      client,
      GetUserFavoriteBoatsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetUserFavoriteBoats.getKey = (variables?: GetUserFavoriteBoatsVariables) =>
  variables === undefined ? ['getUserFavoriteBoats'] : ['getUserFavoriteBoats', variables];

export const useInfiniteGetUserFavoriteBoats = <TData = InfiniteData<GetUserFavoriteBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetUserFavoriteBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetUserFavoriteBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetUserFavoriteBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetUserFavoriteBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getUserFavoriteBoats.infinite']
            : ['getUserFavoriteBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetUserFavoriteBoats, GetUserFavoriteBoatsVariables>(
            client,
            GetUserFavoriteBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetUserFavoriteBoats.getKey = (variables?: GetUserFavoriteBoatsVariables) =>
  variables === undefined ? ['getUserFavoriteBoats.infinite'] : ['getUserFavoriteBoats.infinite', variables];

useGetUserFavoriteBoats.fetcher = (
  client: GraphQLClient,
  variables?: GetUserFavoriteBoatsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetUserFavoriteBoats, GetUserFavoriteBoatsVariables>(
    client,
    GetUserFavoriteBoatsDocument,
    variables,
    headers,
  );

export const GetFeaturesPageSlugsDocument = `
    query getFeaturesPageSlugs($pageSize: Int, $appCode: String!) {
  featuresPages(
    filters: {applications: {code: {eq: $appCode}}}
    pagination: {pageSize: $pageSize}
    status: PUBLISHED
  ) {
    documentId
    slug
  }
}
    `;

export const useGetFeaturesPageSlugs = <TData = GetFeaturesPageSlugs, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturesPageSlugsVariables,
  options?: Omit<UseQueryOptions<GetFeaturesPageSlugs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFeaturesPageSlugs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFeaturesPageSlugs, TError, TData>({
    queryKey: ['getFeaturesPageSlugs', variables],
    queryFn: fetcher<GetFeaturesPageSlugs, GetFeaturesPageSlugsVariables>(
      client,
      GetFeaturesPageSlugsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetFeaturesPageSlugs.getKey = (variables: GetFeaturesPageSlugsVariables) => ['getFeaturesPageSlugs', variables];

export const useInfiniteGetFeaturesPageSlugs = <TData = InfiniteData<GetFeaturesPageSlugs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturesPageSlugsVariables,
  options: Omit<UseInfiniteQueryOptions<GetFeaturesPageSlugs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFeaturesPageSlugs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFeaturesPageSlugs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getFeaturesPageSlugs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFeaturesPageSlugs, GetFeaturesPageSlugsVariables>(
            client,
            GetFeaturesPageSlugsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFeaturesPageSlugs.getKey = (variables: GetFeaturesPageSlugsVariables) => [
  'getFeaturesPageSlugs.infinite',
  variables,
];

useGetFeaturesPageSlugs.fetcher = (
  client: GraphQLClient,
  variables: GetFeaturesPageSlugsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetFeaturesPageSlugs, GetFeaturesPageSlugsVariables>(
    client,
    GetFeaturesPageSlugsDocument,
    variables,
    headers,
  );

export const GetFeaturePageBySlugDocument = `
    query getFeaturePageBySlug($slug: String!) {
  featuresPages(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...FeaturePageFragment
  }
}
    ${FeaturePageFragment}`;

export const useGetFeaturePageBySlug = <TData = GetFeaturePageBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturePageBySlugVariables,
  options?: Omit<UseQueryOptions<GetFeaturePageBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFeaturePageBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFeaturePageBySlug, TError, TData>({
    queryKey: ['getFeaturePageBySlug', variables],
    queryFn: fetcher<GetFeaturePageBySlug, GetFeaturePageBySlugVariables>(
      client,
      GetFeaturePageBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetFeaturePageBySlug.getKey = (variables: GetFeaturePageBySlugVariables) => ['getFeaturePageBySlug', variables];

export const useInfiniteGetFeaturePageBySlug = <TData = InfiniteData<GetFeaturePageBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturePageBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetFeaturePageBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFeaturePageBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFeaturePageBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getFeaturePageBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFeaturePageBySlug, GetFeaturePageBySlugVariables>(
            client,
            GetFeaturePageBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFeaturePageBySlug.getKey = (variables: GetFeaturePageBySlugVariables) => [
  'getFeaturePageBySlug.infinite',
  variables,
];

useGetFeaturePageBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetFeaturePageBySlugVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetFeaturePageBySlug, GetFeaturePageBySlugVariables>(
    client,
    GetFeaturePageBySlugDocument,
    variables,
    headers,
  );

export const GetMenuFeaturedPagesDocument = `
    query getMenuFeaturedPages($limit: Int, $appCode: String!) {
  featuresPages(
    filters: {applications: {code: {eq: $appCode}}}
    pagination: {limit: $limit}
    status: PUBLISHED
  ) {
    documentId
    slug
    title
    description
    image {
      documentId
      url
      alternativeText
      width
      height
    }
    icon {
      id
      name
    }
  }
}
    `;

export const useGetMenuFeaturedPages = <TData = GetMenuFeaturedPages, TError = unknown>(
  client: GraphQLClient,
  variables: GetMenuFeaturedPagesVariables,
  options?: Omit<UseQueryOptions<GetMenuFeaturedPages, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetMenuFeaturedPages, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetMenuFeaturedPages, TError, TData>({
    queryKey: ['getMenuFeaturedPages', variables],
    queryFn: fetcher<GetMenuFeaturedPages, GetMenuFeaturedPagesVariables>(
      client,
      GetMenuFeaturedPagesDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetMenuFeaturedPages.getKey = (variables: GetMenuFeaturedPagesVariables) => ['getMenuFeaturedPages', variables];

export const useInfiniteGetMenuFeaturedPages = <TData = InfiniteData<GetMenuFeaturedPages>, TError = unknown>(
  client: GraphQLClient,
  variables: GetMenuFeaturedPagesVariables,
  options: Omit<UseInfiniteQueryOptions<GetMenuFeaturedPages, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetMenuFeaturedPages, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetMenuFeaturedPages, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getMenuFeaturedPages.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetMenuFeaturedPages, GetMenuFeaturedPagesVariables>(
            client,
            GetMenuFeaturedPagesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetMenuFeaturedPages.getKey = (variables: GetMenuFeaturedPagesVariables) => [
  'getMenuFeaturedPages.infinite',
  variables,
];

useGetMenuFeaturedPages.fetcher = (
  client: GraphQLClient,
  variables: GetMenuFeaturedPagesVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetMenuFeaturedPages, GetMenuFeaturedPagesVariables>(
    client,
    GetMenuFeaturedPagesDocument,
    variables,
    headers,
  );

export const GetBoatsHullTypesDocument = `
    query getBoatsHullTypes($limit: Int = 15) {
  boatsHullTypes(pagination: {limit: $limit}, status: PUBLISHED) {
    ...BoatsHullTypeFragment
  }
}
    ${BoatsHullTypeFragment}`;

export const useGetBoatsHullTypes = <TData = GetBoatsHullTypes, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatsHullTypesVariables,
  options?: Omit<UseQueryOptions<GetBoatsHullTypes, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsHullTypes, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsHullTypes, TError, TData>({
    queryKey: variables === undefined ? ['getBoatsHullTypes'] : ['getBoatsHullTypes', variables],
    queryFn: fetcher<GetBoatsHullTypes, GetBoatsHullTypesVariables>(
      client,
      GetBoatsHullTypesDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsHullTypes.getKey = (variables?: GetBoatsHullTypesVariables) =>
  variables === undefined ? ['getBoatsHullTypes'] : ['getBoatsHullTypes', variables];

export const useInfiniteGetBoatsHullTypes = <TData = InfiniteData<GetBoatsHullTypes>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsHullTypesVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsHullTypes, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsHullTypes, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsHullTypes, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatsHullTypes.infinite']
            : ['getBoatsHullTypes.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsHullTypes, GetBoatsHullTypesVariables>(
            client,
            GetBoatsHullTypesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsHullTypes.getKey = (variables?: GetBoatsHullTypesVariables) =>
  variables === undefined ? ['getBoatsHullTypes.infinite'] : ['getBoatsHullTypes.infinite', variables];

useGetBoatsHullTypes.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatsHullTypesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatsHullTypes, GetBoatsHullTypesVariables>(client, GetBoatsHullTypesDocument, variables, headers);

export const GetAllBoatsHullTypesIdDocument = `
    query getAllBoatsHullTypesId {
  boatsHullTypes(pagination: {limit: 200}, status: PUBLISHED) {
    documentId
    name
    slug
  }
}
    `;

export const useGetAllBoatsHullTypesId = <TData = GetAllBoatsHullTypesId, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAllBoatsHullTypesIdVariables,
  options?: Omit<UseQueryOptions<GetAllBoatsHullTypesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllBoatsHullTypesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllBoatsHullTypesId, TError, TData>({
    queryKey: variables === undefined ? ['getAllBoatsHullTypesId'] : ['getAllBoatsHullTypesId', variables],
    queryFn: fetcher<GetAllBoatsHullTypesId, GetAllBoatsHullTypesIdVariables>(
      client,
      GetAllBoatsHullTypesIdDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetAllBoatsHullTypesId.getKey = (variables?: GetAllBoatsHullTypesIdVariables) =>
  variables === undefined ? ['getAllBoatsHullTypesId'] : ['getAllBoatsHullTypesId', variables];

export const useInfiniteGetAllBoatsHullTypesId = <TData = InfiniteData<GetAllBoatsHullTypesId>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllBoatsHullTypesIdVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllBoatsHullTypesId, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllBoatsHullTypesId, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllBoatsHullTypesId, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getAllBoatsHullTypesId.infinite']
            : ['getAllBoatsHullTypesId.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllBoatsHullTypesId, GetAllBoatsHullTypesIdVariables>(
            client,
            GetAllBoatsHullTypesIdDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllBoatsHullTypesId.getKey = (variables?: GetAllBoatsHullTypesIdVariables) =>
  variables === undefined ? ['getAllBoatsHullTypesId.infinite'] : ['getAllBoatsHullTypesId.infinite', variables];

useGetAllBoatsHullTypesId.fetcher = (
  client: GraphQLClient,
  variables?: GetAllBoatsHullTypesIdVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetAllBoatsHullTypesId, GetAllBoatsHullTypesIdVariables>(
    client,
    GetAllBoatsHullTypesIdDocument,
    variables,
    headers,
  );

export const GetBoatsHullTypesBySlugDocument = `
    query getBoatsHullTypesBySlug($slug: String!) {
  boatsHullTypes(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...BoatsHullTypeFragment
  }
}
    ${BoatsHullTypeFragment}`;

export const useGetBoatsHullTypesBySlug = <TData = GetBoatsHullTypesBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsHullTypesBySlugVariables,
  options?: Omit<UseQueryOptions<GetBoatsHullTypesBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsHullTypesBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsHullTypesBySlug, TError, TData>({
    queryKey: ['getBoatsHullTypesBySlug', variables],
    queryFn: fetcher<GetBoatsHullTypesBySlug, GetBoatsHullTypesBySlugVariables>(
      client,
      GetBoatsHullTypesBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsHullTypesBySlug.getKey = (variables: GetBoatsHullTypesBySlugVariables) => [
  'getBoatsHullTypesBySlug',
  variables,
];

export const useInfiniteGetBoatsHullTypesBySlug = <TData = InfiniteData<GetBoatsHullTypesBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsHullTypesBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsHullTypesBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsHullTypesBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsHullTypesBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatsHullTypesBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsHullTypesBySlug, GetBoatsHullTypesBySlugVariables>(
            client,
            GetBoatsHullTypesBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsHullTypesBySlug.getKey = (variables: GetBoatsHullTypesBySlugVariables) => [
  'getBoatsHullTypesBySlug.infinite',
  variables,
];

useGetBoatsHullTypesBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetBoatsHullTypesBySlugVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetBoatsHullTypesBySlug, GetBoatsHullTypesBySlugVariables>(
    client,
    GetBoatsHullTypesBySlugDocument,
    variables,
    headers,
  );

export const GetTheboatappHomepageDocument = `
    query getTheboatappHomepage {
  theboatappHomepage {
    documentId
    pageCover {
      id
      title
      description
      getStartedLink
      image {
        documentId
        name
        alternativeText
        url
      }
    }
    availableOn {
      id
      title
      coverImage {
        documentId
        name
        alternativeText
        url
      }
      availableonOptions {
        id
        title
        availableonImage {
          documentId
          name
          alternativeText
          url
        }
      }
    }
    imagesGridWithVideo {
      id
      title
      description
      videoUrl
      gridImages {
        documentId
        name
        alternativeText
        url
      }
    }
    featuresCarousel {
      id
      title
      description
    }
    checklistCarousel {
      id
      title
      description
    }
    pricingCards {
      id
      title
      description
    }
    showcase {
      id
      title
      description
      image {
        documentId
        name
        alternativeText
        url
      }
      getStartedLink
    }
    joinUs {
      id
      title
      description
      joinUrl
    }
  }
}
    `;

export const useGetTheboatappHomepage = <TData = GetTheboatappHomepage, TError = unknown>(
  client: GraphQLClient,
  variables?: GetTheboatappHomepageVariables,
  options?: Omit<UseQueryOptions<GetTheboatappHomepage, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTheboatappHomepage, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTheboatappHomepage, TError, TData>({
    queryKey: variables === undefined ? ['getTheboatappHomepage'] : ['getTheboatappHomepage', variables],
    queryFn: fetcher<GetTheboatappHomepage, GetTheboatappHomepageVariables>(
      client,
      GetTheboatappHomepageDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetTheboatappHomepage.getKey = (variables?: GetTheboatappHomepageVariables) =>
  variables === undefined ? ['getTheboatappHomepage'] : ['getTheboatappHomepage', variables];

export const useInfiniteGetTheboatappHomepage = <TData = InfiniteData<GetTheboatappHomepage>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTheboatappHomepageVariables,
  options: Omit<UseInfiniteQueryOptions<GetTheboatappHomepage, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTheboatappHomepage, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTheboatappHomepage, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getTheboatappHomepage.infinite']
            : ['getTheboatappHomepage.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTheboatappHomepage, GetTheboatappHomepageVariables>(
            client,
            GetTheboatappHomepageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTheboatappHomepage.getKey = (variables?: GetTheboatappHomepageVariables) =>
  variables === undefined ? ['getTheboatappHomepage.infinite'] : ['getTheboatappHomepage.infinite', variables];

useGetTheboatappHomepage.fetcher = (
  client: GraphQLClient,
  variables?: GetTheboatappHomepageVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetTheboatappHomepage, GetTheboatappHomepageVariables>(
    client,
    GetTheboatappHomepageDocument,
    variables,
    headers,
  );

export const GetMarinedatacloudHomepageDocument = `
    query getMarinedatacloudHomepage {
  marinedatacloudHomepage {
    documentId
    pageCover {
      id
      title
      description
      appLinks {
        id
        description
        image {
          documentId
          name
          alternativeText
          url
        }
        url
      }
      image {
        documentId
        name
        alternativeText
        url
      }
    }
    ourStory {
      id
      title
      description
      image {
        documentId
        name
        alternativeText
        url
      }
    }
    mission {
      id
      label
      title
      description
      image {
        documentId
        name
        alternativeText
        url
      }
    }
    vision {
      id
      label
      title
      description
      image {
        documentId
        name
        alternativeText
        url
      }
    }
    values {
      id
      title
      description
    }
    workWithUs {
      id
      title
      description
      image {
        documentId
        name
        alternativeText
        url
      }
    }
  }
}
    `;

export const useGetMarinedatacloudHomepage = <TData = GetMarinedatacloudHomepage, TError = unknown>(
  client: GraphQLClient,
  variables?: GetMarinedatacloudHomepageVariables,
  options?: Omit<UseQueryOptions<GetMarinedatacloudHomepage, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetMarinedatacloudHomepage, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetMarinedatacloudHomepage, TError, TData>({
    queryKey: variables === undefined ? ['getMarinedatacloudHomepage'] : ['getMarinedatacloudHomepage', variables],
    queryFn: fetcher<GetMarinedatacloudHomepage, GetMarinedatacloudHomepageVariables>(
      client,
      GetMarinedatacloudHomepageDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetMarinedatacloudHomepage.getKey = (variables?: GetMarinedatacloudHomepageVariables) =>
  variables === undefined ? ['getMarinedatacloudHomepage'] : ['getMarinedatacloudHomepage', variables];

export const useInfiniteGetMarinedatacloudHomepage = <
  TData = InfiniteData<GetMarinedatacloudHomepage>,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetMarinedatacloudHomepageVariables,
  options: Omit<UseInfiniteQueryOptions<GetMarinedatacloudHomepage, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetMarinedatacloudHomepage, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetMarinedatacloudHomepage, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getMarinedatacloudHomepage.infinite']
            : ['getMarinedatacloudHomepage.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetMarinedatacloudHomepage, GetMarinedatacloudHomepageVariables>(
            client,
            GetMarinedatacloudHomepageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetMarinedatacloudHomepage.getKey = (variables?: GetMarinedatacloudHomepageVariables) =>
  variables === undefined
    ? ['getMarinedatacloudHomepage.infinite']
    : ['getMarinedatacloudHomepage.infinite', variables];

useGetMarinedatacloudHomepage.fetcher = (
  client: GraphQLClient,
  variables?: GetMarinedatacloudHomepageVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetMarinedatacloudHomepage, GetMarinedatacloudHomepageVariables>(
    client,
    GetMarinedatacloudHomepageDocument,
    variables,
    headers,
  );

export const GetLegalPageBySlugDocument = `
    query getLegalPageBySlug($slug: String!) {
  legalPages(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...LegalPageFragment
  }
}
    ${LegalPageFragment}`;

export const useGetLegalPageBySlug = <TData = GetLegalPageBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetLegalPageBySlugVariables,
  options?: Omit<UseQueryOptions<GetLegalPageBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetLegalPageBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetLegalPageBySlug, TError, TData>({
    queryKey: ['getLegalPageBySlug', variables],
    queryFn: fetcher<GetLegalPageBySlug, GetLegalPageBySlugVariables>(
      client,
      GetLegalPageBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetLegalPageBySlug.getKey = (variables: GetLegalPageBySlugVariables) => ['getLegalPageBySlug', variables];

export const useInfiniteGetLegalPageBySlug = <TData = InfiniteData<GetLegalPageBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetLegalPageBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetLegalPageBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetLegalPageBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetLegalPageBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getLegalPageBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetLegalPageBySlug, GetLegalPageBySlugVariables>(
            client,
            GetLegalPageBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetLegalPageBySlug.getKey = (variables: GetLegalPageBySlugVariables) => [
  'getLegalPageBySlug.infinite',
  variables,
];

useGetLegalPageBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetLegalPageBySlugVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetLegalPageBySlug, GetLegalPageBySlugVariables>(client, GetLegalPageBySlugDocument, variables, headers);

export const GetLegalPagesSlugsDocument = `
    query getLegalPagesSlugs($pageSize: Int) {
  legalPages(pagination: {pageSize: $pageSize}, status: PUBLISHED) {
    slug
  }
}
    `;

export const useGetLegalPagesSlugs = <TData = GetLegalPagesSlugs, TError = unknown>(
  client: GraphQLClient,
  variables?: GetLegalPagesSlugsVariables,
  options?: Omit<UseQueryOptions<GetLegalPagesSlugs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetLegalPagesSlugs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetLegalPagesSlugs, TError, TData>({
    queryKey: variables === undefined ? ['getLegalPagesSlugs'] : ['getLegalPagesSlugs', variables],
    queryFn: fetcher<GetLegalPagesSlugs, GetLegalPagesSlugsVariables>(
      client,
      GetLegalPagesSlugsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetLegalPagesSlugs.getKey = (variables?: GetLegalPagesSlugsVariables) =>
  variables === undefined ? ['getLegalPagesSlugs'] : ['getLegalPagesSlugs', variables];

export const useInfiniteGetLegalPagesSlugs = <TData = InfiniteData<GetLegalPagesSlugs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetLegalPagesSlugsVariables,
  options: Omit<UseInfiniteQueryOptions<GetLegalPagesSlugs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetLegalPagesSlugs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetLegalPagesSlugs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getLegalPagesSlugs.infinite']
            : ['getLegalPagesSlugs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetLegalPagesSlugs, GetLegalPagesSlugsVariables>(
            client,
            GetLegalPagesSlugsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetLegalPagesSlugs.getKey = (variables?: GetLegalPagesSlugsVariables) =>
  variables === undefined ? ['getLegalPagesSlugs.infinite'] : ['getLegalPagesSlugs.infinite', variables];

useGetLegalPagesSlugs.fetcher = (
  client: GraphQLClient,
  variables?: GetLegalPagesSlugsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetLegalPagesSlugs, GetLegalPagesSlugsVariables>(client, GetLegalPagesSlugsDocument, variables, headers);

export const GetManufacturersDocument = `
    query getManufacturers($limit: Int = 15) {
  manufacturers_connection(
    pagination: {limit: $limit}
    filters: {publicBoatsCount: {gt: 0}}
    status: PUBLISHED
  ) {
    nodes {
      ...FullManufacturerFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${FullManufacturerFragment}
${PaginationFragment}`;

export const useGetManufacturers = <TData = GetManufacturers, TError = unknown>(
  client: GraphQLClient,
  variables?: GetManufacturersVariables,
  options?: Omit<UseQueryOptions<GetManufacturers, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetManufacturers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetManufacturers, TError, TData>({
    queryKey: variables === undefined ? ['getManufacturers'] : ['getManufacturers', variables],
    queryFn: fetcher<GetManufacturers, GetManufacturersVariables>(client, GetManufacturersDocument, variables, headers),
    ...options,
  });
};

useGetManufacturers.getKey = (variables?: GetManufacturersVariables) =>
  variables === undefined ? ['getManufacturers'] : ['getManufacturers', variables];

export const useInfiniteGetManufacturers = <TData = InfiniteData<GetManufacturers>, TError = unknown>(
  client: GraphQLClient,
  variables: GetManufacturersVariables,
  options: Omit<UseInfiniteQueryOptions<GetManufacturers, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetManufacturers, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetManufacturers, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getManufacturers.infinite']
            : ['getManufacturers.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetManufacturers, GetManufacturersVariables>(
            client,
            GetManufacturersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetManufacturers.getKey = (variables?: GetManufacturersVariables) =>
  variables === undefined ? ['getManufacturers.infinite'] : ['getManufacturers.infinite', variables];

useGetManufacturers.fetcher = (
  client: GraphQLClient,
  variables?: GetManufacturersVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetManufacturers, GetManufacturersVariables>(client, GetManufacturersDocument, variables, headers);

export const GetManufacturersBySlugDocument = `
    query getManufacturersBySlug($slug: String!) {
  manufacturers_connection(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    nodes {
      ...FullManufacturerFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${FullManufacturerFragment}
${PaginationFragment}`;

export const useGetManufacturersBySlug = <TData = GetManufacturersBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetManufacturersBySlugVariables,
  options?: Omit<UseQueryOptions<GetManufacturersBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetManufacturersBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetManufacturersBySlug, TError, TData>({
    queryKey: ['getManufacturersBySlug', variables],
    queryFn: fetcher<GetManufacturersBySlug, GetManufacturersBySlugVariables>(
      client,
      GetManufacturersBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetManufacturersBySlug.getKey = (variables: GetManufacturersBySlugVariables) => [
  'getManufacturersBySlug',
  variables,
];

export const useInfiniteGetManufacturersBySlug = <TData = InfiniteData<GetManufacturersBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetManufacturersBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetManufacturersBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetManufacturersBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetManufacturersBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getManufacturersBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetManufacturersBySlug, GetManufacturersBySlugVariables>(
            client,
            GetManufacturersBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetManufacturersBySlug.getKey = (variables: GetManufacturersBySlugVariables) => [
  'getManufacturersBySlug.infinite',
  variables,
];

useGetManufacturersBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetManufacturersBySlugVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetManufacturersBySlug, GetManufacturersBySlugVariables>(
    client,
    GetManufacturersBySlugDocument,
    variables,
    headers,
  );

export const GetAllNewsDocument = `
    query getAllNews($appCode: String!, $pageSize: Int!, $sort: [String] = "publishDate:desc") {
  newsItems_connection(
    filters: {application: {code: {eq: $appCode}}}
    pagination: {pageSize: $pageSize}
    sort: $sort
    status: PUBLISHED
  ) {
    nodes {
      documentId
      title
      slug
      excerpt
      showPublishDate
      publishDate
      featuredImage {
        ...UploadFileEntityFragment
      }
      createdAt
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${UploadFileEntityFragment}
${PaginationFragment}`;

export const useGetAllNews = <TData = GetAllNews, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllNewsVariables,
  options?: Omit<UseQueryOptions<GetAllNews, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllNews, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllNews, TError, TData>({
    queryKey: ['getAllNews', variables],
    queryFn: fetcher<GetAllNews, GetAllNewsVariables>(client, GetAllNewsDocument, variables, headers),
    ...options,
  });
};

useGetAllNews.getKey = (variables: GetAllNewsVariables) => ['getAllNews', variables];

export const useInfiniteGetAllNews = <TData = InfiniteData<GetAllNews>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllNewsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllNews, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllNews, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllNews, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getAllNews.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllNews, GetAllNewsVariables>(
            client,
            GetAllNewsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllNews.getKey = (variables: GetAllNewsVariables) => ['getAllNews.infinite', variables];

useGetAllNews.fetcher = (client: GraphQLClient, variables: GetAllNewsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetAllNews, GetAllNewsVariables>(client, GetAllNewsDocument, variables, headers);

export const GetAllNewsSlugsDocument = `
    query getAllNewsSlugs($appCode: String!, $pageSize: Int!) {
  newsItems_connection(
    filters: {application: {code: {eq: $appCode}}}
    pagination: {pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      slug
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PaginationFragment}`;

export const useGetAllNewsSlugs = <TData = GetAllNewsSlugs, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllNewsSlugsVariables,
  options?: Omit<UseQueryOptions<GetAllNewsSlugs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllNewsSlugs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllNewsSlugs, TError, TData>({
    queryKey: ['getAllNewsSlugs', variables],
    queryFn: fetcher<GetAllNewsSlugs, GetAllNewsSlugsVariables>(client, GetAllNewsSlugsDocument, variables, headers),
    ...options,
  });
};

useGetAllNewsSlugs.getKey = (variables: GetAllNewsSlugsVariables) => ['getAllNewsSlugs', variables];

export const useInfiniteGetAllNewsSlugs = <TData = InfiniteData<GetAllNewsSlugs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllNewsSlugsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllNewsSlugs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllNewsSlugs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllNewsSlugs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getAllNewsSlugs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllNewsSlugs, GetAllNewsSlugsVariables>(
            client,
            GetAllNewsSlugsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllNewsSlugs.getKey = (variables: GetAllNewsSlugsVariables) => ['getAllNewsSlugs.infinite', variables];

useGetAllNewsSlugs.fetcher = (
  client: GraphQLClient,
  variables: GetAllNewsSlugsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetAllNewsSlugs, GetAllNewsSlugsVariables>(client, GetAllNewsSlugsDocument, variables, headers);

export const GetSingleNewsDocument = `
    query getSingleNews($appCode: String!, $newsSlug: String!) {
  newsItems(
    filters: {slug: {eq: $newsSlug}, application: {code: {eq: $appCode}}}
    status: PUBLISHED
  ) {
    documentId
    title
    slug
    excerpt
    showPublishDate
    publishDate
    featuredImage {
      documentId
      url
      alternativeText
    }
    createdAt
    seo {
      id
      metaTitle
      metaDescription
      keywords
      metaImage {
        documentId
        url
        alternativeText
      }
      metaRobots
      metaViewport
      canonicalURL
      structuredData
    }
    content {
      __typename
      ... on ComponentBlocksRichText {
        id
        richtext
      }
    }
  }
}
    `;

export const useGetSingleNews = <TData = GetSingleNews, TError = unknown>(
  client: GraphQLClient,
  variables: GetSingleNewsVariables,
  options?: Omit<UseQueryOptions<GetSingleNews, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetSingleNews, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetSingleNews, TError, TData>({
    queryKey: ['getSingleNews', variables],
    queryFn: fetcher<GetSingleNews, GetSingleNewsVariables>(client, GetSingleNewsDocument, variables, headers),
    ...options,
  });
};

useGetSingleNews.getKey = (variables: GetSingleNewsVariables) => ['getSingleNews', variables];

export const useInfiniteGetSingleNews = <TData = InfiniteData<GetSingleNews>, TError = unknown>(
  client: GraphQLClient,
  variables: GetSingleNewsVariables,
  options: Omit<UseInfiniteQueryOptions<GetSingleNews, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetSingleNews, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetSingleNews, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getSingleNews.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetSingleNews, GetSingleNewsVariables>(
            client,
            GetSingleNewsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetSingleNews.getKey = (variables: GetSingleNewsVariables) => ['getSingleNews.infinite', variables];

useGetSingleNews.fetcher = (
  client: GraphQLClient,
  variables: GetSingleNewsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetSingleNews, GetSingleNewsVariables>(client, GetSingleNewsDocument, variables, headers);

export const GetRecentNewsDocument = `
    query getRecentNews($appCode: String!, $limit: Int = 5, $sort: [String] = "publishDate:desc") {
  newsItems_connection(
    filters: {application: {code: {eq: $appCode}}}
    pagination: {limit: $limit}
    sort: $sort
    status: PUBLISHED
  ) {
    ...NewsCardEntityResponseCollectionFragment
  }
}
    ${NewsCardEntityResponseCollectionFragment}`;

export const useGetRecentNews = <TData = GetRecentNews, TError = unknown>(
  client: GraphQLClient,
  variables: GetRecentNewsVariables,
  options?: Omit<UseQueryOptions<GetRecentNews, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetRecentNews, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetRecentNews, TError, TData>({
    queryKey: ['getRecentNews', variables],
    queryFn: fetcher<GetRecentNews, GetRecentNewsVariables>(client, GetRecentNewsDocument, variables, headers),
    ...options,
  });
};

useGetRecentNews.getKey = (variables: GetRecentNewsVariables) => ['getRecentNews', variables];

export const useInfiniteGetRecentNews = <TData = InfiniteData<GetRecentNews>, TError = unknown>(
  client: GraphQLClient,
  variables: GetRecentNewsVariables,
  options: Omit<UseInfiniteQueryOptions<GetRecentNews, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetRecentNews, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetRecentNews, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getRecentNews.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetRecentNews, GetRecentNewsVariables>(
            client,
            GetRecentNewsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetRecentNews.getKey = (variables: GetRecentNewsVariables) => ['getRecentNews.infinite', variables];

useGetRecentNews.fetcher = (
  client: GraphQLClient,
  variables: GetRecentNewsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetRecentNews, GetRecentNewsVariables>(client, GetRecentNewsDocument, variables, headers);

export const GetNewsCardDocument = `
    query getNewsCard($appCode: String!, $page: Int!, $pageSize: Int!, $sort: [String] = "publishDate:desc") {
  newsItems_connection(
    filters: {application: {code: {eq: $appCode}}}
    pagination: {pageSize: $pageSize, page: $page}
    sort: $sort
    status: PUBLISHED
  ) {
    nodes {
      ...NewsCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${NewsCardFragment}
${PaginationFragment}`;

export const useGetNewsCard = <TData = GetNewsCard, TError = unknown>(
  client: GraphQLClient,
  variables: GetNewsCardVariables,
  options?: Omit<UseQueryOptions<GetNewsCard, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetNewsCard, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetNewsCard, TError, TData>({
    queryKey: ['getNewsCard', variables],
    queryFn: fetcher<GetNewsCard, GetNewsCardVariables>(client, GetNewsCardDocument, variables, headers),
    ...options,
  });
};

useGetNewsCard.getKey = (variables: GetNewsCardVariables) => ['getNewsCard', variables];

export const useInfiniteGetNewsCard = <TData = InfiniteData<GetNewsCard>, TError = unknown>(
  client: GraphQLClient,
  variables: GetNewsCardVariables,
  options: Omit<UseInfiniteQueryOptions<GetNewsCard, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetNewsCard, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetNewsCard, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getNewsCard.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetNewsCard, GetNewsCardVariables>(
            client,
            GetNewsCardDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetNewsCard.getKey = (variables: GetNewsCardVariables) => ['getNewsCard.infinite', variables];

useGetNewsCard.fetcher = (client: GraphQLClient, variables: GetNewsCardVariables, headers?: RequestInit['headers']) =>
  fetcher<GetNewsCard, GetNewsCardVariables>(client, GetNewsCardDocument, variables, headers);

export const GetPricingPlansDocument = `
    query getPricingPlans($pageSize: Int = 6) {
  plans(pagination: {pageSize: $pageSize}, status: PUBLISHED) {
    ...PlanFragment
  }
}
    ${PlanFragment}`;

export const useGetPricingPlans = <TData = GetPricingPlans, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPricingPlansVariables,
  options?: Omit<UseQueryOptions<GetPricingPlans, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPricingPlans, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPricingPlans, TError, TData>({
    queryKey: variables === undefined ? ['getPricingPlans'] : ['getPricingPlans', variables],
    queryFn: fetcher<GetPricingPlans, GetPricingPlansVariables>(client, GetPricingPlansDocument, variables, headers),
    ...options,
  });
};

useGetPricingPlans.getKey = (variables?: GetPricingPlansVariables) =>
  variables === undefined ? ['getPricingPlans'] : ['getPricingPlans', variables];

export const useInfiniteGetPricingPlans = <TData = InfiniteData<GetPricingPlans>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPricingPlansVariables,
  options: Omit<UseInfiniteQueryOptions<GetPricingPlans, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPricingPlans, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPricingPlans, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getPricingPlans.infinite']
            : ['getPricingPlans.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPricingPlans, GetPricingPlansVariables>(
            client,
            GetPricingPlansDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPricingPlans.getKey = (variables?: GetPricingPlansVariables) =>
  variables === undefined ? ['getPricingPlans.infinite'] : ['getPricingPlans.infinite', variables];

useGetPricingPlans.fetcher = (
  client: GraphQLClient,
  variables?: GetPricingPlansVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPricingPlans, GetPricingPlansVariables>(client, GetPricingPlansDocument, variables, headers);

export const GetPostsCategoriesDocument = `
    query getPostsCategories($page: Int, $pageSize: Int!) {
  postCategories(
    pagination: {page: $page, pageSize: $pageSize}
    status: PUBLISHED
  ) {
    ...PostCategoryEntityFragment
  }
}
    ${PostCategoryEntityFragment}`;

export const useGetPostsCategories = <TData = GetPostsCategories, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsCategoriesVariables,
  options?: Omit<UseQueryOptions<GetPostsCategories, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPostsCategories, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPostsCategories, TError, TData>({
    queryKey: ['getPostsCategories', variables],
    queryFn: fetcher<GetPostsCategories, GetPostsCategoriesVariables>(
      client,
      GetPostsCategoriesDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetPostsCategories.getKey = (variables: GetPostsCategoriesVariables) => ['getPostsCategories', variables];

export const useInfiniteGetPostsCategories = <TData = InfiniteData<GetPostsCategories>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsCategoriesVariables,
  options: Omit<UseInfiniteQueryOptions<GetPostsCategories, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPostsCategories, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPostsCategories, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPostsCategories.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPostsCategories, GetPostsCategoriesVariables>(
            client,
            GetPostsCategoriesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPostsCategories.getKey = (variables: GetPostsCategoriesVariables) => [
  'getPostsCategories.infinite',
  variables,
];

useGetPostsCategories.fetcher = (
  client: GraphQLClient,
  variables: GetPostsCategoriesVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPostsCategories, GetPostsCategoriesVariables>(client, GetPostsCategoriesDocument, variables, headers);

export const GetPostsByCategoryDocument = `
    query getPostsByCategory($categorySlug: String!, $page: Int, $appCode: String!, $pageSize: Int!) {
  posts_connection(
    filters: {post_categories: {slug: {eq: $categorySlug}}, application: {code: {eq: $appCode}}}
    pagination: {page: $page, pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      ...PostCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PostCardFragment}
${PaginationFragment}`;

export const useGetPostsByCategory = <TData = GetPostsByCategory, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsByCategoryVariables,
  options?: Omit<UseQueryOptions<GetPostsByCategory, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPostsByCategory, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPostsByCategory, TError, TData>({
    queryKey: ['getPostsByCategory', variables],
    queryFn: fetcher<GetPostsByCategory, GetPostsByCategoryVariables>(
      client,
      GetPostsByCategoryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetPostsByCategory.getKey = (variables: GetPostsByCategoryVariables) => ['getPostsByCategory', variables];

export const useInfiniteGetPostsByCategory = <TData = InfiniteData<GetPostsByCategory>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsByCategoryVariables,
  options: Omit<UseInfiniteQueryOptions<GetPostsByCategory, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPostsByCategory, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPostsByCategory, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPostsByCategory.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPostsByCategory, GetPostsByCategoryVariables>(
            client,
            GetPostsByCategoryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPostsByCategory.getKey = (variables: GetPostsByCategoryVariables) => [
  'getPostsByCategory.infinite',
  variables,
];

useGetPostsByCategory.fetcher = (
  client: GraphQLClient,
  variables: GetPostsByCategoryVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPostsByCategory, GetPostsByCategoryVariables>(client, GetPostsByCategoryDocument, variables, headers);

export const GetCategoryBySlugDocument = `
    query getCategoryBySlug($slug: String!) {
  postCategories(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...CategoryPageFragment
  }
}
    ${CategoryPageFragment}`;

export const useGetCategoryBySlug = <TData = GetCategoryBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetCategoryBySlugVariables,
  options?: Omit<UseQueryOptions<GetCategoryBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCategoryBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCategoryBySlug, TError, TData>({
    queryKey: ['getCategoryBySlug', variables],
    queryFn: fetcher<GetCategoryBySlug, GetCategoryBySlugVariables>(
      client,
      GetCategoryBySlugDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetCategoryBySlug.getKey = (variables: GetCategoryBySlugVariables) => ['getCategoryBySlug', variables];

export const useInfiniteGetCategoryBySlug = <TData = InfiniteData<GetCategoryBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCategoryBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetCategoryBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCategoryBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCategoryBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getCategoryBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCategoryBySlug, GetCategoryBySlugVariables>(
            client,
            GetCategoryBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCategoryBySlug.getKey = (variables: GetCategoryBySlugVariables) => [
  'getCategoryBySlug.infinite',
  variables,
];

useGetCategoryBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetCategoryBySlugVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCategoryBySlug, GetCategoryBySlugVariables>(client, GetCategoryBySlugDocument, variables, headers);

export const GetTagsDocument = `
    query getTags($page: Int, $pageSize: Int!) {
  postTags(pagination: {page: $page, pageSize: $pageSize}, status: PUBLISHED) {
    ...PostTagEntityFragment
  }
}
    ${PostTagEntityFragment}`;

export const useGetTags = <TData = GetTags, TError = unknown>(
  client: GraphQLClient,
  variables: GetTagsVariables,
  options?: Omit<UseQueryOptions<GetTags, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTags, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTags, TError, TData>({
    queryKey: ['getTags', variables],
    queryFn: fetcher<GetTags, GetTagsVariables>(client, GetTagsDocument, variables, headers),
    ...options,
  });
};

useGetTags.getKey = (variables: GetTagsVariables) => ['getTags', variables];

export const useInfiniteGetTags = <TData = InfiniteData<GetTags>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTagsVariables,
  options: Omit<UseInfiniteQueryOptions<GetTags, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTags, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTags, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTags.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTags, GetTagsVariables>(
            client,
            GetTagsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTags.getKey = (variables: GetTagsVariables) => ['getTags.infinite', variables];

useGetTags.fetcher = (client: GraphQLClient, variables: GetTagsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTags, GetTagsVariables>(client, GetTagsDocument, variables, headers);

export const GetPostsByTagDocument = `
    query getPostsByTag($tagSlug: String!, $pageSize: Int = 10, $page: Int = 1, $appCode: String!) {
  posts_connection(
    filters: {post_tags: {slug: {eq: $tagSlug}}, application: {code: {eq: $appCode}}}
    pagination: {page: $page, pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      ...PostCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PostCardFragment}
${PaginationFragment}`;

export const useGetPostsByTag = <TData = GetPostsByTag, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsByTagVariables,
  options?: Omit<UseQueryOptions<GetPostsByTag, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPostsByTag, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPostsByTag, TError, TData>({
    queryKey: ['getPostsByTag', variables],
    queryFn: fetcher<GetPostsByTag, GetPostsByTagVariables>(client, GetPostsByTagDocument, variables, headers),
    ...options,
  });
};

useGetPostsByTag.getKey = (variables: GetPostsByTagVariables) => ['getPostsByTag', variables];

export const useInfiniteGetPostsByTag = <TData = InfiniteData<GetPostsByTag>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsByTagVariables,
  options: Omit<UseInfiniteQueryOptions<GetPostsByTag, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPostsByTag, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPostsByTag, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPostsByTag.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPostsByTag, GetPostsByTagVariables>(
            client,
            GetPostsByTagDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPostsByTag.getKey = (variables: GetPostsByTagVariables) => ['getPostsByTag.infinite', variables];

useGetPostsByTag.fetcher = (
  client: GraphQLClient,
  variables: GetPostsByTagVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPostsByTag, GetPostsByTagVariables>(client, GetPostsByTagDocument, variables, headers);

export const GetTagBySlugDocument = `
    query getTagBySlug($slug: String!) {
  postTags(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...PostTagEntityFragment
  }
}
    ${PostTagEntityFragment}`;

export const useGetTagBySlug = <TData = GetTagBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetTagBySlugVariables,
  options?: Omit<UseQueryOptions<GetTagBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTagBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTagBySlug, TError, TData>({
    queryKey: ['getTagBySlug', variables],
    queryFn: fetcher<GetTagBySlug, GetTagBySlugVariables>(client, GetTagBySlugDocument, variables, headers),
    ...options,
  });
};

useGetTagBySlug.getKey = (variables: GetTagBySlugVariables) => ['getTagBySlug', variables];

export const useInfiniteGetTagBySlug = <TData = InfiniteData<GetTagBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTagBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetTagBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTagBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTagBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTagBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTagBySlug, GetTagBySlugVariables>(
            client,
            GetTagBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTagBySlug.getKey = (variables: GetTagBySlugVariables) => ['getTagBySlug.infinite', variables];

useGetTagBySlug.fetcher = (client: GraphQLClient, variables: GetTagBySlugVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTagBySlug, GetTagBySlugVariables>(client, GetTagBySlugDocument, variables, headers);

export const GetAllPostsSlugDocument = `
    query getAllPostsSlug($appCode: String!, $pageSize: Int!) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}}
    sort: "publishDate:desc"
    pagination: {pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      documentId
      slug
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PaginationFragment}`;

export const useGetAllPostsSlug = <TData = GetAllPostsSlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllPostsSlugVariables,
  options?: Omit<UseQueryOptions<GetAllPostsSlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllPostsSlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllPostsSlug, TError, TData>({
    queryKey: ['getAllPostsSlug', variables],
    queryFn: fetcher<GetAllPostsSlug, GetAllPostsSlugVariables>(client, GetAllPostsSlugDocument, variables, headers),
    ...options,
  });
};

useGetAllPostsSlug.getKey = (variables: GetAllPostsSlugVariables) => ['getAllPostsSlug', variables];

export const useInfiniteGetAllPostsSlug = <TData = InfiniteData<GetAllPostsSlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllPostsSlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllPostsSlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllPostsSlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllPostsSlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getAllPostsSlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllPostsSlug, GetAllPostsSlugVariables>(
            client,
            GetAllPostsSlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllPostsSlug.getKey = (variables: GetAllPostsSlugVariables) => ['getAllPostsSlug.infinite', variables];

useGetAllPostsSlug.fetcher = (
  client: GraphQLClient,
  variables: GetAllPostsSlugVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetAllPostsSlug, GetAllPostsSlugVariables>(client, GetAllPostsSlugDocument, variables, headers);

export const GetAllPostsDocument = `
    query getAllPosts($appCode: String!, $pageSize: Int!) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}}
    sort: "publishDate:desc"
    pagination: {pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      ...PostFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PostFragment}
${PaginationFragment}`;

export const useGetAllPosts = <TData = GetAllPosts, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllPostsVariables,
  options?: Omit<UseQueryOptions<GetAllPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllPosts, TError, TData>({
    queryKey: ['getAllPosts', variables],
    queryFn: fetcher<GetAllPosts, GetAllPostsVariables>(client, GetAllPostsDocument, variables, headers),
    ...options,
  });
};

useGetAllPosts.getKey = (variables: GetAllPostsVariables) => ['getAllPosts', variables];

export const useInfiniteGetAllPosts = <TData = InfiniteData<GetAllPosts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllPostsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllPosts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getAllPosts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllPosts, GetAllPostsVariables>(
            client,
            GetAllPostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllPosts.getKey = (variables: GetAllPostsVariables) => ['getAllPosts.infinite', variables];

useGetAllPosts.fetcher = (client: GraphQLClient, variables: GetAllPostsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetAllPosts, GetAllPostsVariables>(client, GetAllPostsDocument, variables, headers);

export const GetPostsCardDocument = `
    query getPostsCard($appCode: String!, $pageSize: Int = 10, $page: Int = 1) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}}
    sort: "publishDate:desc"
    pagination: {pageSize: $pageSize, page: $page}
    status: PUBLISHED
  ) {
    nodes {
      ...PostCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PostCardFragment}
${PaginationFragment}`;

export const useGetPostsCard = <TData = GetPostsCard, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsCardVariables,
  options?: Omit<UseQueryOptions<GetPostsCard, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPostsCard, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPostsCard, TError, TData>({
    queryKey: ['getPostsCard', variables],
    queryFn: fetcher<GetPostsCard, GetPostsCardVariables>(client, GetPostsCardDocument, variables, headers),
    ...options,
  });
};

useGetPostsCard.getKey = (variables: GetPostsCardVariables) => ['getPostsCard', variables];

export const useInfiniteGetPostsCard = <TData = InfiniteData<GetPostsCard>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsCardVariables,
  options: Omit<UseInfiniteQueryOptions<GetPostsCard, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPostsCard, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPostsCard, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPostsCard.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPostsCard, GetPostsCardVariables>(
            client,
            GetPostsCardDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPostsCard.getKey = (variables: GetPostsCardVariables) => ['getPostsCard.infinite', variables];

useGetPostsCard.fetcher = (client: GraphQLClient, variables: GetPostsCardVariables, headers?: RequestInit['headers']) =>
  fetcher<GetPostsCard, GetPostsCardVariables>(client, GetPostsCardDocument, variables, headers);

export const SearchPostsDocument = `
    query searchPosts($search: String!, $appCode: String!, $page: Int) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}, title: {contains: $search}}
    sort: "publishDate:desc"
    pagination: {page: $page, pageSize: 10}
    status: PUBLISHED
  ) {
    nodes {
      ...PostCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PostCardFragment}
${PaginationFragment}`;

export const useSearchPosts = <TData = SearchPosts, TError = unknown>(
  client: GraphQLClient,
  variables: SearchPostsVariables,
  options?: Omit<UseQueryOptions<SearchPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<SearchPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<SearchPosts, TError, TData>({
    queryKey: ['searchPosts', variables],
    queryFn: fetcher<SearchPosts, SearchPostsVariables>(client, SearchPostsDocument, variables, headers),
    ...options,
  });
};

useSearchPosts.getKey = (variables: SearchPostsVariables) => ['searchPosts', variables];

export const useInfiniteSearchPosts = <TData = InfiniteData<SearchPosts>, TError = unknown>(
  client: GraphQLClient,
  variables: SearchPostsVariables,
  options: Omit<UseInfiniteQueryOptions<SearchPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<SearchPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<SearchPosts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['searchPosts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<SearchPosts, SearchPostsVariables>(
            client,
            SearchPostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteSearchPosts.getKey = (variables: SearchPostsVariables) => ['searchPosts.infinite', variables];

useSearchPosts.fetcher = (client: GraphQLClient, variables: SearchPostsVariables, headers?: RequestInit['headers']) =>
  fetcher<SearchPosts, SearchPostsVariables>(client, SearchPostsDocument, variables, headers);

export const GetPostsDocument = `
    query getPosts($page: Int, $appCode: String!) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}}
    sort: "publishDate:desc"
    pagination: {page: $page, pageSize: 10}
    status: PUBLISHED
  ) {
    nodes {
      ...PostFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${PostFragment}
${PaginationFragment}`;

export const useGetPosts = <TData = GetPosts, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsVariables,
  options?: Omit<UseQueryOptions<GetPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPosts, TError, TData>({
    queryKey: ['getPosts', variables],
    queryFn: fetcher<GetPosts, GetPostsVariables>(client, GetPostsDocument, variables, headers),
    ...options,
  });
};

useGetPosts.getKey = (variables: GetPostsVariables) => ['getPosts', variables];

export const useInfiniteGetPosts = <TData = InfiniteData<GetPosts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostsVariables,
  options: Omit<UseInfiniteQueryOptions<GetPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPosts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPosts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPosts, GetPostsVariables>(
            client,
            GetPostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPosts.getKey = (variables: GetPostsVariables) => ['getPosts.infinite', variables];

useGetPosts.fetcher = (client: GraphQLClient, variables: GetPostsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetPosts, GetPostsVariables>(client, GetPostsDocument, variables, headers);

export const GetRecentPostsDocument = `
    query getRecentPosts($appCode: String!, $pageSize: Int = 10) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}}
    sort: "publishDate:desc"
    pagination: {pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      ...RecentPostFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${RecentPostFragment}
${PaginationFragment}`;

export const useGetRecentPosts = <TData = GetRecentPosts, TError = unknown>(
  client: GraphQLClient,
  variables: GetRecentPostsVariables,
  options?: Omit<UseQueryOptions<GetRecentPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetRecentPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetRecentPosts, TError, TData>({
    queryKey: ['getRecentPosts', variables],
    queryFn: fetcher<GetRecentPosts, GetRecentPostsVariables>(client, GetRecentPostsDocument, variables, headers),
    ...options,
  });
};

useGetRecentPosts.getKey = (variables: GetRecentPostsVariables) => ['getRecentPosts', variables];

export const useInfiniteGetRecentPosts = <TData = InfiniteData<GetRecentPosts>, TError = unknown>(
  client: GraphQLClient,
  variables: GetRecentPostsVariables,
  options: Omit<UseInfiniteQueryOptions<GetRecentPosts, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetRecentPosts, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetRecentPosts, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getRecentPosts.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetRecentPosts, GetRecentPostsVariables>(
            client,
            GetRecentPostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetRecentPosts.getKey = (variables: GetRecentPostsVariables) => ['getRecentPosts.infinite', variables];

useGetRecentPosts.fetcher = (
  client: GraphQLClient,
  variables: GetRecentPostsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetRecentPosts, GetRecentPostsVariables>(client, GetRecentPostsDocument, variables, headers);

export const GetRecentPostsCardsDocument = `
    query getRecentPostsCards($appCode: String!, $pageSize: Int = 10) {
  posts_connection(
    filters: {application: {code: {eq: $appCode}}}
    sort: "publishDate:desc"
    pagination: {pageSize: $pageSize}
    status: PUBLISHED
  ) {
    nodes {
      ...RecentPostCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${RecentPostCardFragment}
${PaginationFragment}`;

export const useGetRecentPostsCards = <TData = GetRecentPostsCards, TError = unknown>(
  client: GraphQLClient,
  variables: GetRecentPostsCardsVariables,
  options?: Omit<UseQueryOptions<GetRecentPostsCards, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetRecentPostsCards, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetRecentPostsCards, TError, TData>({
    queryKey: ['getRecentPostsCards', variables],
    queryFn: fetcher<GetRecentPostsCards, GetRecentPostsCardsVariables>(
      client,
      GetRecentPostsCardsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetRecentPostsCards.getKey = (variables: GetRecentPostsCardsVariables) => ['getRecentPostsCards', variables];

export const useInfiniteGetRecentPostsCards = <TData = InfiniteData<GetRecentPostsCards>, TError = unknown>(
  client: GraphQLClient,
  variables: GetRecentPostsCardsVariables,
  options: Omit<UseInfiniteQueryOptions<GetRecentPostsCards, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetRecentPostsCards, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetRecentPostsCards, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getRecentPostsCards.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetRecentPostsCards, GetRecentPostsCardsVariables>(
            client,
            GetRecentPostsCardsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetRecentPostsCards.getKey = (variables: GetRecentPostsCardsVariables) => [
  'getRecentPostsCards.infinite',
  variables,
];

useGetRecentPostsCards.fetcher = (
  client: GraphQLClient,
  variables: GetRecentPostsCardsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetRecentPostsCards, GetRecentPostsCardsVariables>(client, GetRecentPostsCardsDocument, variables, headers);

export const GetPostBySlugDocument = `
    query getPostBySlug($appCode: String!, $slug: String!) {
  posts(
    filters: {slug: {eq: $slug}, application: {code: {eq: $appCode}}}
    status: PUBLISHED
  ) {
    ...PostFragment
  }
}
    ${PostFragment}`;

export const useGetPostBySlug = <TData = GetPostBySlug, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostBySlugVariables,
  options?: Omit<UseQueryOptions<GetPostBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPostBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPostBySlug, TError, TData>({
    queryKey: ['getPostBySlug', variables],
    queryFn: fetcher<GetPostBySlug, GetPostBySlugVariables>(client, GetPostBySlugDocument, variables, headers),
    ...options,
  });
};

useGetPostBySlug.getKey = (variables: GetPostBySlugVariables) => ['getPostBySlug', variables];

export const useInfiniteGetPostBySlug = <TData = InfiniteData<GetPostBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPostBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetPostBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPostBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPostBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getPostBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPostBySlug, GetPostBySlugVariables>(
            client,
            GetPostBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPostBySlug.getKey = (variables: GetPostBySlugVariables) => ['getPostBySlug.infinite', variables];

useGetPostBySlug.fetcher = (
  client: GraphQLClient,
  variables: GetPostBySlugVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPostBySlug, GetPostBySlugVariables>(client, GetPostBySlugDocument, variables, headers);

export const GetPricingPageDocument = `
    query getPricingPage($publicationStatus: PublicationStatus = PUBLISHED) {
  pricingPage(status: $publicationStatus) {
    ...PricingPageFragment
    features(pagination: {pageSize: 100}) {
      documentId
      title
      description
      badge
      order
      icon {
        name
      }
      group
      link
      subGroup
      showOnCard
      showOnCarousel
      carouselDescription
      availableOn {
        id
        plan {
          documentId
          title
          description
          price {
            amount
            currency {
              documentId
              iso_code
              symbol
            }
          }
          recurrence
          icon {
            name
          }
        }
        availabilityTitle
        availabilitySubtitle
        cardTitle
      }
    }
  }
}
    ${PricingPageFragment}`;

export const useGetPricingPage = <TData = GetPricingPage, TError = unknown>(
  client: GraphQLClient,
  variables?: GetPricingPageVariables,
  options?: Omit<UseQueryOptions<GetPricingPage, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPricingPage, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetPricingPage, TError, TData>({
    queryKey: variables === undefined ? ['getPricingPage'] : ['getPricingPage', variables],
    queryFn: fetcher<GetPricingPage, GetPricingPageVariables>(client, GetPricingPageDocument, variables, headers),
    ...options,
  });
};

useGetPricingPage.getKey = (variables?: GetPricingPageVariables) =>
  variables === undefined ? ['getPricingPage'] : ['getPricingPage', variables];

export const useInfiniteGetPricingPage = <TData = InfiniteData<GetPricingPage>, TError = unknown>(
  client: GraphQLClient,
  variables: GetPricingPageVariables,
  options: Omit<UseInfiniteQueryOptions<GetPricingPage, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetPricingPage, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetPricingPage, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getPricingPage.infinite']
            : ['getPricingPage.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetPricingPage, GetPricingPageVariables>(
            client,
            GetPricingPageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetPricingPage.getKey = (variables?: GetPricingPageVariables) =>
  variables === undefined ? ['getPricingPage.infinite'] : ['getPricingPage.infinite', variables];

useGetPricingPage.fetcher = (
  client: GraphQLClient,
  variables?: GetPricingPageVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetPricingPage, GetPricingPageVariables>(client, GetPricingPageDocument, variables, headers);

export const GetManufacturerBoatsDocument = `
    query getManufacturerBoats($manufacturerId: ID!, $page: Int = 1, $pageSize: Int = 15, $sort: [String] = "createdAt:asc") {
  boats_connection(
    sort: $sort
    pagination: {page: $page, pageSize: $pageSize}
    filters: {manufacturer: {documentId: {eq: $manufacturerId}}}
    status: PUBLISHED
  ) {
    nodes {
      ...BoatCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${BoatCardFragment}
${PaginationFragment}`;

export const useGetManufacturerBoats = <TData = GetManufacturerBoats, TError = unknown>(
  client: GraphQLClient,
  variables: GetManufacturerBoatsVariables,
  options?: Omit<UseQueryOptions<GetManufacturerBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetManufacturerBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetManufacturerBoats, TError, TData>({
    queryKey: ['getManufacturerBoats', variables],
    queryFn: fetcher<GetManufacturerBoats, GetManufacturerBoatsVariables>(
      client,
      GetManufacturerBoatsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetManufacturerBoats.getKey = (variables: GetManufacturerBoatsVariables) => ['getManufacturerBoats', variables];

export const useInfiniteGetManufacturerBoats = <TData = InfiniteData<GetManufacturerBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetManufacturerBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetManufacturerBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetManufacturerBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetManufacturerBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getManufacturerBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetManufacturerBoats, GetManufacturerBoatsVariables>(
            client,
            GetManufacturerBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetManufacturerBoats.getKey = (variables: GetManufacturerBoatsVariables) => [
  'getManufacturerBoats.infinite',
  variables,
];

useGetManufacturerBoats.fetcher = (
  client: GraphQLClient,
  variables: GetManufacturerBoatsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetManufacturerBoats, GetManufacturerBoatsVariables>(
    client,
    GetManufacturerBoatsDocument,
    variables,
    headers,
  );

export const GetCategoryBoatsDocument = `
    query getCategoryBoats($categoryId: ID!, $page: Int = 1, $pageSize: Int = 15, $sort: [String] = "createdAt:asc") {
  boats_connection(
    sort: $sort
    pagination: {page: $page, pageSize: $pageSize}
    filters: {categories: {documentId: {eq: $categoryId}}}
    status: PUBLISHED
  ) {
    nodes {
      ...BoatCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${BoatCardFragment}
${PaginationFragment}`;

export const useGetCategoryBoats = <TData = GetCategoryBoats, TError = unknown>(
  client: GraphQLClient,
  variables: GetCategoryBoatsVariables,
  options?: Omit<UseQueryOptions<GetCategoryBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetCategoryBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetCategoryBoats, TError, TData>({
    queryKey: ['getCategoryBoats', variables],
    queryFn: fetcher<GetCategoryBoats, GetCategoryBoatsVariables>(client, GetCategoryBoatsDocument, variables, headers),
    ...options,
  });
};

useGetCategoryBoats.getKey = (variables: GetCategoryBoatsVariables) => ['getCategoryBoats', variables];

export const useInfiniteGetCategoryBoats = <TData = InfiniteData<GetCategoryBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetCategoryBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetCategoryBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetCategoryBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetCategoryBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getCategoryBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetCategoryBoats, GetCategoryBoatsVariables>(
            client,
            GetCategoryBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetCategoryBoats.getKey = (variables: GetCategoryBoatsVariables) => ['getCategoryBoats.infinite', variables];

useGetCategoryBoats.fetcher = (
  client: GraphQLClient,
  variables: GetCategoryBoatsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetCategoryBoats, GetCategoryBoatsVariables>(client, GetCategoryBoatsDocument, variables, headers);

export const GetActivityBoatsDocument = `
    query getActivityBoats($activityId: ID!, $page: Int = 1, $pageSize: Int = 15, $sort: [String] = "createdAt:asc") {
  boats_connection(
    sort: $sort
    pagination: {page: $page, pageSize: $pageSize}
    filters: {activities: {documentId: {eq: $activityId}}}
    status: PUBLISHED
  ) {
    nodes {
      ...BoatCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${BoatCardFragment}
${PaginationFragment}`;

export const useGetActivityBoats = <TData = GetActivityBoats, TError = unknown>(
  client: GraphQLClient,
  variables: GetActivityBoatsVariables,
  options?: Omit<UseQueryOptions<GetActivityBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetActivityBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetActivityBoats, TError, TData>({
    queryKey: ['getActivityBoats', variables],
    queryFn: fetcher<GetActivityBoats, GetActivityBoatsVariables>(client, GetActivityBoatsDocument, variables, headers),
    ...options,
  });
};

useGetActivityBoats.getKey = (variables: GetActivityBoatsVariables) => ['getActivityBoats', variables];

export const useInfiniteGetActivityBoats = <TData = InfiniteData<GetActivityBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetActivityBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetActivityBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetActivityBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetActivityBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getActivityBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetActivityBoats, GetActivityBoatsVariables>(
            client,
            GetActivityBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetActivityBoats.getKey = (variables: GetActivityBoatsVariables) => ['getActivityBoats.infinite', variables];

useGetActivityBoats.fetcher = (
  client: GraphQLClient,
  variables: GetActivityBoatsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetActivityBoats, GetActivityBoatsVariables>(client, GetActivityBoatsDocument, variables, headers);

export const GetTypeBoatsDocument = `
    query getTypeBoats($typeId: ID!, $page: Int = 1, $pageSize: Int = 15, $sort: [String] = "createdAt:asc") {
  boats_connection(
    sort: $sort
    pagination: {page: $page, pageSize: $pageSize}
    filters: {type: {documentId: {eq: $typeId}}}
    status: PUBLISHED
  ) {
    nodes {
      ...BoatCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${BoatCardFragment}
${PaginationFragment}`;

export const useGetTypeBoats = <TData = GetTypeBoats, TError = unknown>(
  client: GraphQLClient,
  variables: GetTypeBoatsVariables,
  options?: Omit<UseQueryOptions<GetTypeBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTypeBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetTypeBoats, TError, TData>({
    queryKey: ['getTypeBoats', variables],
    queryFn: fetcher<GetTypeBoats, GetTypeBoatsVariables>(client, GetTypeBoatsDocument, variables, headers),
    ...options,
  });
};

useGetTypeBoats.getKey = (variables: GetTypeBoatsVariables) => ['getTypeBoats', variables];

export const useInfiniteGetTypeBoats = <TData = InfiniteData<GetTypeBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetTypeBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetTypeBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetTypeBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetTypeBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getTypeBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetTypeBoats, GetTypeBoatsVariables>(
            client,
            GetTypeBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetTypeBoats.getKey = (variables: GetTypeBoatsVariables) => ['getTypeBoats.infinite', variables];

useGetTypeBoats.fetcher = (client: GraphQLClient, variables: GetTypeBoatsVariables, headers?: RequestInit['headers']) =>
  fetcher<GetTypeBoats, GetTypeBoatsVariables>(client, GetTypeBoatsDocument, variables, headers);

export const GetHullTypeBoatsDocument = `
    query getHullTypeBoats($hullTypeId: ID!, $page: Int = 1, $pageSize: Int = 15, $sort: [String] = "createdAt:asc") {
  boats_connection(
    sort: $sort
    pagination: {page: $page, pageSize: $pageSize}
    filters: {hull_type: {documentId: {eq: $hullTypeId}}}
    status: PUBLISHED
  ) {
    nodes {
      ...BoatCardFragment
    }
    pageInfo {
      ...PaginationFragment
    }
  }
}
    ${BoatCardFragment}
${PaginationFragment}`;

export const useGetHullTypeBoats = <TData = GetHullTypeBoats, TError = unknown>(
  client: GraphQLClient,
  variables: GetHullTypeBoatsVariables,
  options?: Omit<UseQueryOptions<GetHullTypeBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetHullTypeBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetHullTypeBoats, TError, TData>({
    queryKey: ['getHullTypeBoats', variables],
    queryFn: fetcher<GetHullTypeBoats, GetHullTypeBoatsVariables>(client, GetHullTypeBoatsDocument, variables, headers),
    ...options,
  });
};

useGetHullTypeBoats.getKey = (variables: GetHullTypeBoatsVariables) => ['getHullTypeBoats', variables];

export const useInfiniteGetHullTypeBoats = <TData = InfiniteData<GetHullTypeBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetHullTypeBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetHullTypeBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetHullTypeBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetHullTypeBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getHullTypeBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetHullTypeBoats, GetHullTypeBoatsVariables>(
            client,
            GetHullTypeBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetHullTypeBoats.getKey = (variables: GetHullTypeBoatsVariables) => ['getHullTypeBoats.infinite', variables];

useGetHullTypeBoats.fetcher = (
  client: GraphQLClient,
  variables: GetHullTypeBoatsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetHullTypeBoats, GetHullTypeBoatsVariables>(client, GetHullTypeBoatsDocument, variables, headers);

export const GetFeaturedBoatsDocument = `
    query getFeaturedBoats($pageSize: Int = 15) {
  boats(
    pagination: {pageSize: $pageSize}
    filters: {is_featured: {eq: true}}
    status: PUBLISHED
  ) {
    ...BoatCardFragment
  }
}
    ${BoatCardFragment}`;

export const useGetFeaturedBoats = <TData = GetFeaturedBoats, TError = unknown>(
  client: GraphQLClient,
  variables?: GetFeaturedBoatsVariables,
  options?: Omit<UseQueryOptions<GetFeaturedBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetFeaturedBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetFeaturedBoats, TError, TData>({
    queryKey: variables === undefined ? ['getFeaturedBoats'] : ['getFeaturedBoats', variables],
    queryFn: fetcher<GetFeaturedBoats, GetFeaturedBoatsVariables>(client, GetFeaturedBoatsDocument, variables, headers),
    ...options,
  });
};

useGetFeaturedBoats.getKey = (variables?: GetFeaturedBoatsVariables) =>
  variables === undefined ? ['getFeaturedBoats'] : ['getFeaturedBoats', variables];

export const useInfiniteGetFeaturedBoats = <TData = InfiniteData<GetFeaturedBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetFeaturedBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetFeaturedBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetFeaturedBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetFeaturedBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getFeaturedBoats.infinite']
            : ['getFeaturedBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetFeaturedBoats, GetFeaturedBoatsVariables>(
            client,
            GetFeaturedBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetFeaturedBoats.getKey = (variables?: GetFeaturedBoatsVariables) =>
  variables === undefined ? ['getFeaturedBoats.infinite'] : ['getFeaturedBoats.infinite', variables];

useGetFeaturedBoats.fetcher = (
  client: GraphQLClient,
  variables?: GetFeaturedBoatsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetFeaturedBoats, GetFeaturedBoatsVariables>(client, GetFeaturedBoatsDocument, variables, headers);

export const GetBoatBySlugDocument = `
    query getBoatBySlug($slug: String) {
  boats(filters: {slug: {eq: $slug}}, status: PUBLISHED) {
    ...FullBoatFragment
  }
}
    ${FullBoatFragment}`;

export const useGetBoatBySlug = <TData = GetBoatBySlug, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatBySlugVariables,
  options?: Omit<UseQueryOptions<GetBoatBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatBySlug, TError, TData>({
    queryKey: variables === undefined ? ['getBoatBySlug'] : ['getBoatBySlug', variables],
    queryFn: fetcher<GetBoatBySlug, GetBoatBySlugVariables>(client, GetBoatBySlugDocument, variables, headers),
    ...options,
  });
};

useGetBoatBySlug.getKey = (variables?: GetBoatBySlugVariables) =>
  variables === undefined ? ['getBoatBySlug'] : ['getBoatBySlug', variables];

export const useInfiniteGetBoatBySlug = <TData = InfiniteData<GetBoatBySlug>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatBySlugVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatBySlug, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatBySlug, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatBySlug, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatBySlug.infinite']
            : ['getBoatBySlug.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatBySlug, GetBoatBySlugVariables>(
            client,
            GetBoatBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatBySlug.getKey = (variables?: GetBoatBySlugVariables) =>
  variables === undefined ? ['getBoatBySlug.infinite'] : ['getBoatBySlug.infinite', variables];

useGetBoatBySlug.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatBySlugVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatBySlug, GetBoatBySlugVariables>(client, GetBoatBySlugDocument, variables, headers);

export const GetBoatByIdDocument = `
    query getBoatByID($documentId: ID!) {
  boat(documentId: $documentId) {
    ...FullBoatFragment
  }
}
    ${FullBoatFragment}`;

export const useGetBoatById = <TData = GetBoatById, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatByIdVariables,
  options?: Omit<UseQueryOptions<GetBoatById, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatById, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatById, TError, TData>({
    queryKey: ['getBoatByID', variables],
    queryFn: fetcher<GetBoatById, GetBoatByIdVariables>(client, GetBoatByIdDocument, variables, headers),
    ...options,
  });
};

useGetBoatById.getKey = (variables: GetBoatByIdVariables) => ['getBoatByID', variables];

export const useInfiniteGetBoatById = <TData = InfiniteData<GetBoatById>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatByIdVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatById, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatById, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatById, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey: optionsQueryKey ?? ['getBoatByID.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatById, GetBoatByIdVariables>(
            client,
            GetBoatByIdDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatById.getKey = (variables: GetBoatByIdVariables) => ['getBoatByID.infinite', variables];

useGetBoatById.fetcher = (client: GraphQLClient, variables: GetBoatByIdVariables, headers?: RequestInit['headers']) =>
  fetcher<GetBoatById, GetBoatByIdVariables>(client, GetBoatByIdDocument, variables, headers);

export const GetBoatsListByIDsDocument = `
    query getBoatsListByIDs($idFilters: [BoatFiltersInput]) {
  boats(filters: {or: $idFilters}, status: PUBLISHED) {
    ...FullBoatFragment
  }
}
    ${FullBoatFragment}`;

export const useGetBoatsListByIDs = <TData = GetBoatsListByIDs, TError = unknown>(
  client: GraphQLClient,
  variables?: GetBoatsListByIDsVariables,
  options?: Omit<UseQueryOptions<GetBoatsListByIDs, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetBoatsListByIDs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetBoatsListByIDs, TError, TData>({
    queryKey: variables === undefined ? ['getBoatsListByIDs'] : ['getBoatsListByIDs', variables],
    queryFn: fetcher<GetBoatsListByIDs, GetBoatsListByIDsVariables>(
      client,
      GetBoatsListByIDsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetBoatsListByIDs.getKey = (variables?: GetBoatsListByIDsVariables) =>
  variables === undefined ? ['getBoatsListByIDs'] : ['getBoatsListByIDs', variables];

export const useInfiniteGetBoatsListByIDs = <TData = InfiniteData<GetBoatsListByIDs>, TError = unknown>(
  client: GraphQLClient,
  variables: GetBoatsListByIDsVariables,
  options: Omit<UseInfiniteQueryOptions<GetBoatsListByIDs, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetBoatsListByIDs, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetBoatsListByIDs, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getBoatsListByIDs.infinite']
            : ['getBoatsListByIDs.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetBoatsListByIDs, GetBoatsListByIDsVariables>(
            client,
            GetBoatsListByIDsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetBoatsListByIDs.getKey = (variables?: GetBoatsListByIDsVariables) =>
  variables === undefined ? ['getBoatsListByIDs.infinite'] : ['getBoatsListByIDs.infinite', variables];

useGetBoatsListByIDs.fetcher = (
  client: GraphQLClient,
  variables?: GetBoatsListByIDsVariables,
  headers?: RequestInit['headers'],
) => fetcher<GetBoatsListByIDs, GetBoatsListByIDsVariables>(client, GetBoatsListByIDsDocument, variables, headers);

export const GetAllSlugsPublicBoatsDocument = `
    query getAllSlugsPublicBoats($page: Int, $pageSize: Int) {
  boats(pagination: {page: $page, pageSize: $pageSize}, status: PUBLISHED) {
    documentId
    slug
  }
}
    `;

export const useGetAllSlugsPublicBoats = <TData = GetAllSlugsPublicBoats, TError = unknown>(
  client: GraphQLClient,
  variables?: GetAllSlugsPublicBoatsVariables,
  options?: Omit<UseQueryOptions<GetAllSlugsPublicBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetAllSlugsPublicBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<GetAllSlugsPublicBoats, TError, TData>({
    queryKey: variables === undefined ? ['getAllSlugsPublicBoats'] : ['getAllSlugsPublicBoats', variables],
    queryFn: fetcher<GetAllSlugsPublicBoats, GetAllSlugsPublicBoatsVariables>(
      client,
      GetAllSlugsPublicBoatsDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useGetAllSlugsPublicBoats.getKey = (variables?: GetAllSlugsPublicBoatsVariables) =>
  variables === undefined ? ['getAllSlugsPublicBoats'] : ['getAllSlugsPublicBoats', variables];

export const useInfiniteGetAllSlugsPublicBoats = <TData = InfiniteData<GetAllSlugsPublicBoats>, TError = unknown>(
  client: GraphQLClient,
  variables: GetAllSlugsPublicBoatsVariables,
  options: Omit<UseInfiniteQueryOptions<GetAllSlugsPublicBoats, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<GetAllSlugsPublicBoats, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<GetAllSlugsPublicBoats, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['getAllSlugsPublicBoats.infinite']
            : ['getAllSlugsPublicBoats.infinite', variables],
        queryFn: (metaData) =>
          fetcher<GetAllSlugsPublicBoats, GetAllSlugsPublicBoatsVariables>(
            client,
            GetAllSlugsPublicBoatsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteGetAllSlugsPublicBoats.getKey = (variables?: GetAllSlugsPublicBoatsVariables) =>
  variables === undefined ? ['getAllSlugsPublicBoats.infinite'] : ['getAllSlugsPublicBoats.infinite', variables];

useGetAllSlugsPublicBoats.fetcher = (
  client: GraphQLClient,
  variables?: GetAllSlugsPublicBoatsVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<GetAllSlugsPublicBoats, GetAllSlugsPublicBoatsVariables>(
    client,
    GetAllSlugsPublicBoatsDocument,
    variables,
    headers,
  );

export const MasterBoatsCardsQueryDocument = `
    query masterBoatsCardsQuery($filters: BoatFiltersInput, $page: Int, $pageSize: Int) {
  boats_connection(
    filters: $filters
    pagination: {page: $page, pageSize: $pageSize}
    status: PUBLISHED
  ) {
    ...BoatCardEntityResponseCollectionFragment
  }
}
    ${BoatCardEntityResponseCollectionFragment}`;

export const useMasterBoatsCardsQuery = <TData = MasterBoatsCardsQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: MasterBoatsCardsQueryVariables,
  options?: Omit<UseQueryOptions<MasterBoatsCardsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<MasterBoatsCardsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useQuery<MasterBoatsCardsQuery, TError, TData>({
    queryKey: variables === undefined ? ['masterBoatsCardsQuery'] : ['masterBoatsCardsQuery', variables],
    queryFn: fetcher<MasterBoatsCardsQuery, MasterBoatsCardsQueryVariables>(
      client,
      MasterBoatsCardsQueryDocument,
      variables,
      headers,
    ),
    ...options,
  });
};

useMasterBoatsCardsQuery.getKey = (variables?: MasterBoatsCardsQueryVariables) =>
  variables === undefined ? ['masterBoatsCardsQuery'] : ['masterBoatsCardsQuery', variables];

export const useInfiniteMasterBoatsCardsQuery = <TData = InfiniteData<MasterBoatsCardsQuery>, TError = unknown>(
  client: GraphQLClient,
  variables: MasterBoatsCardsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<MasterBoatsCardsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<MasterBoatsCardsQuery, TError, TData>['queryKey'];
  },
  headers?: RequestInit['headers'],
) => {
  return useInfiniteQuery<MasterBoatsCardsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['masterBoatsCardsQuery.infinite']
            : ['masterBoatsCardsQuery.infinite', variables],
        queryFn: (metaData) =>
          fetcher<MasterBoatsCardsQuery, MasterBoatsCardsQueryVariables>(
            client,
            MasterBoatsCardsQueryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
            headers,
          )(),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteMasterBoatsCardsQuery.getKey = (variables?: MasterBoatsCardsQueryVariables) =>
  variables === undefined ? ['masterBoatsCardsQuery.infinite'] : ['masterBoatsCardsQuery.infinite', variables];

useMasterBoatsCardsQuery.fetcher = (
  client: GraphQLClient,
  variables?: MasterBoatsCardsQueryVariables,
  headers?: RequestInit['headers'],
) =>
  fetcher<MasterBoatsCardsQuery, MasterBoatsCardsQueryVariables>(
    client,
    MasterBoatsCardsQueryDocument,
    variables,
    headers,
  );
